import React, { useRef, useEffect, useState } from 'react';
import { replace, useNavigate, useSearchParams } from 'react-router-dom';
import './listingPage.css';
import '../homePage/MainBannerComponent/MainBannerComponent.css';
import DatePicker from 'react-datepicker';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from 'react-modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlaneDeparture } from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';
Modal.setAppElement('#root');

const popularCities = [
  { iata_code: "DEL", name: "Indira Gandhi International Airport", municipality: "New Delhi", countryName: "India" },
  { iata_code: "BOM", name: "Chhatrapati Shivaji International Airport", municipality: "Mumbai", countryName: "India" },
  { iata_code: "DXB", name: "Dubai International Airport", municipality: "Dubai", countryName: "United Arab Emirates" },
  { iata_code: "NBO", name: "Jomo Kenyatta International Airport", municipality: "Nairobi", countryName: "Kenya" },
  { iata_code: "LHR", name: "Heathrow Airport", municipality: "London", countryName: "United Kingdom" },
  { iata_code: "SIN", name: "Singapore Changi Airport", municipality: "Singapore", countryName: "Singapore" },
  { iata_code: "JFK", name: "John F. Kennedy International Airport", municipality: "New York", countryName: "United States" },
  { iata_code: "HKG", name: "Hong Kong International Airport", municipality: "Hong Kong", countryName: "Hong Kong" },
  { iata_code: "LAX", name: "Los Angeles International Airport", municipality: "Los Angeles", countryName: "United States" },
  { iata_code: "CDG", name: "Charles de Gaulle Airport", municipality: "Paris", countryName: "France" },
];

  const baseUrl = process.env.REACT_APP_API_BASE_URL;



const ListingPageComponent = ({ }) => {

  const dropdownRef = useRef(null);
  const datePickerRef = useRef(null);
  const [previousFromValue, setPreviousFromValue] = useState("");
  const [previousFrom2Value, setPreviousFrom2Value] = useState("");
  const [previousFrom3Value, setPreviousFrom3Value] = useState("");
  const [previousToValue, setPreviousToValue] = useState("");
  const [previousTo2Value, setPreviousTo2Value] = useState("");
  const [previousTo3Value, setPreviousTo3Value] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const [searchQueryFrom1, setSearchQueryFrom1] = useState("");
  const [searchQueryFrom2, setSearchQueryFrom2] = useState("");
  const [searchQueryFrom3, setSearchQueryFrom3] = useState("");
  const [searchQueryTo1, setSearchQueryTo1] = useState("");
  const [searchQueryTo2, setSearchQueryTo2] = useState("");
  const [searchQueryTo3, setSearchQueryTo3] = useState("");
  const [searchID, setSearchID] = useState("");

  const [loading2, setLoading2] = useState(true);


  const inputRefs = {
    from: useRef(null),
    to: useRef(null),
    from2: useRef(null),
    to2: useRef(null),
    from3: useRef(null),
    to3: useRef(null),
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !Object.values(inputRefs).some(ref => ref.current && ref.current.contains(event.target))
      ) {
        setShowDropdown(false);
        setShowDestinationDropdown(false);
        setShowFrom2Dropdown(false);
        setShowTo2Dropdown(false);
        setShowFrom3Dropdown(false);
        setShowTo3Dropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleOptionSelect = (option, type) => {

    const iata = option.iata_code || option.AirportCode;
    const name = option.name || option.AirportName;
    const city = option.municipality || option.City;

    switch (type) {

        case 'from':
            setDeparture(`${iata}, ${name}, ${city}`);
            setDepartureIataCode(iata);
            setSearchQueryFrom1("");
            setShowDropdown(false);
            break;

        case 'to':
            setDestination(`${iata}, ${name}, ${city}`);
            setDestinationIataCode(iata);
            setSearchQueryTo1("");
            setShowDestinationDropdown(false);
            break;

        case 'from2':
            setFrom2(`${iata}, ${name}, ${city}`);
            setFrom2IataCode(iata);
            setSearchQueryFrom2("");
            setShowFrom2Dropdown(false);
            break;

        case 'to2':
            setTo2(`${iata}, ${name}, ${city}`);
            setTo2IataCode(iata);
            setSearchQueryTo2("");
            setShowTo2Dropdown(false);
            break;

        case 'from3':
            setFrom3(`${iata}, ${name}, ${city}`);
            setFrom3IataCode(iata);
            setSearchQueryFrom3("");
            setShowFrom3Dropdown(false);
            break;

        case 'to3':
            setTo3(`${iata}, ${name}, ${city}`);
            setTo3IataCode(iata);
            setSearchQueryTo3("");
            setShowTo3Dropdown(false);
            break;

        default:
            break;
    }

    setTimeout(() => {
        setShowDropdown(false);
        setShowDestinationDropdown(false);
        setShowFrom2Dropdown(false);
        setShowTo2Dropdown(false);
        setShowFrom3Dropdown(false);
        setShowTo3Dropdown(false);
    }, 100);

    setRecentSearches((prevSearches) => {

        const updatedSearches = prevSearches.filter(
            (search) =>
                (search.iata_code || search.AirportCode) !== iata
        );

        const newSearches = [option, ...updatedSearches].slice(0, 5);

        localStorage.setItem("recentSearches", JSON.stringify(newSearches));

        return newSearches;
    });
};
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        handleDropdownClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);



  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const bearerToken = localStorage.getItem('bearerToken');
  if (bearerToken === '' || bearerToken === undefined || bearerToken === null)
    window.location.href = '/login';    

  const policy = JSON.parse(sessionStorage.getItem('policies'));

  const [selectedOption, setSelectedOption] = useState(0);
  const [firstClass, setFirstClass] = useState('');
  const [businessClass, setBusinessClass] = useState('');
  const [economyClass, setEconomyClass] = useState('');
  const [premiumEcoClass, setPremiumEcoClass] = useState('');
  const [amountBusinessClass, setAmountBusinessClass] = useState('');
  const [amountEconomyClass, setAmountEconomyClass] = useState('');
  const [amountFirstClass, setAmountFirstClass] = useState('');
  const [amountPremiumEcoClass, setAmountPremiumEcoClass] = useState('');
  const [dayDurationBusinessClass, setDayDurationBusinessClass] = useState('');
  const [dayDurationEconomyClass, setDayDurationEconomyClass] = useState('');
  const [dayDurationFirstClass, setDayDurationFirstClass] = useState('');
  const [dayDurationPremiunEcoClass, setDayDurationPremiumEcoClass] = useState('');
  const [nightDurationBusinessClass, setNightDurationBusinessClass] = useState('');
  const [nightDurationEconomyClass, setNightDurationEconomyClass] = useState('');
  const [nightDurationFirstClass, setNightDurationFirstClass] = useState('');
  const [nightDurationPremiumEcoClass, setNightDurationPremiumEcoClass] = useState('');
  const [isAddPay, setIsAddPay] = useState(false);
  const [isForFamily, setIsForFamily] = useState(false);
  const [isPersonalTravel, setIsPersonalTravel] = useState(false);
  const [walletAmount, setWalletAmount] = useState(0);
  const [restrictedAirlines, setRestictedAirlines] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [isGuest, setIsGuest] = useState(true);
  const [from, setFrom] = useState('');
  const [to, setTO] = useState('');

  useEffect(() => {
    if (policy !== null) {
      setIsGuest(false);
      if (policy[0].policy !== null) {
        setFirstClass(policy[0].policy.firstClass);
        setBusinessClass(policy[0].policy.businessClass);
        setEconomyClass(policy[0].policy.economyClass);
        setPremiumEcoClass(policy[0].policy.premiumEcoClass);
        setAmountBusinessClass(policy[0].policy.amountBusinessClass);
        setAmountEconomyClass(policy[0].policy.amountEconomyClass);
        setAmountFirstClass(policy[0].policy.amountFirstClass);
        setAmountPremiumEcoClass(policy[0].policy.amountPremiumEcoClass);
        setDayDurationBusinessClass(policy[0].policy.dayDurationBusinessClass);
        setDayDurationEconomyClass(policy[0].policy.dayDurationEconomyClass);
        setDayDurationFirstClass(policy[0].policy.dayDurationFirstClass);
        setDayDurationPremiumEcoClass(policy[0].policy.dayDurationPremiunEcoClass);
        setNightDurationBusinessClass(policy[0].policy.nightDurationBusinessClass);
        setNightDurationEconomyClass(144);
        setNightDurationFirstClass(policy[0].policy.nightDurationFirstClass);
        setNightDurationPremiumEcoClass(policy[0].policy.nightDurationPremiumEcoClass);
      }
      else {
        setIsAdmin(true);
        setFirstClass(true);
        setBusinessClass(true);
        setEconomyClass(true);
        setPremiumEcoClass(true);
        setAmountBusinessClass(1000000000);
        setAmountEconomyClass(1000000000);
        setAmountFirstClass(1000000000);
        setAmountPremiumEcoClass(1000000000);
        setDayDurationBusinessClass(144);
        setDayDurationEconomyClass(144);
        setDayDurationFirstClass(144);
        setDayDurationPremiumEcoClass(144);
        setNightDurationBusinessClass(144);
        setNightDurationEconomyClass(144);
        setNightDurationFirstClass(144);
        setNightDurationPremiumEcoClass(144);
      }
      if (policy[0].user !== null) {
        setIsAddPay(policy[0].user.isAddPay);
        setIsForFamily(policy[0].user.isForFamily);
        setIsPersonalTravel(policy[0].user.isPersonalTravel);
        setWalletAmount(policy[0].user.walletAmount);
        setRestictedAirlines(policy[0].user.restrictedAirlines === null ? '' : policy[0].user.restrictedAirlines);
      }
      if (policy[0].user.policyId === 0) {
        setIsAdmin(true);
        setIsAddPay(true);
        setIsForFamily(true);
        setIsPersonalTravel(false);
        setWalletAmount(1000000000);
        setFirstClass(true);
        setBusinessClass(true);
        setEconomyClass(true);
        setPremiumEcoClass(true);
      }
    }
    else {
      setIsGuest(true);
      setFirstClass(true);
      setBusinessClass(true);
      setEconomyClass(true);
      setPremiumEcoClass(true);
      setAmountBusinessClass(1000000000);
      setAmountEconomyClass(1000000000);
      setAmountFirstClass(1000000000);
      setAmountPremiumEcoClass(1000000000);
      setDayDurationBusinessClass(144);
      setDayDurationEconomyClass(144);
      setDayDurationFirstClass(144);
      setDayDurationPremiumEcoClass(144);
      setNightDurationBusinessClass(144);
      setNightDurationEconomyClass(144);
      setNightDurationFirstClass(144);
      setNightDurationPremiumEcoClass(144);
      setIsAddPay(true);
      setIsForFamily(true);
      setIsPersonalTravel(false);
      setWalletAmount(1000000000);
    }
  }, []);
  useEffect(() => {
    if (policy !== null && policy.length > 0) {
      if (policy[0].policy !== null) {
        setFirstClass(policy[0].policy.firstClass);
        setBusinessClass(policy[0].policy.businessClass);
        setEconomyClass(policy[0].policy.economyClass);
        setPremiumEcoClass(policy[0].policy.premiumEcoClass);
      }
      if (policy[0].user !== null) {
        setIsAddPay(policy[0].user.isAddPay);
        setIsForFamily(policy[0].user.isForFamily);
        setIsPersonalTravel(policy[0].user.isPersonalTravel);
        setWalletAmount(policy[0].user.walletAmount);

        if (policy[0].user.policyId === 0) {
          setIsAddPay(true);
          setIsForFamily(true);
          setIsPersonalTravel(false);
          setWalletAmount(1000000000);
          setFirstClass(true);
          setBusinessClass(true);
          setEconomyClass(true);
          setPremiumEcoClass(true);
        }
      }
      else {
        setIsAddPay(false);
        setIsForFamily(false);
        setIsPersonalTravel(true);
        setWalletAmount(0);
      }
    }
    else {
      setIsAddPay(true);
      setIsForFamily(true);
      setIsPersonalTravel(false);
      setWalletAmount(1000000000);
      setFirstClass(true);
      setBusinessClass(true);
      setEconomyClass(true);
      setPremiumEcoClass(true);
    }
    if (isPersonalTravel) {
      setAdults(1);
      setChildren(0);
      setInfants(0);
    }
  }, [policy]);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQuery1, setSearchQuery1] = useState(() => ({


    departure: searchParams.get("origan") || "",
    destination: searchParams.get("destination") || "",
    adults: Number(searchParams.get("adults") || 1),
    children: Number(searchParams.get("children") || 0),
    infant: Number(searchParams.get("infant") || 0),
    cabin: searchParams.get("cabin") || "",
    ip: searchParams.get("ip") || "::1",
    JourneyType: Number(searchParams.get("JourneyType")) || 1,
    stops: searchParams.get("stops") === "true",
    segments: JSON.parse(decodeURIComponent(searchParams.get("segments"))) || [],




    // origin: searchParams.get('origin') || '',
    // destination: searchParams.get('destination') || '',
    // cabin: searchParams.get('cabin')?.split(',')[0] || '',
    // fromdate: searchParams.get('fromdate') || '',
    // todate: searchParams.get('todate') || '',
    // adult: Number(searchParams.get('adult')) || 1,
    // child: Number(searchParams.get('child')) || 0,
    // infant: Number(searchParams.get('infant')) || 0,
    // isRound: searchParams.get('isRound') || 1,
    // fareType: searchParams.get('fareType') || '',
    // isRF: searchParams.get('isRF') || 0,
    // mc: searchParams.get('mc') || '',
    // currency: searchParams.get('currency') || '',
    // fulldesti: searchParams.get('fulldesti') || '',
    // fulldepart: searchParams.get('fulldepart') || '',
    // cabintext: searchParams.get('cabin')?.split(',')[1] || '',


  }));


  useEffect(() => {
    setSelectedtripType(String(searchQuery1.JourneyType));
    setAdults(searchQuery1.adults);
    setChildren(searchQuery1.children);
    setInfants(searchQuery1.infant);
    setCabinClass(searchQuery1.cabin);
    setDeparture(searchQuery1.departure);
    setDestination(searchQuery1.destination);


    if (searchQuery1.JourneyType === 1) {
      setStartDate(new Date(searchQuery1.segments[0]?.depdate));
      setDepartureIataCode(searchQuery1.segments[0]?.depcode);
      setDestinationIataCode(searchQuery1.segments[0]?.arrcode);
    } else if (searchQuery1.JourneyType === 2) {
      setStartDate(new Date(searchQuery1.segments[0]?.depdate));
      setReturnDate(new Date(searchQuery1.segments[1]?.depdate));

    }
  }, []);

  useEffect(() => {
    try {

      const originFromUrl = searchParams.get("origin");
      const destinationFromUrl = searchParams.get("destination");

      if (originFromUrl) {
        setDeparture(originFromUrl);
      }

      if (destinationFromUrl) {
        setDestination(destinationFromUrl);
      }


      const rawSegments = searchParams.get("segments");

      let segmentsData = [];
      if (rawSegments) {
        const parsed = JSON.parse(decodeURIComponent(rawSegments));
        if (Array.isArray(parsed)) {
          segmentsData = parsed;
        }
      }

      const parsedQuery = {
        adults: Number(searchParams.get("adults") ?? 1),
        children: Number(searchParams.get("children") ?? 0),
        infant: Number(searchParams.get("infant") ?? 0),
        cabin: searchParams.get("cabin") ?? "Y",
        ip: searchParams.get("ip") ?? "::1",
        JourneyType: Number(searchParams.get("JourneyType") ?? 1),
        stops: searchParams.get("stops") === "true",
        segments: segmentsData,
      };

      // 🧠 Round-trip auto return segment
      if (parsedQuery.JourneyType === 2 && segmentsData.length === 1) {
        const first = segmentsData[0];
        segmentsData = [
          first,
          {
            depcode: first.arrcode,
            arrcode: first.depcode,
            depdate: new Date(
              new Date(first.depdate).getTime() + 86400000
            ).toISOString().split("T")[0],
          },
        ];
        parsedQuery.segments = segmentsData;
      }

      setsegmentdata(segmentsData);
      setSearchQuery1(parsedQuery);

      if (segmentsData.length > 0) {
        setDepartureIataCode(segmentsData[0].depcode);
        setDestinationIataCode(segmentsData[0].arrcode);
      }

    } catch (err) {
      console.error("URL parse error:", err);
    }
  }, [searchParams]);


  const updateSearchParams = (updatedParams) => {
    const newSearchParams = new URLSearchParams(searchParams);

    Object.entries(updatedParams).forEach(([key, value]) => {
      if (value === undefined || value === null) {
        newSearchParams.delete(key);
        return;
      }

      if (key === "segments") {
        newSearchParams.set(
          key,
          encodeURIComponent(JSON.stringify(value))
        );
        return;
      }

      newSearchParams.set(key, String(value));
    });

    // ✅ THIS is what actually updates the URL
    setSearchParams(newSearchParams);

    setSearchQuery1((prev) => ({
      ...prev,
      ...updatedParams,
    }));
  };


  const [loading, setLoading] = useState(false);
  const [upsellloading, setUpsellloading] = useState(false);
  const [listingPage1, setListingPage1] = useState([{
    Connection: null,
    ItineraryId: null,
    Offercode: "",
    OutboundInboundlist: [
      {
        flightlist: [
          {
            Aircraft: "",
            Arrival: {
              city: "",
              name: "",
              Datetime: "",
              Date: "",
              apidate: null,
              Terminal: ""
            },
            Departure: {
              city: "",
              name: "",
              Datetime: "",
              Date: "",
              apidate: null,
              Terminal: ""
            },
            CabinClassText: "",
            CheckinBaggage: [

              {
                Type: "",
                Value: "",
                price: null
              }
            ],
            FlightMinutes: "",
            FlightTime: "",
            MarketingAirline: {
              name: "",
              number: "",
              code: "",

            },
            OperatingAirline: {
              name: "",
              number: "",
              code: ""
            },
            RBD: "",
            RBDLIST: [],
            flightindex: 0,
            seats_remaining: null,
            technicalStop: []
          }
        ],
        totaltime: ""
      }
    ],
    api_response_ref: "",
    dealcode: null,
    dealcount: 0,
    farefamilylistdata: [],
    faretype: "",
    faretypename: "",
    id: "",
    pcc: "",
    price: {
      tarriffinfo: [],
      base_price: 0,
      tax_price: 0,
      total_price: 0,
      currency_sign: "",
      airlinemarkuptotal: 0
    },
    searchindex: 0,
    supplier: 0,
    totaltime: 0,
    unique_id: ""
  }]);

  useEffect(() => {
    // debuggers
    console.log("listingPage1 UPDATED:", listingPage1);

    console.log("Is array:", Array.isArray(listingPage1));
    console.log("Length:", listingPage1.length);
  }, [listingPage1]);

  const [listingPage, setListingPage] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',  // Smooth scrolling
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const [startDate, setStartDate] = useState(() => {
    return searchQuery1 && searchQuery1.segments?.[0]?.depdate ? new Date(searchQuery1.segments?.[0]?.depdate) : new Date();
  });
  const [returnDate, setReturnDate] = useState(() => {
    return searchQuery1.todate ? new Date(searchQuery1.todate) : ''
  });

  const [depart2, setDepart2] = useState(new Date());
  const [depart3, setDepart3] = useState(new Date());
  const [from2, setFrom2] = useState('');
  const [to2, setTo2] = useState('');
  const [to2IataCode, setTo2IataCode] = useState('');
  const [from2IataCode, setFrom2IataCode] = useState('');
  const [from3, setFrom3] = useState('');
  const [from3IataCode, setFrom3IataCode] = useState('');
  const [to3, setTo3] = useState('');
  const [to3IataCode, setTo3IataCode] = useState('');
  const [from2Options, setFrom2Options] = useState([]);
  const [to2Options, setTo2Options] = useState([]);
  const [from3Options, setFrom3Options] = useState([]);
  const [to3Options, setTo3Options] = useState([]);
  const [showFrom2Dropdown, setShowFrom2Dropdown] = useState(false);
  const [showTo2Dropdown, setShowTo2Dropdown] = useState(false);
  const [showFrom3Dropdown, setShowFrom3Dropdown] = useState(false);
  const [showTo3Dropdown, setShowTo3Dropdown] = useState(false);
  const [isSecondCityVisible, setIsSecondCityVisible] = useState(false);
  const [isSecondCityVisibleSelected, setIsSecondCityVisibleSelected] = useState(false);

  const [tripType, setTripType] = useState(String(searchQuery1?.JourneyType ?? 1));
  const [selectedtripType, setSelectedtripType] = useState(String(searchQuery1?.JourneyType ?? 1));
  const [showTravelerModal, setShowTravelerModal] = useState(false);
  const [isSearchClicked, setIsSearchClicked] = useState(true);
  const [adults, setAdults] = useState(searchQuery1?.adults ?? 1);
  const [children, setChildren] = useState(searchQuery1?.children ?? 0);
  const [infants, setInfants] = useState(searchQuery1?.infant ?? 0);
  const [cabinClass, setCabinClass] = useState(searchQuery1?.cabin ?? 'Y');
  const [cabinClassText, setCabinClassText] = useState(searchQuery1?.cabintext ?? 'Economy');
  const [fareType, setFareType] = useState(searchQuery1?.fareType ?? '0');
  const [isNRF, setIsNRF] = useState(searchQuery1?.isRF ?? false);
  const [departure, setDeparture] = useState(searchQuery1?.origin ?? '');

  const [departureOptions, setDepartureOptions] = useState([]);
  const [departureIataCode, setDepartureIataCode] = useState('');
  const [selectedDeparture, setSelectedDeparture] = useState(searchQuery1?.origin ?? '');
  const [destination, setDestination] = useState(searchQuery1?.destination ?? '');

  const [destinationOptions, setDestinationOptions] = useState([]);
  const [destinationIataCode, setDestinationIataCode] = useState('');
  const [selectedDestination, setSelectedDestination] = useState(searchQuery1?.destination ?? '');
  const [showDestinationDropdown, setShowDestinationDropdown] = useState(false);
  const [currency, setCurrency] = useState(searchQuery1?.currency ?? '');
  const [selectedcurrency, setSelectedCurrency] = useState(searchQuery1?.currency ?? '');
  const [isReady, setIsReady] = useState(false);
  const [isSearchAgain, setIsSearchAgain] = useState(true);
  const [segmentdata, setsegmentdata] = useState([]);

  const convertToHours = (time) => {

    if (time == null || time === "") return 0;


    if (typeof time === "number") {
      return Math.ceil(time / 60);
    }


    if (typeof time === "string") {
      const parts = time.split(":");

      if (parts.length !== 2) return 0;

      const hours = Number(parts[0]);
      const minutes = Number(parts[1]);

      if (Number.isNaN(hours) || Number.isNaN(minutes)) return 0;


      return hours + (minutes > 0 ? 1 : 0);
    }

    return 0;
  };


  useEffect(() => {
    if (selectedtripType === "3") {
      if (searchQuery1.mc !== '') {
        setIsReady(true);
        setFrom2(searchQuery1.mc?.split('|')[0]);

        setFrom2IataCode(searchQuery1.mc?.split('|')[0]?.split(',')[0]);
        setTo2(searchQuery1.mc?.split('|')[1]);
        setTo2IataCode(searchQuery1.mc?.split('|')[1]?.split(',')[0]);
        setDepart2(new Date(searchQuery1.mc?.split('$')[0]?.split('|')[2]));
        if (searchQuery1.mc?.split('$').length > 1) {
          setIsSecondCityVisibleSelected(true);
          setFrom3(searchQuery1.mc?.split('$')[1]?.split('|')[0]);
          setFrom3IataCode(searchQuery1.mc?.split('$')[1]?.split('|')[0]?.split(',')[0]);
          setTo3(searchQuery1.mc?.split('$')[1]?.split('|')[1]);
          setTo3IataCode(searchQuery1.mc?.split('$')[1]?.split('|')[1]?.split(',')[0]);
          setDepart3(new Date(searchQuery1.mc?.split('$')[1]?.split('|')[2]));
        }
      }
    }
  }, [selectedtripType, searchQuery1]);

  useEffect(() => {
    if (destination) {
      setFrom2(destination);
      setFrom2IataCode(destinationIataCode);
    }
  }, [destination, destinationIataCode]);

  useEffect(() => {
    if (to2) {
      setFrom3(to2);
      setFrom3IataCode(to2IataCode);
    }
  }, [to2, to2IataCode]);

  useEffect(() => {
    if (startDate) {
      //if (!returnDate || startDate > returnDate)
      //setReturnDate(new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1)));
      //if (tripType === '1') setReturnDate(new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1)));
      if (selectedtripType === '2')
        setReturnDate(new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1)));
      if (selectedtripType === '3' && depart2 < startDate)
        setDepart2(startDate);
    }
  }, [startDate]);
  useEffect(() => {
    if (selectedtripType === '3' && depart2 < startDate) {
      setDepart2(new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1)));
    }
  }, [selectedtripType])
  useEffect(() => {
    if (depart2) {
      if (selectedtripType === '3' && depart3 < depart2)
        setDepart3(new Date(new Date(depart2).setDate(new Date(depart2).getDate() + 1)));
    }
  }, [depart2]);

  useEffect(() => {
    if (
      segmentdata.length > 0 &&
      (departureIataCode || destinationIataCode || startDate || returnDate)
    ) {
      setsegmentdata((prev) => {
        const updated = [...prev];

        // --- 1️⃣ Update outbound (first segment) ---
        if (updated[0]) {
          updated[0] = {
            ...updated[0],
            depcode: departureIataCode || updated[0].depcode,
            arrcode: destinationIataCode || updated[0].arrcode,
            depdate: startDate
              ? startDate.toISOString().split("T")[0]
              : updated[0].depdate,
          };
        }

        // --- 2️⃣ Handle round-trip return segment ---
        if (selectedtripType === "2") {
          const formattedReturn = returnDate
            ? returnDate.toISOString().split("T")[0]
            : updated[1]?.depdate || "";

          if (updated.length === 1) {
            // Create return segment if missing
            const firstSeg = updated[0];
            const returnSeg = {
              depcode: destinationIataCode || firstSeg.arrcode || "",
              arrcode: departureIataCode || firstSeg.depcode || "",
              depdate: formattedReturn,
            };
            updated.push(returnSeg);
          } else if (updated[1]) {
            // Update existing return segment
            updated[1] = {
              ...updated[1],
              depcode: destinationIataCode || updated[1].depcode,
              arrcode: departureIataCode || updated[1].arrcode,
              depdate: formattedReturn,
            };
          }
        }

        return updated;
      });
    }
  }, [departureIataCode, destinationIataCode, startDate, returnDate, selectedtripType]);


  const searchButton = async () => {
   
    debugger
    if (departure === '') {
      await Swal.fire({
        icon: 'warning',
        title: 'Missing Departure',
        text: 'Please select departure.'
      });
      return;
    }
    if (destination === '') {
      await window.Swal.fire({
        icon: 'warning',
        title: 'Missing Destination',
        text: 'Please select destination.'
      });
      return;
    }
    if (!departure.includes(',')) {
      await window.Swal.fire({
        icon: 'warning',
        title: 'Invalid Departure Selection',
        text: 'Please select departure option.'
      });
      return;
    }
    if (!destination.includes(',')) {
      await window.Swal.fire({
        icon: 'warning',
        title: 'Invalid Destination Selection',
        text: 'Please select destination option.'
      });
      return;
    }
    if (destination === departure) {
      Swal.fire({
        icon: 'warning',
        title: 'Same City Selected',
        text: 'Please select different Cities.'
      });
      return;
    }
    // Check if departure date is missing
    if (!startDate) {
      await Swal.fire({
        icon: 'warning',
        title: 'Missing Departure Date',
        text: 'Please select a departure date.'
      });
      return;
    }
    if (selectedtripType === '2' && !returnDate) { // && returnDate < startDate
      await Swal.fire({
        icon: 'warning',
        title: 'Missing Return Date',
        text: 'Please select a return date that is not earlier than the departure date.'
      });
      return;
    }
    setDetailsVisible(false);
    let mc = '';
    try {
      if (selectedtripType === "3") {
        if (from2 === '') {
          await Swal.fire({
            icon: 'warning',
            title: 'Missing Departure',
            text: 'Please select departure.'
          });
          return;
        }
        else if (to2 === '') {
          await Swal.fire({
            icon: 'warning',
            title: 'Missing Destination',
            text: 'Please select destination.'
          });
          return;
        }
        else if (!from2.includes(',')) {
          await Swal.fire({
            icon: 'warning',
            title: 'Invalid Departure Selection',
            text: 'Please select departure option.'
          });
          return;
        }
        else if (!to2.includes(',')) {
          await Swal.fire({
            icon: 'warning',
            title: 'Invalid Destination Selection',
            text: 'Please select destination option.'
          });
          return;
        }
        else if (from2 === to2) {
          await Swal.fire({
            icon: 'warning',
            title: 'Same City Selected',
            text: 'Please select different Cities.'
          });
          return;
        }
        else {
          mc = from2 + "|" + to2 + "|" + depart2.toISOString()?.split('T')[0];
        }
        if (isSecondCityVisibleSelected) {
          if (from3 === '') {
            await Swal.fire({
              icon: 'warning',
              title: 'Missing Departure',
              text: 'Please select departure.'
            });
            return;
          }
          else if (to3 === '') {
            await Swal.fire({
              icon: 'warning',
              title: 'Missing Destination',
              text: 'Please select destination.'
            });
            return;
          }
          else {
            mc += "$" + from3 + "|" + to3 + "|" + depart3.toISOString()?.split('T')[0];
          }
        }
      }
      setLoading(true);

      const query = {
        // origin: departureIataCode,
        // destination: destinationIataCode,
        // cabin: cabinClass,
        // fromdate: startDate,
        // adult: adults,
        // child: children,
        // infant: infants,
        // isRound: selectedtripType,
        // fareType: fareType,
        // isRF: isNRF,
        // mc: mc,
        // currency: selectedcurrency

        adults: adults,
        children: children,
        infant: infants,
        cabin: cabinClass,
        ip: "::1",
        JourneyType: selectedtripType,
        stops: true,
        segments: segmentdata
      };


      console.log(query)
      const pageQuery = {
        adults: Number(adults),
        children: Number(children),
        infant: Number(infants),
        cabin: cabinClass,
        origin: departure,                 // e.g. "Delhi, IN"
        destination: destination,
        ip: "::1",
        JourneyType: Number(selectedtripType), // ✅ FIX 1
        stops: true,
        segments: [...segmentdata],            // ✅ FIX 2
      };

      if (returnDate) {
        pageQuery.todate = returnDate.toISOString().split("T")[0];
      }

      const params = new URLSearchParams();

      Object.entries(pageQuery).forEach(([key, value]) => {
        if (key === "segments") {
          params.set(
            key,
            encodeURIComponent(JSON.stringify(value))
          );
        } else {
          params.set(key, String(value));
        }
      });

      // ✅ Navigate WITH query params
      navigate(`/listing-page?${params.toString()}`);



      // const response = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/getFlightList`, {
      const response = await fetch(`${baseUrl}api/Flight/SearchFlight`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearerToken,

          },
          body: JSON.stringify(query),
        }
      );

      if (!response.ok) {
        // if (response.status === 401) {
        //   localStorage.removeItem('bearerToken');
        //   localStorage.removeItem('policies');
        //   sessionStorage.removeItem('policies');
        //   localStorage.removeItem('user');
        //   sessionStorage.clear();
        //   window.location.href = '/login';
        // }
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();

      console.log("Full API Response:", result);
      console.log("sc data Response:", result.Data?.sc);
      setSearchID(result.Data?.sc);

      let flightData = [];

      if (Array.isArray(result?.Data?.Data)) {
        flightData = result.Data.Data;
      } else if (Array.isArray(result?.Data)) {
        flightData = result.Data;
      } else if (Array.isArray(result)) {
        flightData = result;
      }

      console.log("Extracted flightData:", flightData);
      console.log("flightData length:", flightData.length);

      setListingPage1(flightData);
      setLoading2(false);

      if (flightData && flightData.length > 0) {
        if (query.JourneyType === "1") {
          // await getCalendarData(query);
        }
        clearAllFilters();
        setIsSearchClicked(true);
        setLoading(false);
        setCurrency(selectedcurrency);
        setTripType(selectedtripType);
        setSearchQuery1(query);
        setIsSecondCityVisible(isSecondCityVisibleSelected);
      }
      else {
        console.log("No flight data found, setting empty array");
        setListingPage1([]);
        setListingPage([]);
        clearAllFilters();
        setLoading(false);
        setIsSearchAgain(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
      setIsSearchAgain(false);
      clearAllFilters();
    }
  };

  useEffect(() => {
    if (Array.isArray(listingPage) && listingPage.length === 0 && isSearchAgain) {
      setLoading(true);
      setIsReady(true);
      const executeSearch = async () => {
        await searchButton();
        await  getCalendarData();
        setLoading(false);
        setIsReady(false);
        setIsSearchAgain(false);
      };
      if (isReady) {
        executeSearch();
      }
    }
  }, [listingPage, isReady]);

  const [selectedAirlines, setSelectedAirlines] = useState([]);
  const [selectedDepartureTimeSlot, setSelectedDepartureTimeSlot] = useState('');
  const [selectedArrivalTimeSlot, setSelectedArrivalTimeSlot] = useState('');
  // Return journey time slots
  const [selectedReturnDepartureTimeSlot, setSelectedReturnDepartureTimeSlot] = useState('');
  const [selectedReturnArrivalTimeSlot, setSelectedReturnArrivalTimeSlot] = useState('');
  const [calendarData, setCalendarData] = useState([]);
  const [activeTabs, setActiveTabs] = useState({});
  const [activeTabs1, setActiveTabs1] = useState({});
  const [activeTabs2, setActiveTabs2] = useState({});
  const [detailsVisible, setDetailsVisible] = useState(false);
  const [selectedIndex, setselectedIndex] = useState();
  const [selectedStops, setSelectedStops] = useState([]);
  const [selectedStopsRound, setSelectedStopsRound] = useState([]);
  const [selectedStopFilter, setSelectedStopFilter] = useState('');
  const [selectedStopFilterRound, setSelectedStopFilterRound] = useState('');
  const [selectedAirlineFilter, setSelectedAirlineFilter] = useState('');
  const [selectedTimeSlotFilter, setSelectedTimeSlotFilter] = useState('');
  const [selectedArrivalTimeSlotFilter, setSelectedArrivalTimeSlotFilter] = useState('');
  // Scope controls for round-trip popular filters
  // When both are false → popular stop filter is global (applies to both legs)
  // When only onward is true → applies only to outbound leg
  // When only return is true → applies only to inbound leg
  // When both are true → applies to both legs via their respective sections
  const [applyStopsOnward, setApplyStopsOnward] = useState(false);
  const [applyStopsReturn, setApplyStopsReturn] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [tooltip, setTooltip] = useState("");
  const [isFlightValid, setIsFlightValid] = useState(true);

  const fareTypeoptions = [
    { value: "RC", label: "REGULAR FARES", description: "Standard fare for regular passengers." },
    { value: "STC", label: "STUDENT FARES", description: "Applicable only for students above 12 years of age. Valid student ID cards and student visas (where applicable) are required to avail this." },
    { value: "YCD", label: "SENIOR CITIZEN", description: "Applicable only for senior citizens above the age of 60 years. A valid proof of Date of Birth is required at the airport to avail this." },
  ];
  const FilterPrices = listingPage1.filter((flight) => {
    // Safety check for price structure
    const priceInfo = flight?.price?.tarriffinfo?.[0];
    if (!priceInfo || !priceInfo.per_pax_total_price) return false;

    const amount = parseInt(Math.round(priceInfo.per_pax_total_price));
    const airline = flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.MarketingAirline?.name;
    if (!airline) return false;

    const totaltime = flight?.OutboundInboundlist?.[0]?.totaltime || 0;
    const durationHours = convertToHours(totaltime);

    // Check if flight meets basic criteria
    const isAllowedAirline = isGuest || isAdmin || (restrictedAirlines === null || !restrictedAirlines.includes(airline));
    const isWithinWallet = amount <= parseInt(walletAmount);
    const isWithinCabinPrice = (firstClass && amount <= parseInt(amountFirstClass, 10)) ||
      (businessClass && amount <= parseInt(amountBusinessClass, 10)) ||
      (premiumEcoClass && amount <= parseInt(amountPremiumEcoClass, 10)) ||
      (economyClass && amount <= parseInt(amountEconomyClass, 10));
    const isWithinDuration = parseInt(dayDurationFirstClass) >= durationHours ||
      parseInt(dayDurationBusinessClass) >= durationHours ||
      parseInt(dayDurationPremiunEcoClass) >= durationHours ||
      parseInt(dayDurationEconomyClass) >= durationHours;

    if (isAllowedAirline && isWithinWallet && isWithinCabinPrice && isWithinDuration) {
      return amount <= parseInt(amountPremiumEcoClass, 10);
    }
    return false;
  });
  const prices = FilterPrices.map((flight) => {
    const price = flight?.price?.tarriffinfo?.[0]?.per_pax_total_price;
    return price ? parseInt(Math.round(price)) : 0;
  }).filter(price => price > 0);
  const minPrice = prices.length > 0 ? Math.min(...prices) : 0;
  const maxPrice = prices.length > 0 ? Math.max(...prices) : 100000;

  const [fromPrice, setFromPrice] = useState(minPrice);
  const [toPrice, setToPrice] = useState(maxPrice);
  const [selectedPriceRange, setSelectedPriceRange] = useState([minPrice, maxPrice]);

  const sliderRef = useRef(null);
  const prevButtonRef = useRef(null);
  const nextButtonRef = useRef(null);


  const handleAddCity = () => {
    setIsSecondCityVisibleSelected(true);
  };

  const handleRemoveCity = () => {
    setIsSecondCityVisibleSelected(false);
    setTo3IataCode('');
    setTo3('');
  };

  const handleFrom2Change = (e) => {
    const query = e.target.value;
    setFrom2(query);
    setSearchQuery(query);
    setShowFrom2Dropdown(true);

    if (query.length > 1) {
      fetchLocationData(query, setFrom2Options);
    } else {
      setFrom2Options(popularCities);
    }
  };

  const handleTo2Change = (e) => {
    const query = e.target.value;
    setTo2(query);
    setSearchQuery(query);
    setShowTo2Dropdown(true);

    if (query.length > 1) {
      fetchLocationData(query, setTo2Options);
    } else {
      setTo2Options(popularCities);
    }
  };
  const handleFrom3Change = (e) => {
    const query = e.target.value;
    setFrom3(query);
    setSearchQuery(query);
    setShowFrom3Dropdown(true);

    if (query.length > 1) {
      fetchLocationData(query, setFrom3Options);
    } else {
      setFrom3Options(popularCities);
    }
  };

  const handleTo3Change = (e) => {
    const query = e.target.value;
    setTo3(query);
    setSearchQuery(query);
    setShowTo3Dropdown(true);

    if (query.length > 1) {
      fetchLocationData(query, setTo3Options);
    } else {
      setTo3Options(popularCities);
    }
  };

  const handlePrevClick = () => {
    sliderRef.current.scrollBy({
      left: -100,
      behavior: 'smooth'
    });
  };

  const handleNextClick = () => {
    sliderRef.current.scrollBy({
      left: 100,
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    if (listingPage && listingPage.length > 0) {
      if (prevButtonRef.current && nextButtonRef.current) {
        prevButtonRef.current.addEventListener('click', handlePrevClick);
        nextButtonRef.current.addEventListener('click', handleNextClick);
      }

      return () => {
        if (prevButtonRef.current && nextButtonRef.current) {
          prevButtonRef.current.removeEventListener('click', handlePrevClick);
          nextButtonRef.current.removeEventListener('click', handleNextClick);
        }
      };
    }
  }, [listingPage]);

  const allDurations = listingPage.flatMap(flight => {
    if (tripType === "1") {
      if (flight.noOfStops === "0") {
        if (isGuest ? true : isAdmin ? true : (((parseInt(dayDurationFirstClass) >= convertToHours(flight.duration)
          || parseInt(dayDurationBusinessClass) >= convertToHours(flight.duration)
          || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.duration)
          || parseInt(dayDurationEconomyClass) >= convertToHours(flight.duration))
          && ((firstClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountFirstClass, 10))
            || (businessClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountBusinessClass, 10))
            || (premiumEcoClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountPremiumEcoClass, 10)
              || (economyClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountEconomyClass, 10))
            )))
          && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount)
          && (restrictedAirlines !== null && !restrictedAirlines.includes(flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name)))
        ) {
          return [convertToHours(flight.duration)];
        }
        else {
          return [];
        }
      } else if (flight.noOfStops === "1") {
        if (isGuest ? true : isAdmin ? true : (((parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime)
          || parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime)
          || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime)
          || parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime))
          && ((firstClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountFirstClass, 10))
            || (businessClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountBusinessClass, 10))
            || (premiumEcoClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountPremiumEcoClass, 10)
              || (economyClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountEconomyClass, 10))
            )))
          && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount)
          && (restrictedAirlines !== null && !restrictedAirlines.includes(flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name)))
        ) {
          return [
            convertToHours(flight.inbwLOTime)
          ];
        }
        else {
          return [];
        }
      } else if (flight.noOfStops === "2") {
        if (isGuest ? true : isAdmin ? true : ((
          (parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime1)
            || parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime1)
            || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime1)
            || parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime1))
          && ((firstClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountFirstClass, 10))
            || (businessClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountBusinessClass, 10))
            || (premiumEcoClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountPremiumEcoClass, 10))
            || (economyClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountEconomyClass, 10))
          ) && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount)
          && (restrictedAirlines !== null && !restrictedAirlines.includes(flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name))
        ))) {
          return [
            convertToHours(flight.inbwLOTime1)
          ];
        }
        else {
          return [];
        }
      } else if (flight.noOfStops === "3") {
        if (isGuest ? true : isAdmin ? true : ((parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime2)
          || parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime2)
          || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime2)
          || parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime2))
          && ((firstClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountFirstClass, 10))
            || (businessClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountBusinessClass, 10))
            || (premiumEcoClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountPremiumEcoClass, 10))
            || (economyClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountEconomyClass, 10)))
          && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount)
          && (restrictedAirlines !== null && !restrictedAirlines.includes(flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name)))
        ) {
          return [
            convertToHours(flight.inbwLOTime2)
          ];
        }
        else {
          return [];
        }
      }
    }
    else {
      return [];
    }
  });
  const minDuration = Math.min(...allDurations);
  const maxDuration = Math.max(...allDurations);

  const [fromDuration, setFromDuration] = useState(minDuration);
  const [toDuration, setToDuration] = useState(maxDuration);
  const [selectedDurationRange, setSelectedDurationRange] = useState([minDuration, maxDuration]);



  const scrollIntoView = (index) => {
    const activeElement = document.getElementById(`option-${index}`);
    if (activeElement) {
      activeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
    const activeElementr = document.getElementById(`optionr-${index}`);
    if (activeElementr) {
      activeElementr.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
    const activeElementp = document.getElementById(`optionp-${index}`);
    if (activeElementp) {
      activeElementp.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  };
  // async function searchFlights() {
  //   const request = {
  //     adults: 1,
  //     children: 1,
  //     infant: 0,
  //     cabin: "Y",
  //     ip: "::1",
  //     JourneyType: 1,
  //     stops: true,
  //     segments: [
  //       {
  //         depcode: "DEL",
  //         arrcode: "DXB",

  //         depdate: "2026-01-01"
  //       }
  //     ]
  //   };

  //   try {
  //     const response = await fetch(
  //       "https://flighapi.aadviktech.com/api/Flight/SearchFlight",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json"
  //         },
  //         body: (request) // 🔴 must be stringified
  //       }
  //     );

  //     if (!response.ok) {
  //       // Handle non-200 responses
  //       const errorText = await response.text();
  //       throw new Error(`API Error ${response.status}: ${errorText}`);
  //     }

  //     const data = await response.json();
  //     console.log("Flight Search Response:", data);
  //     return data;

  //   } catch (error) {
  //     console.error("Error fetching flights:", error);
  //     throw error;
  //   }
  // }
  // useEffect(() => {
  //   searchFlights();
  // }, []);

  const fetchLocationData = async (query, setOptions) => {
    console.log("setOptions:", setOptions); // ✅ Debugging
    if (typeof setOptions !== "function") {
        console.error("🚨 setOptions is not a function! Check function call.");
        return;
    }
    if (!bearerToken) {
        console.error("No token found");
        return;
    }

    console.log("Payload:", query);
    try {
        const response = await fetch(`${baseUrl}api/Flight/GetAirportSearch?search=${query}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + bearerToken,
            },
            //body: JSON.stringify("query") // Add the API request body with the query
        });

        if (!response.ok) {
            if (response.status === 401) {
                localStorage.removeItem("bearerToken");
                window.location.href = "/login";
            }
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();
        console.log("Fetched Data:", result); // ✅ Debugging API response

        setOptions(result.Data);
    } catch (error) {
        console.error("Error fetching data:", error);
    }
};

  const handleKeyDown = (event, options = [], type) => {
    if (!options || options.length === 0) return;

    if (event.key === "ArrowDown") {
      setActiveIndex(prev => {
        const newIndex = prev < (options?.length || 0) - 1 ? prev + 1 : prev;
        scrollIntoView(newIndex);
        return newIndex;
      });
    } else if (event.key === "ArrowUp") {
      setActiveIndex(prev => {
        const newIndex = prev > 0 ? prev - 1 : prev;
        scrollIntoView(newIndex);
        return newIndex;
      });
    } else if (event.key === "Enter" && activeIndex !== -1) {
      handleOptionSelect(options[activeIndex], type);
    }
  };

  const handleCabinClassChange = (e) => {
    const selectedValue = e.target.value;
    setCabinClass(selectedValue);

    const selectedText = e.target.options[e.target.selectedIndex].text;
    setCabinClassText(selectedText);
  };
  const handleSliderChange = (e) => {
    const { id, value } = e.target;
    if (id === "fromSlider") {
      setFromPrice(Number(value));
    } else if (id === "toSlider") {
      setToPrice(Number(value));
    }
  };
  const averageDuration = (min, max) => (min + max) / 2;

  const handleInputChange = (e) => {
    const query = e.target.value;
    setDeparture(query);
    setSearchQuery(query);
    setShowDropdown(true);

    if (query.length > 1) {
      fetchLocationData(query, setDepartureOptions);
    } else {
      setDepartureOptions(popularCities);
    }
  };
  const handleDestinationChange = (e) => {
    const query = e.target.value;
    setDestination(query);
    setSearchQuery(query);
    setShowDestinationDropdown(true);

    if (query.length > 1) {
      fetchLocationData(query, setDestinationOptions);
    } else {
      setDestinationOptions(popularCities);
    }
  };
  const handleTravelerModalToggle = () => {
    setShowTravelerModal(!showTravelerModal);
  };
  const handleTripTypeChange = (type) => {
    setSelectedtripType(type);


    if (type === '2') {
      setsegmentdata((prev) => {
        // If we already have 2 segments, don't do anything
        if (prev.length >= 2) return prev;

        // Get the first segment data
        const firstSeg = prev[0] || { depcode: '', arrcode: '', depdate: new Date().toISOString().split('T')[0] };

        // Calculate return date (1 day after departure)
        const returnDate = new Date(new Date(firstSeg.depdate).getTime() + 1 * 24 * 60 * 60 * 1000)
          .toISOString()
          .split("T")[0];

        // Create the return segment
        const returnSeg = {
          depcode: firstSeg.arrcode,
          arrcode: firstSeg.depcode,
          depdate: returnDate,
        };

        const newSegments = [firstSeg, returnSeg];

        // Update the main search query state as well
        setSearchQuery1(prevQuery => ({
          ...prevQuery,
          JourneyType: 2,
          segments: newSegments
        }));

        return newSegments;
      });

      // Set the visual return date picker state
      const rDate = new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000);
      setReturnDate(rDate);

    } else {
      // Logic for One Way
      setReturnDate(null);
      setsegmentdata((prev) => {
        const newSegments = [prev[0]];
        setSearchQuery1(prevQuery => ({
          ...prevQuery,

          segments: newSegments
        }));
        return newSegments;
      });
    }
  };
  const maxPassengers = 9;

  const handleAddPassenger = (type, count) => {
    const totalPassengers = adults + children + infants;
    if (totalPassengers >= maxPassengers && count === 1) {
      Swal.fire({
        icon: 'warning',
        title: 'Passenger Limit Exceeded',
        text: 'You cannot select more than 9 passengers.'
      });
      return;
    }
    if (type === "adult") {
      if (adults < 1) {
        Swal.fire({
          icon: 'warning',
          title: 'Insufficient Adults',
          text: 'At least one adult is required.'
        });
        return;
      }
      setAdults(adults + count);
    } else if (type === "child") {
      setChildren(children + count);
    } else if (type === "infant") {
      if (infants === adults && count === 1) {
        Swal.fire({
          icon: 'warning',
          title: 'Infant Limit Exceeded',
          text: 'Infants cannot exceed the number of adults.'
        });
        return;
      }
      setInfants(infants + count);
    }
    if (isPersonalTravel) {
      setAdults(1);
      setChildren(0);
      setInfants(0);
    }
  };

  

  const getCalendarData = async (query) => {
    const calendarPayload = {
      adults: adults,
        children: children,
        infant: infants,
        cabin: cabinClass,
        ip: "::1",
        JourneyType: Number(selectedtripType),
        stops: true,
        segments: segmentdata
    }
    console.log("calendarpayload",calendarPayload)
    console.log("calendarquery",query)

    try {
      const response = await fetch(`${baseUrl}api/Flight/GetCalendarPrice`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': 'Bearer ' + bearerToken,
        },
        body: JSON.stringify({calendarPayload}),
      });
      if (!response.ok) {
        // if (response.status === 401) {
        //   localStorage.removeItem('bearerToken');
        //   localStorage.removeItem('policies');
        //   sessionStorage.removeItem('policies');
        //   localStorage.removeItem('user');
        //   sessionStorage.clear();
        //   window.location.href = '/login';
        // }
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
      const result = await response.json();
      console.log("calender data",result)
      setCalendarData(result);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const openTab = (index, tabName) => {
    setActiveTabs(prevState => ({
      ...prevState,
      [index]: tabName
    }));
  };
  const openTab1 = (index, tabName) => {
    setActiveTabs1(prevState => ({
      ...prevState,
      [index]: tabName
    }));
  };
  const openTab2 = (index, tabName) => {
    setActiveTabs2(prevState => ({
      ...prevState,
      [index]: tabName
    }));
  };
  const viewFlightDetails = (index) => {
    handleViewDetails(index);
  };
  const handleViewDetails = (index) => {
    if (selectedIndex === index) {
      setDetailsVisible(!detailsVisible);
    } else {
      setDetailsVisible(true);
      setselectedIndex(index);
    }
    if (tripType === '1')
      openTab(index, `flight-details${index}`);
    if (tripType === '2')
      openTab1(index, `flight-details${index}`);
    if (tripType === '3')
      openTab2(index, `flight-details${index}`);
  };
  const currencySymbols = {
    INR: '₹',
    EUR: '€',
    USD: '$',
    AED: 'د.إ',
  };
  const getCurrencySymbol = (currencyCode) => {
    return currencySymbols[currencyCode] || currencyCode;
  };
  const hasFlightsForTimeSlot = (timeSlot, type) => {
    return listingPage1.some(flight => {


      let timeString = null;



      // loop is REQUIRED for multi-trip
      flight?.OutboundInboundlist?.forEach((leg, legIndex) => {
        const flightList = leg?.flightlist || [];

        if (!flightList.length) return;

        if (type === "departure") {
          // First segment departure
          timeString = flightList[0]?.Departure?.time || null;
        } else {
          // Last segment arrival (auto handles stops)
          timeString =
            flightList[flightList.length - 1]?.Arrival?.time || null;
        }

        // console.log(`Leg ${legIndex + 1} time:`, timeString);
      });


      if (!timeString) return false;
      const [hours] = timeString?.split(':').map(Number);
      const isTimeSlotMatched = (
        (timeSlot === 'before6' && hours < 6) ||
        (timeSlot === 'morning' && hours >= 6 && hours < 12) ||
        (timeSlot === 'afternoon' && hours >= 12 && hours < 18) ||
        (timeSlot === 'evening' && hours >= 18)
      );

      const isFlightValid1 = isGuest ? true : isAdmin ? true : (restrictedAirlines !== null &&
        !restrictedAirlines.includes(flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name) &&
        ((firstClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountFirstClass, 10)) ||
          (businessClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountBusinessClass, 10)) ||
          (premiumEcoClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountPremiumEcoClass, 10)) ||
          (economyClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountEconomyClass, 10))) &&
        flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount) &&
        (tripType === "1" || tripType === "2" || tripType === "3") ? flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount) &&
      (flight.noOfStops === "0" ?
        (parseInt(dayDurationFirstClass) >= convertToHours(flight.duration) ||
          parseInt(dayDurationBusinessClass) >= convertToHours(flight.duration) ||
          parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.duration) ||
          parseInt(dayDurationEconomyClass) >= convertToHours(flight.duration)) :
        ((flight.noOfStops === "1" ? (
          parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime) ||
          parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime) ||
          parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime) ||
          parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime)) :
          flight.noOfStops === "2" ? (
            parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime1) ||
            parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime1) ||
            parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime1) ||
            parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime1)) :
            (parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime2) ||
              parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime2) ||
              parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime2) ||
              parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime2)))))
        : (tripType === "2" || tripType === "3") ? flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount) && (restrictedAirlines !== null
          && !restrictedAirlines.includes(flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name) && flight.retmarketingCompany !== null
          && !restrictedAirlines.includes(flight.OutboundInboundlist[1].flightlist[0].MarketingAirline.name)
          && flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name === flight.OutboundInboundlist[1].flightlist[0].MarketingAirline.name
          && ((firstClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountFirstClass, 10))
            || (businessClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountBusinessClass, 10))
            || (premiumEcoClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountPremiumEcoClass, 10))
            || (economyClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountEconomyClass, 10)))
          && (flight.retnoOfStops === "0" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.retduration)
            || parseInt(dayDurationBusinessClass) >= convertToHours(flight.retduration)
            || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.retduration)
            || parseInt(dayDurationEconomyClass) >= convertToHours(flight.retduration))
            : (flight.retnoOfStops === "1" ?
              (parseInt(dayDurationFirstClass) >= convertToHours(flight.retinbwLOTime)
                || parseInt(dayDurationBusinessClass) >= convertToHours(flight.retinbwLOTime)
                || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.retinbwLOTime)
                || parseInt(dayDurationEconomyClass) >= convertToHours(flight.retinbwLOTime)) :
              flight.retnoOfStops === "2" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.retinbwLOTime1)
                || parseInt(dayDurationBusinessClass) >= convertToHours(flight.retinbwLOTime1)
                || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.retinbwLOTime1)
                || parseInt(dayDurationEconomyClass) >= convertToHours(flight.retinbwLOTime1)) :
                (parseInt(dayDurationFirstClass) >= convertToHours(flight.retinbwLOTime2)
                  || parseInt(dayDurationBusinessClass) >= convertToHours(flight.retinbwLOTime2)
                  || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.retinbwLOTime2)
                  || parseInt(dayDurationEconomyClass) >= convertToHours(flight.retinbwLOTime2)))))
          : (tripType === "3") ? flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount) && (restrictedAirlines !== null && flight.marketingCompany3 !== null
            && !restrictedAirlines.includes(flight.marketingCompany3?.split('|')[1])
            && ((firstClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountFirstClass, 10))
              || (businessClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountBusinessClass, 10))
              || (premiumEcoClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountPremiumEcoClass, 10))
              || (economyClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountEconomyClass, 10)))
            && (flight.noOfStops3 === "0" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.duration3)
              || parseInt(dayDurationBusinessClass) >= convertToHours(flight.duration3)
              || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.duration3)
              || parseInt(dayDurationEconomyClass) >= convertToHours(flight.duration3))
              : (flight.noOfStops3 === "1" ? (parseInt(parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime3)
                || dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime3)
                || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime3)
                || parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime3)) :
                flight.noOfStops3 === "2" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime31)
                  || parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime31)
                  || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime31)
                  || parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime31)) :
                  (parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime32)
                    || parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime32)
                    || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime32)
                    || parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime32))))) : false);

      return isTimeSlotMatched && isFlightValid1;
    });
  };
  // Helper function to check return journey time slots
  const hasFlightsForReturnTimeSlot = (timeSlot, type) => {
    if (tripType !== "2") return false;
    return listingPage1.some(flight => {
      const returnLeg = flight?.OutboundInboundlist?.[1];
      if (!returnLeg || !returnLeg.flightlist || returnLeg.flightlist.length === 0) return false;

      let timeString = null;
      if (type === "departure") {
        timeString = returnLeg.flightlist[0]?.Departure?.time || null;
      } else {
        timeString = returnLeg.flightlist[returnLeg.flightlist.length - 1]?.Arrival?.time || null;
      }

      if (!timeString) return false;
      const [hours] = timeString.split(':').map(Number);
      const isTimeSlotMatched = (
        (timeSlot === 'before6' && hours < 6) ||
        (timeSlot === 'morning' && hours >= 6 && hours < 12) ||
        (timeSlot === 'afternoon' && hours >= 12 && hours < 18) ||
        (timeSlot === 'evening' && hours >= 18)
      );
      return isTimeSlotMatched;
    });
  };
  const handleDepartureButtonClick = (timeSlot) => {
    setSelectedDepartureTimeSlot(prevSlot =>
      prevSlot === timeSlot ? '' : timeSlot
    );
    setSelectedTimeSlotFilter(prev => prev === timeSlot ? '' : timeSlot);
  };
  const handleArrivalButtonClick = (timeSlot) => {
    setSelectedArrivalTimeSlot(prevSlot =>
      prevSlot === timeSlot ? '' : timeSlot
    );
    setSelectedArrivalTimeSlotFilter(prev => prev === timeSlot ? '' : timeSlot);
  };
  // Return journey handlers
  const handleReturnDepartureButtonClick = (timeSlot) => {
    setSelectedReturnDepartureTimeSlot(prevSlot =>
      prevSlot === timeSlot ? '' : timeSlot
    );
  };
  const handleReturnArrivalButtonClick = (timeSlot) => {
    setSelectedReturnArrivalTimeSlot(prevSlot =>
      prevSlot === timeSlot ? '' : timeSlot
    );
  };

  const handleStopsFilter = (e, stops) => {
    if (e.target.checked) {
      const updatedStops = [...selectedStops, stops];
      setSelectedStops(updatedStops);
      setSelectedStopFilter(updatedStops.join(','));
    } else {
      const updatedStops = selectedStops.filter(stop => stop !== stops);
      setSelectedStops(updatedStops);
      setSelectedStopFilter(updatedStops.join(','));
    }
  };
  const handleStopsFilterRound = (e, stops) => {
    if (e.target.checked) {
      const updatedStops = [...selectedStopsRound, stops];
      setSelectedStopsRound(updatedStops);
      setSelectedStopFilterRound(updatedStops.join(','));
    } else {
      const updatedStops = selectedStopsRound.filter(stop => stop !== stops);
      setSelectedStopsRound(updatedStops);
      setSelectedStopFilterRound(updatedStops.join(','));
    }
  };
  // Popular stop filter handler with round-trip scope support
  const handlePopularStopsFilter = (e, stops) => {
    const { checked } = e.target;

    // For one-way and multi-city, behave like normal onward filter
    if (tripType !== "2") {
      handleStopsFilter({ target: { checked } }, stops);
      return;
    }

    // Round-trip behaviour based on scope checkboxes:
    // - If both scope flags are false → global: apply to both legs
    // - If only applyStopsOnward is true → apply only to outbound
    // - If only applyStopsReturn is true → apply only to inbound
    // - If both are true → apply to both via their respective sections
    const applyOnward = (!applyStopsOnward && !applyStopsReturn) || applyStopsOnward;
    const applyReturn = (!applyStopsOnward && !applyStopsReturn) || applyStopsReturn;

    const syntheticEvent = { target: { checked } };

    if (applyOnward) {
      handleStopsFilter(syntheticEvent, stops);
    }
    if (applyReturn) {
      handleStopsFilterRound(syntheticEvent, stops);
    }
  };
  const getAirlinesWithDetails = () => {
    const airlinesMap = {};
    listingPage1.forEach(flight => {
      // Safety checks
      const priceInfo = flight?.price?.tarriffinfo?.[0];
      if (!priceInfo || !priceInfo.per_pax_total_price) return;

      const outbound = flight?.OutboundInboundlist?.[0];
      if (!outbound || !outbound.flightlist || outbound.flightlist.length === 0) return;

      const firstFlight = outbound.flightlist[0];
      if (!firstFlight?.MarketingAirline?.name) return;

      let airline = "";
      const price = parseFloat(Math.round(priceInfo.per_pax_total_price));
      let aircode = "";
      if (tripType === "2") {
        if (isGuest ? flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name === flight.OutboundInboundlist[1].flightlist[0].MarketingAirline.name
          : isAdmin ? flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name === flight.OutboundInboundlist[1].flightlist[0].MarketingAirline.name :
            (restrictedAirlines !== null && !restrictedAirlines.includes(flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name)
              && !restrictedAirlines.includes(flight.OutboundInboundlist[1].flightlist[0].MarketingAirline.name)
              && flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name === flight.OutboundInboundlist[1].flightlist[0].MarketingAirline.name
              && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount)
              && ((firstClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountFirstClass, 10))
                || (businessClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountBusinessClass, 10))
                || (economyClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountEconomyClass, 10))
                || (premiumEcoClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountPremiumEcoClass, 10))
              ) &&
              ((flight.noOfStops === "0" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.duration)
                || parseInt(dayDurationBusinessClass) >= convertToHours(flight.duration)
                || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.duration)
                || parseInt(dayDurationEconomyClass) >= convertToHours(flight.duration)) :
                flight.noOfStops === "1" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime)
                  || parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime)
                  || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime)
                  || parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime)) :
                  flight.noOfStops === "2" ? (parseInt(parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime1)
                    || dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime1)
                    || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime1)
                    || parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime1)) :
                    (parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime2)
                      || parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime2)
                      || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime2)
                      || parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime2))))
              && (flight.retnoOfStops === "0" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.retduration)
                || parseInt(dayDurationBusinessClass) >= convertToHours(flight.retduration)
                || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.retduration)
                || parseInt(dayDurationEconomyClass) >= convertToHours(flight.retduration))
                : (flight.retnoOfStops === "1" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.retinbwLOTime)
                  || parseInt(dayDurationBusinessClass) >= convertToHours(flight.retinbwLOTime)
                  || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.retinbwLOTime)
                  || parseInt(dayDurationEconomyClass) >= convertToHours(flight.retinbwLOTime)) :
                  flight.retnoOfStops === "2" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.retinbwLOTime1)
                    || parseInt(dayDurationBusinessClass) >= convertToHours(flight.retinbwLOTime1)
                    || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.retinbwLOTime1)
                    || parseInt(dayDurationEconomyClass) >= convertToHours(flight.retinbwLOTime1)) :
                    (parseInt(dayDurationFirstClass) >= convertToHours(flight.retinbwLOTime2)
                      || parseInt(dayDurationBusinessClass) >= convertToHours(flight.retinbwLOTime2)
                      || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.retinbwLOTime2)
                      || parseInt(dayDurationEconomyClass) >= convertToHours(flight.retinbwLOTime2)))))) {
          airline = flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name;
          aircode = flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.code;
        }
      }
      else if (tripType === "3") {
        // Multi-city trip - simplified check
        const totaltime = outbound.totaltime || 0;
        const durationHours = convertToHours(totaltime);
        const outboundAirline = firstFlight.MarketingAirline.name;

        if (isGuest || isAdmin) {
          airline = outboundAirline;
          aircode = firstFlight.MarketingAirline.code;
        } else {
          if (restrictedAirlines === null ||
            (!restrictedAirlines.includes(outboundAirline) &&
              ((firstClass && price <= parseInt(amountFirstClass, 10)) ||
                (businessClass && price <= parseInt(amountBusinessClass, 10)) ||
                (premiumEcoClass && price <= parseInt(amountPremiumEcoClass, 10)) ||
                (economyClass && price <= parseInt(amountEconomyClass, 10))) &&
              price <= parseInt(walletAmount) &&
              (parseInt(dayDurationFirstClass) >= durationHours ||
                parseInt(dayDurationBusinessClass) >= durationHours ||
                parseInt(dayDurationPremiunEcoClass) >= durationHours ||
                parseInt(dayDurationEconomyClass) >= durationHours))) {
            airline = outboundAirline;
            aircode = firstFlight.MarketingAirline.code;
          }
        }
      }
      else {
        // For tripType === "1" (one way)
        const totaltime = outbound.totaltime || 0;
        const durationHours = convertToHours(totaltime);
        const outboundAirline = firstFlight.MarketingAirline.name;

        if (isGuest || isAdmin) {
          airline = outboundAirline;
          aircode = firstFlight.MarketingAirline.code;
        } else {
          if (restrictedAirlines === null ||
            (!restrictedAirlines.includes(outboundAirline) &&
              ((firstClass && price <= parseInt(amountFirstClass, 10)) ||
                (businessClass && price <= parseInt(amountBusinessClass, 10)) ||
                (premiumEcoClass && price <= parseInt(amountPremiumEcoClass, 10)) ||
                (economyClass && price <= parseInt(amountEconomyClass, 10))) &&
              price <= parseInt(walletAmount) &&
              (parseInt(dayDurationFirstClass) >= durationHours ||
                parseInt(dayDurationBusinessClass) >= durationHours ||
                parseInt(dayDurationPremiunEcoClass) >= durationHours ||
                parseInt(dayDurationEconomyClass) >= durationHours))) {
            airline = outboundAirline;
            aircode = firstFlight.MarketingAirline.code;
          }
        }
      }
      if (airline != "") {
        if (airlinesMap[airline]) {
          airlinesMap[airline].count += 1;
          airlinesMap[airline].minPrice = Math.min(airlinesMap[airline].minPrice, price);
          airlinesMap[airline].aircode = aircode;
        } else {
          airlinesMap[airline] = {
            count: 1,
            minPrice: price,
            aircode: aircode
          };
        }
      }
    });
    return airlinesMap;
  };
  const handleAirlineCheckboxChange = (airline) => {
    setSelectedAirlines((prevSelected) => {
      let updatedAirlines;
      if (prevSelected.includes(airline)) {
        updatedAirlines = prevSelected.filter(item => item !== airline);
        setSelectedAirlineFilter(updatedAirlines.join(', '));
      } else {
        updatedAirlines = [...prevSelected, airline];
        setSelectedAirlineFilter([]);
      }
      return updatedAirlines;
    });
  };
  const getMinPriceForNoOfStops = (noOfStops, trip) => {
    const filteredFlights = listingPage1.filter((flight) => {
      // Calculate stops: flightlist.length - 1 (0 stops = 1 flight, 1 stop = 2 flights, etc.)
      const flightStops = flight.OutboundInboundlist?.[0]?.flightlist?.length > 1
        ? String(flight.OutboundInboundlist[0].flightlist.length - 1)
        : "0";
      const isMatchingStops = flightStops === noOfStops;

      // Safety checks
      const priceInfo = flight?.price?.tarriffinfo?.[0];
      if (!priceInfo || !priceInfo.per_pax_total_price) return false;

      const airline = flight.OutboundInboundlist?.[0]?.flightlist?.[0]?.MarketingAirline?.name;
      if (!airline) return false;

      const price = parseInt(Math.round(priceInfo.per_pax_total_price));
      const totaltime = flight.OutboundInboundlist?.[0]?.totaltime || 0;
      const durationHours = convertToHours(totaltime);

      const isAllowedAirline = isGuest ? true : isAdmin ? true : (restrictedAirlines !== null &&
        !restrictedAirlines.includes(airline) &&
        ((firstClass && price <= parseInt(amountFirstClass, 10)) ||
          (businessClass && price <= parseInt(amountBusinessClass, 10)) ||
          (premiumEcoClass && price <= parseInt(amountPremiumEcoClass, 10)) ||
          (economyClass && price <= parseInt(amountEconomyClass, 10))) &&
        price <= parseInt(walletAmount) &&
        (tripType === "1" || tripType === "2" || tripType === "3") ? price <= parseInt(walletAmount) &&
      (parseInt(dayDurationFirstClass) >= durationHours ||
        parseInt(dayDurationBusinessClass) >= durationHours ||
        parseInt(dayDurationPremiunEcoClass) >= durationHours ||
        parseInt(dayDurationEconomyClass) >= durationHours)
        : true);

      return isGuest ? isMatchingStops : isAdmin ? isMatchingStops : (isMatchingStops && isAllowedAirline);
    });
    const prices = filteredFlights.map((flight) => {
      const price = flight?.price?.tarriffinfo?.[0]?.per_pax_total_price;
      return price ? parseInt(Math.round(price), 10) : null;
    }).filter(price => price !== null && price > 0);

    return prices.length > 0 ? Math.min(...prices) : null;
  };
  const getMinPriceForAirline = (airline) => {
    const safeList = Array.isArray(listingPage1) ? listingPage1 : [];

    const filteredFlights = safeList.filter((flight) => {
      // ---------- SAFETY ----------
      const outbound = flight?.OutboundInboundlist?.[0]?.flightlist?.[0];
      if (!outbound) return false;

      const airlineName = outbound?.MarketingAirline?.name;
      if (!airlineName) return false;

      const tariff = flight?.price?.tarriffinfo?.[0];
      if (!tariff?.per_pax_total_price) return false;

      const price = Number(tariff.per_pax_total_price);
      if (!Number.isFinite(price)) return false;

      // ---------- AIRLINE MATCH ----------
      const isAirline = airlineName === airline;

      // ---------- ADMIN / GUEST ----------
      if (isGuest || isAdmin) {
        return isAirline;
      }

      // ---------- RESTRICTED AIRLINES ----------
      if (
        restrictedAirlines &&
        restrictedAirlines.includes(airlineName)
      ) {
        return false;
      }

      // ---------- WALLET ----------
      if (price > Number(walletAmount)) return false;

      // ---------- CABIN PRICE ----------
      if (
        !(
          (firstClass && price <= Number(amountFirstClass)) ||
          (businessClass && price <= Number(amountBusinessClass)) ||
          (premiumEcoClass && price <= Number(amountPremiumEcoClass)) ||
          (economyClass && price <= Number(amountEconomyClass))
        )
      ) {
        return false;
      }

      // ---------- DURATION ----------
      let durationValue = null;

      if (flight.noOfStops === "0") {
        durationValue = flight?.OutboundInboundlist?.[0]?.totaltime;
      } else if (flight.noOfStops === "1") {
        durationValue = flight?.inbwLOTime;
      } else if (flight.noOfStops === "2") {
        durationValue = flight?.inbwLOTime1;
      } else if (flight.noOfStops === "3") {
        durationValue = flight?.inbwLOTime2;
      }

      const durationHours = convertToHours(durationValue);

      const durationAllowed =
        Number(dayDurationFirstClass) >= durationHours ||
        Number(dayDurationBusinessClass) >= durationHours ||
        Number(dayDurationPremiunEcoClass) >= durationHours ||
        Number(dayDurationEconomyClass) >= durationHours;

      if (!durationAllowed) return false;

      // ---------- FINAL ----------
      return isAirline;
    });

    // ---------- MIN PRICE ----------
    const prices = filteredFlights
      .map((f) => Number(f?.price?.tarriffinfo?.[0]?.per_pax_total_price))
      .filter(Number.isFinite);

    return prices.length > 0 ? Math.min(...prices) : null;
  };

  const getMinPriceForTimeSlot = (timeSlot) => {
    const safeList = Array.isArray(listingPage1) ? listingPage1 : [];

    const filteredFlights = safeList.filter((flight) => {
      // ---------- SAFETY GUARDS ----------
      const tariff = flight?.price?.tarriffinfo?.[0];
      if (!tariff?.per_pax_total_price) return false;

      const price = Number(tariff.per_pax_total_price);
      if (!Number.isFinite(price)) return false;

      const outbound = flight?.OutboundInboundlist?.[0]?.flightlist?.[0];
      if (!outbound) return false;

      const departureTime = outbound?.Departure?.time;
      const airlineName = outbound?.MarketingAirline?.name;

      // ---------- TIME SLOT ----------
      const isAirline =
        getDepartureTimeSlot(departureTime) === timeSlot;

      // ---------- ADMIN / GUEST ----------
      if (isGuest || isAdmin) {
        return isAirline;
      }

      // ---------- AIRLINE FILTER ----------
      if (
        restrictedAirlines &&
        restrictedAirlines.includes(airlineName)
      ) {
        return false;
      }

      // ---------- WALLET ----------
      if (price > Number(walletAmount)) return false;

      // ---------- CABIN PRICE ----------
      if (
        !(
          (firstClass && price <= Number(amountFirstClass)) ||
          (businessClass && price <= Number(amountBusinessClass)) ||
          (premiumEcoClass && price <= Number(amountPremiumEcoClass)) ||
          (economyClass && price <= Number(amountEconomyClass))
        )
      ) {
        return false;
      }

      // ---------- DURATION ----------
      let durationValue = null;

      if (flight.noOfStops === "0") durationValue = flight.duration;
      if (flight.noOfStops === "1") durationValue = flight.inbwLOTime;
      if (flight.noOfStops === "2") durationValue = flight.inbwLOTime1;
      if (flight.noOfStops === "3") durationValue = flight.inbwLOTime2;

      const durationHours = convertToHours(durationValue);

      const durationAllowed =
        Number(dayDurationFirstClass) >= durationHours ||
        Number(dayDurationBusinessClass) >= durationHours ||
        Number(dayDurationPremiunEcoClass) >= durationHours ||
        Number(dayDurationEconomyClass) >= durationHours;

      if (!durationAllowed) return false;

      // ---------- FINAL ----------
      return isAirline;
    });

    // ---------- MIN PRICE ----------
    const prices = filteredFlights
      .map((f) => Number(f?.price?.tarriffinfo?.[0]?.per_pax_total_price))
      .filter(Number.isFinite);

    return prices.length > 0 ? Math.min(...prices) : null;
  };

  const getDepartureTimeSlot = (time) => {
    if (!time || typeof time !== "string") return null;

    const [hour] = time.split(":").map(Number);

    if (hour < 6) return "before6";
    if (hour >= 6 && hour < 12) return "morning";
    if (hour >= 12 && hour < 18) return "afternoon";
    if (hour >= 18) return "evening";
    return null;
  };

  const toggleStopFilter = (noOfStops) => {
    setSelectedStopFilter(prev => prev === noOfStops ? '' : noOfStops);
    filterFlights();
  };
  const toggleAirlineFilter = (airline) => {
    if (selectedAirlines.includes(airline) && restrictedAirlines !== null && !restrictedAirlines.includes(airline)) {
      const updatedAirlines = selectedAirlines.filter(a => a !== airline);
      setSelectedAirlines(updatedAirlines);

      if (airline === "Air India") {
        setSelectedAirlineFilter('');
      }
    } else {
      const updatedAirlines = [...selectedAirlines, airline];
      setSelectedAirlines(updatedAirlines);

      if (airline === "Air India" && restrictedAirlines !== null && !restrictedAirlines.includes(airline)) {
        setSelectedAirlineFilter('Air India');
      }
    }
  };
  const toggleTimeSlotFilter = (timeSlot) => {
    setSelectedTimeSlotFilter(prev => prev === timeSlot ? '' : timeSlot);
  };
  const appliedFilters = {
    stops: selectedStopFilter,
    stopsRound: selectedStopFilterRound,
    airline: selectedAirlineFilter,
    timeSlot: selectedTimeSlotFilter,
    arrivalslot: selectedArrivalTimeSlotFilter,
    price: selectedPriceRange,
    duration: selectedDurationRange
  };
  const removeFilter = (filterKey) => {
    if (filterKey === "price") {
      setSelectedPriceRange([minPrice, maxPrice]);
      setFromPrice(minPrice);
      setToPrice(maxPrice);
    } else if (filterKey === "duration") {
      setSelectedDurationRange([minDuration, maxDuration]);
      setFromDuration(minDuration);
      setToDuration(maxDuration);
    } else if (filterKey === "stops") {
      setSelectedStops([]);
      setSelectedStopFilter('');
    } else if (filterKey === "stopsRound") {
      setSelectedStopsRound([]);
      setSelectedStopFilterRound('');
    } else if (filterKey === "airline") {
      setSelectedAirlines([]);
      setSelectedAirlineFilter('');
    } else if (filterKey === "timeSlot") {
      setSelectedTimeSlotFilter('');
      setSelectedDepartureTimeSlot('');
    } else if (filterKey === "arrivalslot") {
      setSelectedArrivalTimeSlotFilter('');
      setSelectedArrivalTimeSlot('');
    }
  };
  const clearAllFilters = () => {
    setSelectedAirlines([]);
    setSelectedStops([]);
    setSelectedStopFilter('');
    setSelectedStopsRound([]);
    setSelectedStopFilterRound('');
    setSelectedAirlineFilter('');
    setSelectedTimeSlotFilter('');
    setSelectedArrivalTimeSlotFilter('');
    setSelectedDepartureTimeSlot('');
    setSelectedArrivalTimeSlot('');
    setSelectedReturnDepartureTimeSlot('');
    setSelectedReturnArrivalTimeSlot('');
    setApplyStopsOnward(false);
    setApplyStopsReturn(false);
    setSelectedPriceRange([minPrice, maxPrice]);
    setFromPrice(minPrice);
    setToPrice(maxPrice);
    setSelectedDurationRange([minDuration, maxDuration]);
    setFromDuration(minDuration);
    setToDuration(maxDuration);
    setTimeout(() => {
      filterFlights();
    }, 0);
  };
  const [isSearchTriggered, setIsSearchTriggered] = useState(false);

  const goToDate = (theDate) => {
    const utcDate = new Date(Date.UTC(theDate.getFullYear(), theDate.getMonth(), theDate.getDate()));
    setStartDate(utcDate);
    setIsSearchTriggered(true);
  };

  useEffect(() => {
    if (isSearchTriggered) {
      searchButton();
      setIsSearchTriggered(false);
    }
  }, [startDate, isSearchTriggered]);
  useEffect(() => {
    const selectedFlight = listingPage.find((f) => f);
    if (!selectedFlight) return;

    setSelectedDeparture(selectedFlight.depCode);

    let destination;
    if (tripType === "1") {
      destination =
        selectedFlight.noOfStops === "0" ? selectedFlight.arrCode :
          selectedFlight.noOfStops === "1" ? selectedFlight.lOlocationArr :
            selectedFlight.noOfStops === "2" ? selectedFlight.lOlocationArr1 :
              selectedFlight.lOlocationArr2;
    } else if (tripType === "2") {
      destination =
        selectedFlight.retnoOfStops === "0" ? selectedFlight.retarrCode :
          selectedFlight.retnoOfStops === "1" ? selectedFlight.retLOlocationArr :
            selectedFlight.retnoOfStops === "2" ? selectedFlight.retLOlocationArr1 :
              selectedFlight.retLOlocationArr2;
    } else if (tripType === "3") {
      destination =
        selectedFlight.noOfStops3 === "0" ? selectedFlight.arrCode3 :
          selectedFlight.noOfStops3 === "1" ? selectedFlight.lOlocationArr3 :
            selectedFlight.noOfStops3 === "2" ? selectedFlight.lOlocationArr31 :
              selectedFlight.lOlocationArr32;
    }

    setSelectedDestination(destination);
  }, [listingPage, tripType]);


  const filterFlights = () => {
    const filteredFlights = listingPage1.filter(f => {
      // Get flight price from listingPage1 structure
      const flightPrice = parseInt(Math.round(f.price?.tarriffinfo?.[0]?.per_pax_total_price || 0));

      // Get airline name from listingPage1 structure
      const airline = f.OutboundInboundlist?.[0]?.flightlist?.[0]?.MarketingAirline?.name;

      // Get departure time from listingPage1 structure
      const departureTime = f.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.time;
      const departureHour = departureTime ? parseInt(departureTime.split(':')[0], 10) : null;

      // Calculate number of stops from flightlist length
      const noOfStops = f.OutboundInboundlist?.[0]?.flightlist?.length > 1
        ? String(f.OutboundInboundlist[0].flightlist.length - 1)
        : "0";

      // Get return stops for round trip
      const retnoOfStops = tripType === "2" && f.OutboundInboundlist?.[1]?.flightlist
        ? (f.OutboundInboundlist[1].flightlist.length > 1
          ? String(f.OutboundInboundlist[1].flightlist.length - 1)
          : "0")
        : null;

      // Get arrival time based on trip type
      let arrivalTime = null;
      let arrivalHour = null;
      if (tripType === "1") {
        const lastFlight = f.OutboundInboundlist?.[0]?.flightlist?.[f.OutboundInboundlist[0].flightlist.length - 1];
        arrivalTime = lastFlight?.Arrival?.time;
        arrivalHour = arrivalTime ? parseInt(arrivalTime.split(':')[0], 10) : null;
      } else if (tripType === "2") {
        const returnLastFlight = f.OutboundInboundlist?.[1]?.flightlist?.[f.OutboundInboundlist[1].flightlist.length - 1];
        arrivalTime = returnLastFlight?.Arrival?.time;
        arrivalHour = arrivalTime ? parseInt(arrivalTime.split(':')[0], 10) : null;
      }

      // Calculate flight duration from totaltime (in minutes)
      let flightDuration = null;
      if (tripType === "1" && f.OutboundInboundlist?.[0]?.totaltime) {
        flightDuration = convertToHours(f.OutboundInboundlist[0].totaltime);
      }

      // Calculate eligible duration
      const totaltime = f.OutboundInboundlist?.[0]?.totaltime || 0;
      const eligibleduration = convertToHours(totaltime);

      const eligibleduration2 = tripType === "2" || tripType === "3"
        ? (f.OutboundInboundlist?.[1]?.totaltime
          ? convertToHours(f.OutboundInboundlist[1].totaltime)
          : 0)
        : 0;

      const dayduration1 = parseInt(dayDurationFirstClass) >= eligibleduration
        || parseInt(dayDurationBusinessClass) >= eligibleduration
        || parseInt(dayDurationPremiunEcoClass) >= eligibleduration
        || parseInt(dayDurationEconomyClass) >= eligibleduration
        ;

      const dayduration2 = tripType === "2" || tripType === "3" ? (parseInt(dayDurationFirstClass) >= eligibleduration2
        || parseInt(dayDurationBusinessClass) >= eligibleduration2
        || parseInt(dayDurationPremiunEcoClass) >= eligibleduration2
        || parseInt(dayDurationEconomyClass) >= eligibleduration2
      ) : true;

      // Fix: Define eligibleduration3 correctly for tripType "3"
      let eligibleduration3 = 0;
      if (tripType === "3" && f.OutboundInboundlist?.[2]?.totaltime) {
        eligibleduration3 = convertToHours(f.OutboundInboundlist[2].totaltime);
      }
      const dayduration3 = tripType === "3" ? (
        parseInt(dayDurationFirstClass) >= eligibleduration3
        || parseInt(dayDurationBusinessClass) >= eligibleduration3
        || parseInt(dayDurationPremiunEcoClass) >= eligibleduration3
        || parseInt(dayDurationEconomyClass) >= eligibleduration3
      ) : true;

      const dayduration = dayduration1 && dayduration2 && dayduration3;

      const eligiblePrice = parseInt(amountFirstClass) >= flightPrice
        || parseInt(amountBusinessClass) >= flightPrice
        || parseInt(amountPremiumEcoClass) >= flightPrice
        || parseInt(amountEconomyClass) >= flightPrice
        ;

      const matchesPriceRange = fromPrice === Infinity ? true : flightPrice >= fromPrice && flightPrice <= toPrice;

      const matchesDurationRange = fromDuration === Infinity ? true : tripType === "1" ? flightDuration >= fromDuration
        && flightDuration <= toDuration : true;

      const matchesDepartureTimeSlot = selectedDepartureTimeSlot
        ? (selectedDepartureTimeSlot === 'before6' && departureHour < 6) ||
        (selectedDepartureTimeSlot === 'morning' && departureHour >= 6 && departureHour < 12) ||
        (selectedDepartureTimeSlot === 'afternoon' && departureHour >= 12 && departureHour < 18) ||
        (selectedDepartureTimeSlot === 'evening' && departureHour >= 18)
        : true;

      const matchesArrivalTimeSlot = selectedArrivalTimeSlot
        ? (selectedArrivalTimeSlot === 'before6' && arrivalHour < 6) ||
        (selectedArrivalTimeSlot === 'morning' && arrivalHour >= 6 && arrivalHour < 12) ||
        (selectedArrivalTimeSlot === 'afternoon' && arrivalHour >= 12 && arrivalHour < 18) ||
        (selectedArrivalTimeSlot === 'evening' && arrivalHour >= 18)
        : true;

      // Stops filter (outbound)
      const matchesStops = selectedStopFilter
        ? selectedStopFilter.split(',').includes(noOfStops)
        : true;

      // Round trip stops filter (inbound)
      const matchesStopsRound = selectedStopFilterRound && retnoOfStops !== null
        ? selectedStopFilterRound.split(',').includes(retnoOfStops)
        : true;

      // Airline filter
      const matchesAirline = airline && (restrictedAirlines === null || !restrictedAirlines.includes(airline))
        ? (selectedAirlines.length > 0 ? selectedAirlines.includes(airline) : true)
        : false;

      // Time slot filter
      const timeSlot = departureTime ? getDepartureTimeSlot(departureTime) : null;
      const matchesTimeSlotFilter =
        tripType === "2"
          ? true // for round-trip, use separate onward/return time-slot filters only
          : (selectedTimeSlotFilter && timeSlot
            ? timeSlot === selectedTimeSlotFilter
            : true);

      // Arrival time slot filter
      const arrivalTimeSlot = arrivalTime ? getDepartureTimeSlot(arrivalTime) : null;
      const matchesArrivalTimeSlotFilter = selectedArrivalTimeSlotFilter && arrivalTimeSlot
        ? arrivalTimeSlot === selectedArrivalTimeSlotFilter
        : true;

      // Return journey time slot filters (for round trip)
      let returnDepartureTime = null;
      let returnArrivalTime = null;
      let returnDepartureHour = null;
      let returnArrivalHour = null;

      if (tripType === "2" && f.OutboundInboundlist?.[1]) {
        const returnFirstFlight = f.OutboundInboundlist[1]?.flightlist?.[0];
        const returnLastFlight = f.OutboundInboundlist[1]?.flightlist?.[f.OutboundInboundlist[1].flightlist.length - 1];
        returnDepartureTime = returnFirstFlight?.Departure?.time;
        returnArrivalTime = returnLastFlight?.Arrival?.time;
        returnDepartureHour = returnDepartureTime ? parseInt(returnDepartureTime.split(':')[0], 10) : null;
        returnArrivalHour = returnArrivalTime ? parseInt(returnArrivalTime.split(':')[0], 10) : null;
      }

      const matchesReturnDepartureTimeSlot = tripType === "2" && selectedReturnDepartureTimeSlot
        ? (selectedReturnDepartureTimeSlot === 'before6' && returnDepartureHour < 6) ||
        (selectedReturnDepartureTimeSlot === 'morning' && returnDepartureHour >= 6 && returnDepartureHour < 12) ||
        (selectedReturnDepartureTimeSlot === 'afternoon' && returnDepartureHour >= 12 && returnDepartureHour < 18) ||
        (selectedReturnDepartureTimeSlot === 'evening' && returnDepartureHour >= 18)
        : true;

      const matchesReturnArrivalTimeSlot = tripType === "2" && selectedReturnArrivalTimeSlot
        ? (selectedReturnArrivalTimeSlot === 'before6' && returnArrivalHour < 6) ||
        (selectedReturnArrivalTimeSlot === 'morning' && returnArrivalHour >= 6 && returnArrivalHour < 12) ||
        (selectedReturnArrivalTimeSlot === 'afternoon' && returnArrivalHour >= 12 && returnArrivalHour < 18) ||
        (selectedReturnArrivalTimeSlot === 'evening' && returnArrivalHour >= 18)
        : true;

      // Wallet amount check
      const isflight = isGuest ? true : isAdmin ? true : flightPrice <= parseInt(walletAmount);

      return matchesPriceRange && matchesDurationRange && matchesDepartureTimeSlot && matchesArrivalTimeSlotFilter &&
        matchesArrivalTimeSlot && matchesStops && matchesAirline && matchesTimeSlotFilter && dayduration && eligiblePrice
        && matchesStopsRound && isflight && matchesReturnDepartureTimeSlot && matchesReturnArrivalTimeSlot;
    });
    // Sort by price
    return filteredFlights.sort((a, b) => {
      const priceA = parseInt(Math.round(a.price?.tarriffinfo?.[0]?.per_pax_total_price || 0));
      const priceB = parseInt(Math.round(b.price?.tarriffinfo?.[0]?.per_pax_total_price || 0));
      return priceA - priceB;
    });
  };
  useEffect(() => {
    if (!isFlightValid) {
      const isFlightValid1 = listingPage.filter(flight => {
        if (isGuest ? true : isAdmin ? true : (restrictedAirlines !== null &&
          !restrictedAirlines.includes(flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name) &&
          ((firstClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountFirstClass, 10)) ||
            (businessClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountBusinessClass, 10)) ||
            (premiumEcoClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountPremiumEcoClass, 10)) ||
            (economyClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountEconomyClass, 10))) &&
          flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount) &&
          (tripType === "1" || tripType === "2" || tripType === "3") ? flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount) &&
        (flight.noOfStops === "0" ?
          (parseInt(dayDurationFirstClass) >= convertToHours(flight.duration) ||
            parseInt(dayDurationBusinessClass) >= convertToHours(flight.duration) ||
            parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.duration) ||
            parseInt(dayDurationEconomyClass) >= convertToHours(flight.duration)) :
          ((flight.noOfStops === "1" ? (
            parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime) ||
            parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime) ||
            parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime) ||
            parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime)) :
            flight.noOfStops === "2" ? (
              parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime1) ||
              parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime1) ||
              parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime1) ||
              parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime1)) :
              (parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime2) ||
                parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime2) ||
                parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime2) ||
                parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime2)))))
          : (tripType === "2" || tripType === "3") ? flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount) && (restrictedAirlines !== null
            && !restrictedAirlines.includes(flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name) && flight.retmarketingCompany !== null
            && !restrictedAirlines.includes(flight.OutboundInboundlist[1].flightlist[0].MarketingAirline.name)
            && flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name === flight.OutboundInboundlist[1].flightlist[0].MarketingAirline.name
            && ((firstClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountFirstClass, 10))
              || (businessClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountBusinessClass, 10))
              || (premiumEcoClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountPremiumEcoClass, 10))
              || (economyClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountEconomyClass, 10)))
            && (flight.retnoOfStops === "0" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.retduration)
              || parseInt(dayDurationBusinessClass) >= convertToHours(flight.retduration)
              || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.retduration)
              || parseInt(dayDurationEconomyClass) >= convertToHours(flight.retduration))
              : (flight.retnoOfStops === "1" ?
                (parseInt(dayDurationFirstClass) >= convertToHours(flight.retinbwLOTime)
                  || parseInt(dayDurationBusinessClass) >= convertToHours(flight.retinbwLOTime)
                  || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.retinbwLOTime)
                  || parseInt(dayDurationEconomyClass) >= convertToHours(flight.retinbwLOTime)) :
                flight.retnoOfStops === "2" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.retinbwLOTime1)
                  || parseInt(dayDurationBusinessClass) >= convertToHours(flight.retinbwLOTime1)
                  || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.retinbwLOTime1)
                  || parseInt(dayDurationEconomyClass) >= convertToHours(flight.retinbwLOTime1)) :
                  (parseInt(dayDurationFirstClass) >= convertToHours(flight.retinbwLOTime2)
                    || parseInt(dayDurationBusinessClass) >= convertToHours(flight.retinbwLOTime2)
                    || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.retinbwLOTime2)
                    || parseInt(dayDurationEconomyClass) >= convertToHours(flight.retinbwLOTime2)))))
            : (tripType === "3") ? flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(walletAmount) && (restrictedAirlines !== null && flight.marketingCompany3 !== null
              && !restrictedAirlines.includes(flight.marketingCompany3?.split('|')[1])
              && ((firstClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountFirstClass, 10))
                || (businessClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountBusinessClass, 10))
                || (premiumEcoClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountPremiumEcoClass, 10))
                || (economyClass && flight.price.tarriffinfo[0].per_pax_total_price <= parseInt(amountEconomyClass, 10)))
              && (flight.noOfStops3 === "0" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.duration3)
                || parseInt(dayDurationBusinessClass) >= convertToHours(flight.duration3)
                || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.duration3)
                || parseInt(dayDurationEconomyClass) >= convertToHours(flight.duration3))
                : (flight.noOfStops3 === "1" ? (parseInt(parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime3)
                  || dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime3)
                  || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime3)
                  || parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime3)) :
                  flight.noOfStops3 === "2" ? (parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime31)
                    || parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime31)
                    || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime31)
                    || parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime31)) :
                    (parseInt(dayDurationFirstClass) >= convertToHours(flight.inbwLOTime32)
                      || parseInt(dayDurationBusinessClass) >= convertToHours(flight.inbwLOTime32)
                      || parseInt(dayDurationPremiunEcoClass) >= convertToHours(flight.inbwLOTime32)
                      || parseInt(dayDurationEconomyClass) >= convertToHours(flight.inbwLOTime32))))) : false)
        ) {
          return true;
        }
        return false;
      });
      setIsFlightValid(isFlightValid1.length > 0 ? true : false);
    }
  }, [listingPage]);

  const swapValues = () => {
    const dept = departure;
    const deptiata = departureIataCode;
    setDeparture(destination);
    setDepartureIataCode(destinationIataCode);
    setDestination(dept);
    setDestinationIataCode(deptiata);
  };
  const filteredFlights = filterFlights();
  const nonStopPrice = getMinPriceForNoOfStops("0", "1");
  const oneStopPrice = getMinPriceForNoOfStops("1", "1");
  const moreStopsPrice = getMinPriceForNoOfStops("2", "1");
  const nonStopPriceRound = tripType === "2" ? getMinPriceForNoOfStops("0", "2") : 0;
  const oneStopPriceRound = tripType === "2" ? getMinPriceForNoOfStops("1", "2") : 0;
  const moreStopsPriceRound = tripType === "2" ? getMinPriceForNoOfStops("2", "2") : 0;

  const airlinesDetails = getAirlinesWithDetails();
  const isPriceChanged = appliedFilters.price[0] !== fromPrice || appliedFilters.price[1] !== toPrice;
  const isDurationChanged = tripType === "1" ? appliedFilters.duration[0] !== fromDuration || appliedFilters.duration[1] !== parseInt(toDuration, 10) : false;
  const isAnyFilterApplied =
    appliedFilters.stops || appliedFilters.stopsRound || appliedFilters.arrivalslot ||
    appliedFilters.airline || appliedFilters.timeSlot ||
    isPriceChanged || isDurationChanged;
  useEffect(() => {
    if (!listingPage1 || listingPage1.length === 0) return;
    const prices = listingPage1.map(flight => parseInt(Math.round(flight.price?.tarriffinfo?.[0]?.per_pax_total_price || 0), 10));
    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);
    setFromPrice(Math.min(...prices));
    setToPrice(Math.max(...prices));
    setSelectedPriceRange([minPrice, maxPrice]);
    const allD = listingPage1.flatMap(flight => {
      if (tripType === "1") {
        const totaltime = flight.OutboundInboundlist?.[0]?.totaltime;
        if (totaltime) {
          const durationHours = convertToHours(totaltime);
          if (parseInt(dayDurationFirstClass) >= durationHours
            || parseInt(dayDurationBusinessClass) >= durationHours
            || parseInt(dayDurationPremiunEcoClass) >= durationHours
            || parseInt(dayDurationEconomyClass) >= durationHours
          ) {
            return [durationHours];
          }
        }
        return [];
      }
      else {
        return [];
      }
    });
    if (allD.length > 0) {
      const min = Math.min(...allD);
      const max = Math.max(...allD);
      setFromDuration(min);
      setToDuration(max);
      setSelectedDurationRange([min, max]);
    }
  }, [listingPage1]);
  const hasPopularFilters = listingPage1.some(flight =>
    getMinPriceForNoOfStops('0', "1") > 0 ||
    getMinPriceForTimeSlot('morning') > 0 ||
    (restrictedAirlines !== null && !restrictedAirlines.includes(flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name))
  );
  const [pricingOption, setPricingOption] = useState([]);
  const [newpricingOption, setNewPricingOption] = useState([]);
  const [pricingFlight, setPricingFlight] = useState({});
  const [addtoCartFlight, setAddtoCartFlight] = useState([]);
  const [pricesModal, setPricesModal] = useState(false);
  const [pricesModal1, setPricesModal1] = useState(false);
  const [pricesModal2, setPricesModal2] = useState(false);

  const [activePriceModal, setActivePriceModal] = useState(null);
  const [slideIndex, setSlideIndex] = useState(0);
  const ITEMS_PER_SLIDE = 1;
  const VISIBLE_SLIDES = 3;
  const maxIndex = pricingOption.length - VISIBLE_SLIDES;
  const handleNext = () => {
    setSlideIndex((prev) => Math.min(prev + 1, maxIndex));
  };

  const handlePrev = () => {
    setSlideIndex((prev) => Math.max(prev - 1, 0));
  };
  useEffect(() => {
    if (activePriceModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [activePriceModal]);



  // Inside your component where the Modal is rendered:

  // If any price modal is open, prevent body scroll. Otherwise allow scroll.

  // null | "ONE_WAY" | "ROUND_TRIP" | "MULTI_CITY"




  const handlePricing = async (flight) => {
    if (isGuest ? false : isAdmin ? false : (parseInt(Math.round(flight.price.tarriffinfo[0].per_pax_total_price)) > parseInt(walletAmount))) {
      await Swal.fire({
        icon: 'warning',
        title: 'Restricted',
        text: 'Can not proceed. Restricted.'
      });
      return;
    }
    try {

      const response = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/getFlightPricing`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + bearerToken,
        },
        body: JSON.stringify(flight),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('bearerToken');
          localStorage.removeItem('policies');
          sessionStorage.removeItem('policies');
          localStorage.removeItem('user');
          sessionStorage.clear();
          window.location.href = '/login';
        }
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
      const result = await response.json();
      if (result) {
        setAddtoCartFlight(result);
        setPricingFlight(flight);
        // if (selectedtripType === "1") {
        //   setPricesModal(true);
        // }
        // if (selectedtripType === "2") {
        //   setPricesModal1(true); 
        // }
        // if (selectedtripType === "3") {
        //   setPricesModal2(true);
        // }
        if (selectedtripType === "1") setActivePriceModal("ONE_WAY");
        if (selectedtripType === "2") setActivePriceModal("ROUND_TRIP");
        if (selectedtripType === "3") setActivePriceModal("MULTI_CITY");
        setUpsellloading(false);
      }
      else {
        await Swal.fire({
          icon: 'warning',
          title: 'No Fare Available',
          text: 'NO FARE FOR BOOKING CODE-TRY OTHER PRICING OPTIONS'
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setUpsellloading(false);
    }
  };

  const handleUpsellPricing = async (flight) => {
    console.log("search id", searchID);
    const price = Math.round(
      flight?.price?.tarriffinfo?.[0]?.per_pax_total_price
    );

    if (!isGuest && !isAdmin && price > parseInt(walletAmount)) {
      await Swal.fire({
        icon: 'warning',
        title: 'Insufficient Wallet Balance',
        text: 'Cannot proceed. You do not have sufficient wallet balance for this booking.',
      });
      return;
    }

    setUpsellloading(true);

    try {
      const payload = {
        sc: searchID,
        id: flight?.id
      };
      console.log("payload", payload)

      // const response = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/Fare_PriceUpsellWithoutPNR`, {
      const response = await fetch(`${baseUrl}api/Flight/Fare_PriceUpsellWithoutPNR`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + bearerToken,
        },
        body: JSON.stringify(payload),
        
      });

      if (!response.ok) {
        setUpsellloading(false);

        if (response.status === 401) {
          localStorage.removeItem("bearerToken");
          localStorage.removeItem("policies");
          sessionStorage.removeItem("policies");
          localStorage.removeItem("user");
          sessionStorage.clear();
          window.location.href = "/login";
          return;
        }

        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      console.log("Upsellpricing", result)
      const pricingData = result?.Data;

      console.log("price result", pricingData);

      setPricingFlight(flight);

      if (pricingData.length > 0) {

        setPricingOption(pricingData);

        if (selectedtripType === "1") setActivePriceModal("ONE_WAY");
        if (selectedtripType === "2") setActivePriceModal("ROUND_TRIP");
        if (selectedtripType === "3") setActivePriceModal("MULTI_CITY");
      } else {
        AddToCart(flight)
      }

      setUpsellloading(false);
    } catch (error) {
      setUpsellloading(false);
      console.error('Error fetching data:', error);
    }
  };


  // const AddToCart = async (index, frmData) => {
  const AddToCart = async (flight) => {
    const payload = {
      sc: searchID,
      id: flight?.id,
    };

    // Convert payload to query string
    const queryString = new URLSearchParams(payload).toString();

    // Navigate to pricing page with payload as params
    navigate(`/pricing?${queryString}`, { replace: true });

    setUpsellloading(false);

    // index = frmData === 'upsell' ? index : 0;
    // if (frmData === "standard") {
    //   handlePricing(pricingFlight);
    // }
    // if (frmData === "upsell") {
    //   if (pricingOption[index].typequalifier?.split('|')[1] === "") {
    //     alert("NO FARE FOR BOOKING CODE-TRY OTHER PRICING OPTIONS");
    //     return;
    //   }
    // }
    // if (pricingOption.length > 0) {
    //   if (Math.round(pricingOption[index].amount).toString() === "") {
    //     alert("NO FARE FOR BOOKING CODE-TRY OTHER PRICING OPTIONS");
    //     return;
    //   }
    //   if (Math.round(pricingOption[index].taxamount).toString() === "") {
    //     alert("NO FARE FOR BOOKING CODE-TRY OTHER PRICING OPTIONS");
    //     return;
    //   }
    //   if (pricingOption[index].farebasis === null) {
    //     alert("NO FARE FOR BOOKING CODE-TRY OTHER PRICING OPTIONS");
    //     return;
    //   }
    //   if (pricingOption[index].farebasis?.split('|')[1] === "") {
    //     alert("NO FARE FOR BOOKING CODE-TRY OTHER PRICING OPTIONS");
    //     return;
    //   }
    // }
    // try {
    //   const payload = {
    //     sf: pricingFlight,
    //     nd: [{
    //       ...pricingFlight,
    //       sessionData: frmData === 'standard' ? addtoCartFlight.sessionData : pricingOption[index].sessionData,
    //       bookingClass: frmData === 'standard' ? addtoCartFlight.bookingClass : pricingOption[index].typequalifier?.split('|')[1],
    //       amount: frmData === 'standard' ? Math.round(addtoCartFlight.amount).toString() : Math.round(pricingOption[index].amount).toString(),
    //       taxamount: frmData === 'standard' ? Math.round(addtoCartFlight.taxamount).toString() : Math.round(pricingOption[index].taxamount).toString(),
    //       loText: frmData === 'standard' ? addtoCartFlight.loText : pricingOption[index].farebasis?.split('|')[1],
    //       freeText: frmData === 'standard' ? addtoCartFlight.freeText : addtoCartFlight.freeText + " | MiniRules: " + pricingOption[index].miniRule
    //     }]
    //   };

    //   const payload =  {
    //     sc: searchID,
    //     id: pricingFlight?.id
    //   };
    //     //  const response = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/AddToCart`, {
    //      const response = await fetch(`${baseUrl}api/Flight/FlightDetail`, {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //         // 'Authorization': 'Bearer ' + bearerToken,
    //       },
    //       body: JSON.stringify(payload),
    //     });
    //     if (!response.ok) {
    //       setUpsellloading(false);
    //       if (response.status === 401) {
    //         localStorage.removeItem('bearerToken');
    //         localStorage.removeItem('policies');
    //         sessionStorage.removeItem('policies');
    //         localStorage.removeItem('user');
    //         sessionStorage.clear();
    //         window.location.href = '/login';
    //       }
    //       throw new Error(`Error ${response.status}: ${response.statusText}`);
    //     }

    //     const result = await response.json();
    //     console.log(" new result",result)
    //     if (response.status === 200) {
    //       setUpsellloading(false);
    //       navigate('/pricing', { replace: true });
    //     }
    //     else {
    //       setUpsellloading(false);
    //       alert("NO FARE FOR BOOKING CODE-TRY OTHER PRICING OPTIONS");
    //     }
    //   } catch (error) {
    //     setUpsellloading(false);
    //     console.error('Error fetching data:', error);
    //   }
    // };

    const handleDurationSliderChange = (e, type) => {
      const value = e.target.value;
      if (type === "fromDuration") {
        if (value <= toDuration) {
          setFromDuration(value);
        }
      } else if (type === "toDuration") {
        if (value >= fromDuration) {
          setToDuration(value);
        }
      }
    }
  };

  useEffect(() => {
    if (loading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [loading]);



  const [recentSearches, setRecentSearches] = useState([]);


  const modalRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current && !modalRef.current.contains(event.target) &&
        triggerRef.current && !triggerRef.current.contains(event.target)
      ) {
        setShowTravelerModal(false);
      }
    };

    if (showTravelerModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTravelerModal]);

  const handleDropdownClose = (type) => {
    if (type === "from" && searchQuery === "") setSearchQuery(previousFromValue);
    if (type === "from2" && searchQuery === "") setSearchQuery(previousFrom2Value);
    if (type === "from3" && searchQuery === "") setSearchQuery(previousFrom3Value);
    if (type === "to" && searchQuery === "") setSearchQuery(previousToValue);
    if (type === "to2" && searchQuery === "") setSearchQuery(previousTo2Value);
    if (type === "to3" && searchQuery === "") setSearchQuery(previousTo3Value);

    setShowDropdown(false);
    setShowDestinationDropdown(false);
    setShowFrom2Dropdown(false);
    setShowTo2Dropdown(false);
    setShowFrom3Dropdown(false);
    setShowTo3Dropdown(false);
  };
  const handleSearchInputChange = (e, type) => {
    const value = e.target.value;

    switch (type) {
      case "from":
        setSearchQueryFrom1(value);
        handleInputChange(e);
        break;
      case "from2":
        setSearchQueryFrom2(value);
        handleFrom2Change(e);
        break;
      case "from3":
        setSearchQueryFrom3(value);
        handleFrom3Change(e);
        break;
      case "to":
        setSearchQueryTo1(value);
        handleDestinationChange(e);
        break;
      case "to2":
        setSearchQueryTo2(value);
        handleTo2Change(e);
        break;
      case "to3":
        setSearchQueryTo3(value);
        handleTo3Change(e);
        break;
      default:
        break;
    }
  };
  const handleInputFocus = (type) => {
    switch (type) {
      case "from":
        setShowDropdown(true);
        setSearchQueryFrom1("");
        setShowDestinationDropdown(false);
        setShowFrom2Dropdown(false);
        setShowTo2Dropdown(false);
        setShowFrom3Dropdown(false);
        setShowTo3Dropdown(false);
        break;
      case "to":
        setShowDropdown(false);
        setShowDestinationDropdown(true);
        setSearchQueryTo1("");
        setShowFrom2Dropdown(false);
        setShowTo2Dropdown(false);
        setShowFrom3Dropdown(false);
        setShowTo3Dropdown(false);
        break;
      case "from2":
        setShowDropdown(false);
        setShowDestinationDropdown(false);
        setShowFrom2Dropdown(true);
        setSearchQueryFrom2("");
        setShowTo2Dropdown(false);
        setShowFrom3Dropdown(false);
        setShowTo3Dropdown(false);
        break;
      case "to2":
        setShowDropdown(false);
        setShowDestinationDropdown(false);
        setShowFrom2Dropdown(false);
        setShowTo2Dropdown(true);
        setSearchQueryTo2("");
        setShowFrom3Dropdown(false);
        setShowTo3Dropdown(false);
        break;
      case "from3":
        setShowDropdown(false);
        setShowDestinationDropdown(false);
        setShowFrom2Dropdown(false);
        setShowTo2Dropdown(false);
        setShowFrom3Dropdown(true);
        setSearchQueryFrom3("");
        setShowTo3Dropdown(false);
        break;
      case "to3":
        setShowDropdown(false);
        setShowDestinationDropdown(false);
        setShowFrom2Dropdown(false);
        setShowTo2Dropdown(false);
        setShowFrom3Dropdown(false);
        setShowTo3Dropdown(true);
        setSearchQueryTo3("");
        break;
      default:
        break;
    }

    setTimeout(() => {
      if (inputRefs[type].current) {
        inputRefs[type].current.focus();
      }
    }, 100);
  };

  const renderDropdown = (options, type, searchQuery, setSearchQuery, inputRef) => {
    return (
      <div ref={dropdownRef} className="dropdown-home-main" style={{ height: "500px", width: "270px" }}>
        <input
          type="text"
          ref={inputRef}
          placeholder={type.includes('from') ? "From" : "To"}
          id={type + "1"}
          value={searchQuery || ""}
          autoComplete="off"
          onChange={(e) => { setSearchQuery(e.target.value); handleSearchInputChange(e, type) }}
          onKeyDown={(e) => handleKeyDown(e, options, type)}
          onFocus={(e) => e.target.select()}
          className="search-bar-home text-dark"
        />

        {searchQuery.length === 0 && recentSearches.length > 0 && recentSearches.some(item => item.name && item.name.trim() !== '') && (
          <>
            <p className="headingdrops m-0">Recent Searches</p>
            <div className="headinglistsdrops">
              {recentSearches
                .filter(item => item.name && item.name.trim() !== '')
                .map((item, index) => (
                  <div
                    key={index}
                    style={{ background: index === activeIndex ? "#e0e0e0" : "white", cursor: "pointer" }}
                    onClick={() => handleOptionSelect(item, type)}
                    id={`optionr-${index}`}
                    className="droplistmain"
                  >
                    <div style={{ height: "20px", width: "20px" }}>
                      <FontAwesomeIcon icon={faPlaneDeparture} color="grey" />
                    </div>
                    <div className="flightCityCountry">
                      <p className="m-0">
                        {item.municipality}, {item.countryName}
                      </p>
                      <p className="text-muted" style={{ fontSize: "11px", fontWeight: "300" }}>
                        {item.name}
                      </p>
                    </div>
                    <div className="text-muted">
                      {item.iata_code}
                    </div>
                  </div>
                ))}
            </div>
          </>
        )}

        {searchQuery.length === 0 && popularCities.length > 0 && (
          <>
            <p className="headingdrops m-0">Popular Cities</p>
            <div className="headinglistsdrops">
              {popularCities.map((option, index) => (
                <div key={index}
                  className={index === activeIndex ? "active" : ""}
                  style={{ background: index === activeIndex ? "#e0e0e0" : "white", cursor: "pointer" }}
                  onClick={() => handleOptionSelect(option, type)} id={`optionp-${index}`}>
                  <div key={index} onClick={() => handleOptionSelect(option, type)} id={`optionp-${index}`} className="droplistmain">
                    <div style={{ height: "20px", width: "20px" }}>
                      <FontAwesomeIcon icon={faPlaneDeparture} color="grey" />
                    </div>
                    <div className="flightCityCountry">
                      <p className="m-0">
                        {option.municipality}, {option.countryName}
                      </p>
                      <p className="text-muted" style={{ fontSize: "11px", fontWeight: "300" }}>
                        {option.name}
                      </p>
                    </div>
                    <div className="text-muted">
                      {option.iata_code}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

{searchQuery.length > 0 && options.length > 0 && (
                    <>
                        <p className="headingdrops m-0">Search Results</p>
                        <div className="headinglistsdrops">
                            {options.map((option, index) => (
                                <div
                                    key={index}
                                    className={`${index === activeIndex ? "active" : ""}`}
                                    id={`option-${index}`}
                                    style={{
                                        background: index === activeIndex ? "#e0e0e0" : "white",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => handleOptionSelect(option, type)}
                                >
                                    <div className="droplistmain">
                                        <div style={{ height: "20px", width: "20px" }}>
                                            <FontAwesomeIcon icon={faPlaneDeparture} color="grey" />
                                        </div>

                                        <div className="flightCityCountry">
                                            <p className="m-0">
                                                {option.City}, {option.Country}
                                            </p>

                                            <p className="text-muted" style={{ fontSize: "10px", fontWeight: "300" }}>
                                                {option.AirportName}
                                            </p>
                                        </div>

                                        <div className="text-muted">
                                            {option.AirportCode}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
      </div>
    );
  };

  return (
    <>
      <div id="root"></div>
      <div className='Container-fluid listingStickyform'>
        <div className="flight-search-container-listing">
          <div className="flight-options-container">
            <div className="flight-options1 flight-options1-listing text-white">
              <label className="">
                <input
                  type="radio"
                  name="trip-type"
                  checked={selectedtripType === "1"}
                  onChange={() => handleTripTypeChange('1')} /> One Way
              </label>
              <label>
                <input type="radio" name="trip-type" checked={selectedtripType === "2"}
                  onChange={() => handleTripTypeChange('2')} /> Round Trip
              </label>
              <label>
                <input type="radio" name="trip-type" checked={selectedtripType === "3"}
                  onChange={() => handleTripTypeChange('3')} /> Multi-city
              </label>
            </div>
            <div className="flight-options2">
              <select name="currency" id="currency" value={selectedcurrency} onChange={(e) => setSelectedCurrency(e.target.value)}>
                <option value="INR">INR</option>
                {/* <option value="AED">AED</option>
                <option value="EUR">EUR</option> */}
                {/* <option value="USD">USD</option> */}
              </select>
              {/* <select
                name="fareType"
                id="fareType"
                value={fareType}
                onChange={(e) => setFareType(e.target.value)}
                onMouseOut={() => setTooltip("")}
              >
                {fareTypeoptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    onMouseOver={() => setTooltip(option.description)}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
              {tooltip && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    backgroundColor: "#333",
                    color: "#fff",
                    padding: "5px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    marginTop: "5px",
                  }}
                >
                  {tooltip}
                </div>
              )}
              <select name="isNRF" id="isNRF" value={isNRF} onChange={(e) => setIsNRF(e.target.value)}>
                <option value="0">All</option>
                <option value="1">Refundable</option>
                <option value="2">Non-Refundable</option>
              </select> */}
            </div>
          </div>
          <div className="flight-search-listing">
            <div className="input-wrapper listinginputfromtoBox">
              <label htmlFor="from">From</label>
              <div>

                <input
                  type="text"
                  id="from"
                  value={departure ? departure?.split(",")[2] : ""}
                  autoComplete="off"
                  className="metropolis-bold"
                  onFocus={(e) => {
                    setShowDropdown(true);
                    setShowDestinationDropdown(false);
                    setShowFrom2Dropdown(false);
                    setShowTo2Dropdown(false);
                    setShowFrom3Dropdown(false);
                    setShowTo3Dropdown(false);
                    handleInputFocus("from");
                  }}
                  onKeyDown={(e) => handleKeyDown(e, departureOptions, 'from')}
                  placeholder="Select City"
                  onChange={handleInputChange}
                />
              </div>
              {showDropdown && renderDropdown(departureOptions, 'from', searchQueryFrom1, setSearchQueryFrom1, inputRefs.from)}
            </div>
            <div className="swap-icon-listing">
              <button type="button" onClick={swapValues}><img src="./assets/images/swapImg.png" alt="" className="" /></button>
            </div>
            <div className="input-wrapper listinginputfromtoBox">
              <label htmlFor="to">To</label>
              <div>
                <input type="text" id="to"
                  value={destination ? destination?.split(",")[2] : ""}
                  placeholder="Select City"
                  autoComplete="off"
                  onKeyDown={(e) => handleKeyDown(e, destinationOptions, 'to')}
                  onChange={handleDestinationChange}
                  className="metropolis-bold"
                  onFocus={(e) => {
                    setShowDropdown(false);
                    setShowDestinationDropdown(true);
                    setShowFrom2Dropdown(false);
                    setShowTo2Dropdown(false);
                    setShowFrom3Dropdown(false);
                    setShowTo3Dropdown(false);
                    handleInputFocus("to");
                  }}
                />
              </div>
              {showDestinationDropdown && renderDropdown(destinationOptions, 'to', searchQueryTo1, setSearchQueryTo1, inputRefs.to)}
            </div>
            <div className="input-group smallwidthBoxes-listing">
              <label className="custom-label-listing">Depart</label>
              <DatePicker
                selected={startDate}
                onChange={date => {
                  setStartDate(date);
                  // Update segmentdata when departure date changes
                  if (date && segmentdata.length > 0) {
                    const formattedDate = date.toISOString().split('T')[0];
                    setsegmentdata((prev) => {
                      const updated = [...prev];
                      if (updated[0]) {
                        updated[0] = { ...updated[0], depdate: formattedDate };
                      }
                      return updated;
                    });
                  }
                }}
                placeholderText="Select Date"
                dateFormat="EEE, dd MMM yy"
                className="date-input testDrop-listing"
                minDate={new Date()}
              />
            </div>
            <div className="input-group smallwidthBoxes-listing">
              <label htmlFor="return" className="custom-label-listing">Return</label>
              <DatePicker
                ref={datePickerRef}
                selected={returnDate}
                onChange={(date) => {
                  setReturnDate(date);
                  setSelectedtripType("2");
                  // Update segmentdata when return date changes
                  if (date && segmentdata.length > 0) {
                    const formattedDate = date.toISOString().split('T')[0];
                    setsegmentdata((prev) => {
                      const updated = [...prev];
                      // If second segment doesn't exist, create it
                      if (updated.length === 1) {
                        const firstSeg = updated[0];
                        const returnSeg = {
                          depcode: firstSeg.arrcode || '',
                          arrcode: firstSeg.depcode || '',
                          depdate: formattedDate,
                        };
                        updated.push(returnSeg);
                      } else if (updated[1]) {
                        // Update existing second segment
                        updated[1] = { ...updated[1], depdate: formattedDate };
                      }
                      return updated;
                    });
                  }
                }}
                dateFormat="EEE, dd MMM yy"
                className="date-input testDrop-listing"
                minDate={startDate}
                maxDate={startDate ? new Date(startDate.getTime() + 360 * 24 * 60 * 60 * 1000) : null}
              />
              <p
                className={`return-text `}
                style={{ top: "10px", fontSize: "15px", textAlign: "left", paddingLeft: "10px", cursor: "pointer", position: "absolute", color: "white", fontWeight: "600" }}
                onClick={() => {
                  setSelectedtripType("2");
                  if (!returnDate && startDate) {
                    setReturnDate(new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000));
                  }
                  if (datePickerRef.current) {
                    datePickerRef.current.setFocus();
                  }
                }}
              >
                {returnDate
                  ? " "
                  : "Select Return Date"}
              </p>
            </div>
            <div className="input-wrapper listinginputfromtoBox travellerHover smallwidthBoxes-listing text-white">
              <label htmlFor="travelers">Travelers & Class</label>
              <div className="traveler-input" ref={triggerRef} onClick={handleTravelerModalToggle} style={{ paddingLeft: "16px", overflow: "hidden" }}>
                {adults} Adult{adults > 1 ? 's' : ''}
                {children > 0 && `, ${children} Child${children > 1 ? 'ren' : ''}`}
                {infants > 0 && `, ${infants} Infant${infants > 1 ? 's' : ''}`}
                , {cabinClassText}
              </div>
            </div>
            <button className="buttonSearchMainListing" onClick={searchButton}>
              Search
            </button>
          </div>
          {showTravelerModal && (
            <div className="traveler-modal-listing text-white" ref={modalRef}>
              <div className="modal-content">
                <label className="fw-bold text-start">Cabin class</label>
                <select id="cabinClass" name="cabinClass" value={cabinClass} onChange={handleCabinClassChange}>
                  {economyClass && (<option value="Y">Economy</option>)}
                  {premiumEcoClass && (<option value="W">Premium Economy</option>)}
                  {businessClass && (<option value="C">Business Class</option>)}
                  {firstClass && (<option value="F">First Class</option>)}
                </select>
                <div className="passenger-count">
                  <label className="col-lg-6 text-start">Adults (Age 12+)</label>
                  <div className="col-lg-6">
                    <button onClick={() => handleAddPassenger("adult", -1)} disabled={adults <= 1}>
                      <img
                        src={adults > 1 ? "./assets/images/MinusActive.png" : "./assets/images/minusTraveller.png"}
                        alt="Traveller Icon"
                      />
                    </button>
                    <span>{adults}</span>
                    {!isPersonalTravel && (<button
                      onClick={() => handleAddPassenger("adult", 1)}
                    >
                      <img src="./assets/images/Add.png" alt="" />
                    </button>)}
                  </div>
                </div>
                {isForFamily && (
                  <>
                    <div className="passenger-count">
                      <label className="col-lg-6 text-start">Children (Age 2-11)</label>
                      <div className="col-lg-6">
                        <button onClick={() => handleAddPassenger("child", -1)} disabled={children <= 0}>
                          <img
                            src={children > 0 ? "./assets/images/MinusActive.png" : "./assets/images/minusTraveller.png"}
                            alt="Traveller Icon"
                          />
                        </button>
                        <span>{children}</span>
                        <button
                          onClick={() => handleAddPassenger("child", 1)}
                        >
                          <img src="./assets/images/Add.png" alt="" />
                        </button>
                      </div>
                    </div>
                    <div className="passenger-count">
                      <label className="col-lg-6 text-start">Infants (Age 0-2)</label>
                      <div className="col-lg-6">
                        <button onClick={() => handleAddPassenger("infant", -1)} disabled={infants <= 0}>
                          <img
                            src={infants > 0 ? "./assets/images/MinusActive.png" : "./assets/images/minusTraveller.png"}
                            alt="Traveller Icon"
                          />
                        </button>
                        <span>{infants}</span>
                        <button
                          onClick={() => handleAddPassenger("infant", 1)}
                        >
                          <img src="./assets/images/Add.png" alt="" />
                        </button>
                      </div>
                    </div></>)}
                <button className="apply-button" onClick={handleTravelerModalToggle}>Apply</button>
              </div>
            </div>
          )}

          {/* For Multi-city, add another form */}
          {selectedtripType === '3' && (
            <>
              <div className="flight-search-listing multi-city multiMainContainer mt-2">
                <div className="input-wrapper listinginputfromtoBox multiCityForm-listing">
                  <label htmlFor="from-2">From</label>
                  <div>
                    <input
                      type="text"
                      value={from2 ? from2?.split(',')[2] : ""}
                      onChange={handleFrom2Change}
                      onFocus={(e) => {
                        setShowDropdown(false);
                        setShowDestinationDropdown(false);
                        setShowFrom2Dropdown(true);
                        setShowTo2Dropdown(false);
                        setShowFrom3Dropdown(false);
                        setShowTo3Dropdown(false);
                        handleInputFocus("from2");
                      }}
                      onKeyDown={(e) => handleKeyDown(e, from2Options, 'from2')}
                      className="metropolis-bold" placeholder="Select City" />

                  </div>
                  {showFrom2Dropdown && renderDropdown(from2Options, 'from2', searchQueryFrom2, setSearchQueryFrom2, inputRefs.from2)}
                </div>
                <div className="input-wrapper listinginputfromtoBox multiCityForm-listing">
                  <label htmlFor="to-2">To</label>
                  <div>
                    <input
                      type="text"
                      value={to2 ? to2?.split(',')[2] : ""}
                      onKeyDown={(e) => handleKeyDown(e, to2Options, 'to2')}
                      autoComplete="off"
                      onFocus={(e) => {
                        setShowDropdown(false);
                        setShowDestinationDropdown(false);
                        setShowFrom2Dropdown(false);
                        setShowTo2Dropdown(true);
                        setShowFrom3Dropdown(false);
                        setShowTo3Dropdown(false);
                        handleInputFocus("to2");
                      }}
                      onChange={handleTo2Change}
                      className="metropolis-bold" placeholder="Select City" />

                  </div>
                  {showTo2Dropdown && renderDropdown(to2Options, 'to2', searchQueryTo2, setSearchQueryTo2, inputRefs.to2)}
                </div>
                <div className="input-group smallwidthBoxes-listing multiCityForm-listing multiDepartWidth">
                  <label className="custom-label-listing" htmlFor="depart-2">Depart</label>
                  <DatePicker
                    selected={depart2}
                    onChange={date => setDepart2(date)}
                    placeholderText="Select Date"
                    dateFormat="EEE, dd MMM yy"
                    className="date-input testDrop"
                    minDate={startDate || new Date()}
                  />
                </div>
                {!isSecondCityVisibleSelected && (
                  <div className="addCityFlight-listing" onClick={handleAddCity}>
                    Add City
                  </div>
                )}
              </div>
              {isSecondCityVisibleSelected && (
                <div className="flight-search-listing multi-city multiMainContainer1 mt-2">
                  <div className="input-wrapper listinginputfromtoBox multiCityForm-listing1">
                    <label htmlFor="from-3">From</label>
                    <div>
                      <input
                        type="text"
                        value={from3 ? from3?.split(',')[2] : ""}
                        onChange={handleFrom3Change}
                        onFocus={(e) => {
                          setShowDropdown(false);
                          setShowDestinationDropdown(false);
                          setShowFrom2Dropdown(false);
                          setShowTo2Dropdown(false);
                          setShowFrom3Dropdown(true);
                          setShowTo3Dropdown(false);
                          handleInputFocus("from3");
                        }}
                        onKeyDown={(e) => handleKeyDown(e, from3Options, 'from3')}
                        className="metropolis-bold" placeholder="Select City" />

                    </div>
                    {showFrom3Dropdown && renderDropdown(from3Options, 'from3', searchQueryFrom3, setSearchQueryFrom3, inputRefs.from3)}
                  </div>
                  <div className="input-wrapper listinginputfromtoBox multiCityForm-listing1">
                    <label htmlFor="to-3">To</label>
                    <div>
                      <input
                        type="text"
                        value={to3 ? to3?.split(',')[2] : ""}
                        onKeyDown={(e) => handleKeyDown(e, to3Options, 'to3')}
                        autoComplete="off"
                        onFocus={(e) => {
                          setShowDropdown(false);
                          setShowDestinationDropdown(false);
                          setShowFrom2Dropdown(false);
                          setShowTo2Dropdown(false);
                          setShowFrom3Dropdown(false);
                          setShowTo3Dropdown(true);
                          handleInputFocus("to3");
                        }}
                        onChange={handleTo3Change}
                        className="metropolis-bold" placeholder="Select City" />
                    </div>
                    {showTo3Dropdown && renderDropdown(to3Options, 'to3', searchQueryTo3, setSearchQueryTo3, inputRefs.to3)}
                  </div>
                  <div className="input-group smallwidthBoxes-listing multiDepartWidth">
                    <label className="custom-label-listing" htmlFor="depart-3">Depart</label>
                    <DatePicker
                      selected={depart3}
                      onChange={date => setDepart3(date)}
                      placeholderText="Select Date"
                      dateFormat="EEE, dd MMM yy"
                      className="date-input testDrop"
                      minDate={depart2 || new Date()}
                    />
                  </div>
                  <div className="homedeleteButton" onClick={handleRemoveCity}>
                    <img src="./assets/images/deleteIcon.png" alt="Delete" />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <div className='container-fluid listingBGDiv'></div>

      {listingPage1 && isFlightValid && listingPage1.length > 0 ? (
        <div className={`listingDetailsDiv ${!loading ? "show" : ""}`}>
          <div className="sidebar text-start mt-4">
            <div className="header">
              <h5 className='fw-semibold'>Applied Filters</h5>
              <button className="clear-all" onClick={clearAllFilters}>
                Clear all
              </button>
            </div>
            {isAnyFilterApplied && (
              <>

                <div className="applied-filters">
                  {appliedFilters.stops && (
                    <div className='applyedfilter'>
                      Outbound Stops <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("stops")} />
                    </div>
                  )}


                  {appliedFilters.stopsRound && (
                    <div>
                      Inbound Stops <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("stopsRound")} />
                    </div>
                  )}


                  {appliedFilters.airline && (
                    <div>
                      Airline <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("airline")} />
                    </div>
                  )}


                  {appliedFilters.timeSlot && (
                    <div>
                      Time Slot <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("timeSlot")} />
                    </div>
                  )}


                  {appliedFilters.arrivalslot && (
                    <div>
                      Arrival Time Slot <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("arrivalslot")} />
                    </div>
                  )}


                  {isPriceChanged && (
                    <div>
                      Price <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("price")} />
                    </div>
                  )}


                  {/* {isDurationChanged && tripType === "1" && (
                    <div>
                      Duration <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("duration")} />
                    </div>
                  )} */}

                </div>
              </>
            )}
            {hasPopularFilters && (
              <div className="filter-section">
                <h6 className='smallfilterheading'>
                  Popular Filters

                </h6>
                {listingPage1.some(flight => {
                  const stops = flight.OutboundInboundlist?.[0]?.flightlist?.length > 1
                    ? String(flight.OutboundInboundlist[0].flightlist.length - 1)
                    : "0";
                  return stops === '0';
                }) && getMinPriceForNoOfStops('0', "1") > 0 && (
                    <label>
                      <span>Non Stop</span>
                      <p className="price-checkbox m-0">
                        {/* <span>{getCurrencySymbol(currency)}{new Intl.NumberFormat('en-IN').format(getMinPriceForNoOfStops('0', "1"))}</span> */}
                        <input
                          type="checkbox"
                          className="checkboxsize"
                          checked={selectedStopFilter.includes('0')}
                          onChange={(e) => handlePopularStopsFilter(e, '0')}
                        />
                      </p>
                    </label>
                  )}
                {/* {listingPage1.some(flight => flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name === 'Air India' && (restrictedAirlines !== null && !restrictedAirlines.includes(flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name))) && (
                  <label>
                    <span>Air India</span>
                    <p className="price-checkbox m-0">
                      <span>{getCurrencySymbol(currency)}{new Intl.NumberFormat('en-IN').format(getMinPriceForAirline('Air India'))}</span> 
                      <input
                        type="checkbox"
                        className="checkboxsize"
                        checked={selectedAirlines.includes('Air India')}
                        onChange={() => toggleAirlineFilter('Air India')}
                      />
                    </p>
                  </label>
                )} */}
                {oneStopPrice && (
                  <label>
                    <span>1 Stop</span>
                    <p className="price-checkbox m-0">

                      <input
                        type="checkbox"
                        className="checkboxsize"
                        checked={selectedStopFilter.includes('1')}
                        onChange={(e) => handlePopularStopsFilter(e, '1')}
                      />
                    </p>
                  </label>
                )}
                {moreStopsPrice && (
                  <label>
                    <span>2+ Stops</span>
                    <p className="price-checkbox m-0">

                      <input
                        type="checkbox"
                        className="checkboxsize"
                        checked={selectedStopFilter.includes('2')}
                        onChange={(e) => handlePopularStopsFilter(e, '2')}
                      />
                    </p>
                  </label>
                )}
                {/* {listingPage1.some(flight => {
                  const depTime = flight.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.time;
                  return depTime && getDepartureTimeSlot(depTime) === 'morning';
                }) && getMinPriceForTimeSlot('morning') > 0 && (
                    <label>
                      <span>Morning Departures</span>
                      <p className="price-checkbox m-0">
                        <span>{getCurrencySymbol(currency)}{new Intl.NumberFormat('en-IN').format(getMinPriceForTimeSlot('morning'))}</span>
                        <input
                          type="checkbox"
                          className="checkboxsize"
                          checked={selectedTimeSlotFilter === 'morning'}
                          onChange={() => toggleTimeSlotFilter('morning')}
                        />
                      </p>
                    </label>
                  )} */}
              </div>)}

            {/* {tripType === "2" && (
              <div className="filter-section">
                <h6 className='smallfilterheading'>Stops from {selectedDestination?.split(',')[2]}</h6>
                {nonStopPriceRound && (
                  <label>
                    <span>Non Stop</span>
                    <p className="price-checkbox m-0">
                      <span>{getCurrencySymbol(currency)}{new Intl.NumberFormat('en-IN').format(nonStopPriceRound)}</span>
                      <input
                        type="checkbox"
                        className="checkboxsize"
                        checked={selectedStopFilterRound.includes('0')}
                        onChange={(e) => handleStopsFilterRound(e, '0')}
                      />
                    </p>
                  </label>
                )}
                {oneStopPriceRound && (
                  <label>
                    <span>1 Stop</span>
                    <p className="price-checkbox m-0">

                      <input
                        type="checkbox"
                        className="checkboxsize"
                        checked={selectedStopFilterRound.includes('1')}
                        onChange={(e) => handleStopsFilterRound(e, '1')}
                      />
                    </p>
                  </label>
                )}
                {moreStopsPriceRound && (
                  <label>
                    <span>1+ Stops</span>
                    <p className="price-checkbox m-0">

                      <input
                        type="checkbox"
                        className="checkboxsize"
                        checked={selectedStopFilterRound.includes('2')}
                        onChange={(e) => handleStopsFilterRound(e, '2')}
                      />
                    </p>
                  </label>
                )}
              </div>
            )} */}
            <div className="filter-section">
              <h6 className='smallfilterheading'>
                {tripType === "1" ? "Flight Price" : tripType === "2" ? "Round-Trip Price" : ""}
              </h6>
              <div className="range_container testhover" style={{ position: "relative" }}>
                <div className="sliders_control">
                  <input
                    id="toSlider"
                    type="range"
                    value={toPrice}
                    min={minPrice}
                    max={maxPrice}
                    onChange={handleSliderChange}
                    style={{
                      width: "100%",
                      background: `linear-gradient(90deg, #2993B6 ${(toPrice - minPrice) / (maxPrice - minPrice) * 100}%, #ddd ${(toPrice - minPrice) / (maxPrice - minPrice) * 100}%)`,
                    }}
                  />
                </div>

                {/* Tooltip for the slider */}
                <div className="form_control_container">
                  <input
                    className="form_control_container__time__input form_control_container__time__input1 tooltip1"
                    type="text"
                    id="toInput"
                    value={`${getCurrencySymbol(currency)}${new Intl.NumberFormat('en-IN').format(toPrice)}`}
                    min={minPrice}
                    max={maxPrice}
                    onChange={(e) => handleInputChange(e, "toInput")}
                    disabled
                    style={{
                      position: "absolute",
                      top: "-31px",
                      left: `calc(${((toPrice - minPrice) / (maxPrice - minPrice)) * 100}% - 20px)`, // Prevents overflow
                      transform: `${toPrice - minPrice < (maxPrice - minPrice) * 0.1 ? "translateX(0%)" : toPrice - minPrice > (maxPrice - minPrice) * 0.9 ? "translateX(-74%)" : "translateX(-50%)"}`,
                    }}
                  />
                </div>

                {/* Min and Max Price Display */}
                <div className="price-range-labels mt-2" style={{ display: "flex", justifyContent: "space-between" }}>
                  <span className='smallfilterheading'>{`${getCurrencySymbol(currency)}${new Intl.NumberFormat('en-IN').format(minPrice)}`}</span>
                  <span className='smallfilterheading'>{`${getCurrencySymbol(currency)}${new Intl.NumberFormat('en-IN').format(maxPrice)}`}</span>
                </div>
              </div>
            </div>
            {/* Onward Journey Section - Only for Round Trip */}
            {tripType === "2" && (
              <>
                <div className="filter-section">
                  <h6 className='smallfilterheading' style={{ color: '#2993B6', marginBottom: '15px' }}>Onward Journey</h6>

                  {/* Stops from Departure City */}
                  <div style={{ marginBottom: '20px' }}>
                    <h6 className='smallfilterheading' style={{ fontSize: '14px', marginBottom: '10px' }}>
                      Stops from {listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.city}
                    </h6>
                    {listingPage1.some(flight => {
                      const stops = flight.OutboundInboundlist?.[0]?.flightlist?.length > 1
                        ? String(flight.OutboundInboundlist[0].flightlist.length - 1)
                        : "0";
                      return stops === '0';
                    }) && getMinPriceForNoOfStops('0', "1") > 0 && (
                        <label>
                          <span>Non Stop</span>
                          <p className="price-checkbox m-0">
                            <input
                              type="checkbox"
                              className="checkboxsize"
                              checked={selectedStopFilter.includes('0')}
                              onChange={() => toggleStopFilter('0')}
                            />
                          </p>
                        </label>
                      )}
                    {oneStopPrice && (
                      <label>
                        <span>1 Stop</span>
                        <p className="price-checkbox m-0">
                          <input
                            type="checkbox"
                            className="checkboxsize"
                            checked={selectedStopFilter.includes('1')}
                            onChange={(e) => handleStopsFilter(e, '1')}
                          />
                        </p>
                      </label>
                    )}
                    {moreStopsPrice && (
                      <label>
                        <span>2+ Stops</span>
                        <p className="price-checkbox m-0">
                          <input
                            type="checkbox"
                            className="checkboxsize"
                            checked={selectedStopFilter.includes('2')}
                            onChange={(e) => handleStopsFilter(e, '2')}
                          />
                        </p>
                      </label>
                    )}
                  </div>

                  {/* Departure From Departure City */}
                  <div style={{ marginBottom: '20px' }}>
                    <h6 className='smallfilterheading' style={{ fontSize: '14px', marginBottom: '10px' }}>Departure From {listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.city}</h6>
                    <div className="time-filters">
                      {hasFlightsForTimeSlot('before6', 'departure') && (
                        <button
                          style={{ backgroundColor: selectedDepartureTimeSlot === 'before6' ? '#2993B6' : '', color: selectedDepartureTimeSlot === 'before6' ? 'white' : 'black' }}
                          onClick={() => handleDepartureButtonClick('before6')}
                        >
                          <img src="/assets/images/BeforSix.png" alt="Before 6AM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          Before 6AM
                        </button>
                      )}
                      {hasFlightsForTimeSlot('morning', 'departure') && (
                        <button
                          style={{ backgroundColor: selectedDepartureTimeSlot === 'morning' ? '#2993B6' : '', color: selectedDepartureTimeSlot === 'morning' ? 'white' : 'black' }}
                          onClick={() => handleDepartureButtonClick('morning')}
                        >
                          <img src="/assets/images/noon.png" alt="6AM - 12PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          6AM - 12PM
                        </button>
                      )}
                      {hasFlightsForTimeSlot('afternoon', 'departure') && (
                        <button
                          style={{ backgroundColor: selectedDepartureTimeSlot === 'afternoon' ? '#2993B6' : '', color: selectedDepartureTimeSlot === 'afternoon' ? 'white' : 'black' }}
                          onClick={() => handleDepartureButtonClick('afternoon')}
                        >
                          <img src="/assets/images/evening.png" alt="12PM - 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          12PM - 6PM
                        </button>
                      )}
                      {hasFlightsForTimeSlot('evening', 'departure') && (
                        <button
                          style={{ backgroundColor: selectedDepartureTimeSlot === 'evening' ? '#2993B6' : '', color: selectedDepartureTimeSlot === 'evening' ? 'white' : 'black' }}
                          onClick={() => handleDepartureButtonClick('evening')}
                        >
                          <img src="/assets/images/after6.png" alt="After 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          After 6PM
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Arrival at Destination City */}
                  <div style={{ marginBottom: '20px' }}>
                    <h6 className='smallfilterheading' style={{ fontSize: '14px', marginBottom: '10px' }}>Arrival at {listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist?.[listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist.length - 1]?.Arrival?.city}</h6>
                    <div className="time-filters">
                      {hasFlightsForTimeSlot('before6', 'arrival') && (
                        <button
                          style={{ backgroundColor: selectedArrivalTimeSlot === 'before6' ? '#2993B6' : '', color: selectedArrivalTimeSlot === 'before6' ? 'white' : 'black' }}
                          onClick={() => handleArrivalButtonClick('before6')}
                        >
                          <img src="/assets/images/BeforSix.png" alt="Before 6AM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          Before 6AM
                        </button>
                      )}
                      {hasFlightsForTimeSlot('morning', 'arrival') && (
                        <button
                          style={{ backgroundColor: selectedArrivalTimeSlot === 'morning' ? '#2993B6' : '', color: selectedArrivalTimeSlot === 'morning' ? 'white' : 'black' }}
                          onClick={() => handleArrivalButtonClick('morning')}
                        >
                          <img src="/assets/images/noon.png" alt="6AM - 12PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          6AM - 12PM
                        </button>
                      )}
                      {hasFlightsForTimeSlot('afternoon', 'arrival') && (
                        <button
                          style={{ backgroundColor: selectedArrivalTimeSlot === 'afternoon' ? '#2993B6' : '', color: selectedArrivalTimeSlot === 'afternoon' ? 'white' : 'black' }}
                          onClick={() => handleArrivalButtonClick('afternoon')}
                        >
                          <img src="/assets/images/evening.png" alt="12PM - 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          12PM - 6PM
                        </button>
                      )}
                      {hasFlightsForTimeSlot('evening', 'arrival') && (
                        <button
                          style={{ backgroundColor: selectedArrivalTimeSlot === 'evening' ? '#2993B6' : '', color: selectedArrivalTimeSlot === 'evening' ? 'white' : 'black' }}
                          onClick={() => handleArrivalButtonClick('evening')}
                        >
                          <img src="/assets/images/after6.png" alt="After 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          After 6PM
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Return Journey Section */}
                <div className="filter-section">
                  <h6 className='smallfilterheading' style={{ color: '#2993B6', marginBottom: '15px' }}>Return Journey</h6>

                  {/* Stops from Destination City */}
                  <div style={{ marginBottom: '20px' }}>
                    <h6 className='smallfilterheading' style={{ fontSize: '14px', marginBottom: '10px' }}>Stops from {listingPage1?.[0]?.OutboundInboundlist?.[1]?.flightlist?.[0]?.Departure?.city}</h6>
                    {nonStopPriceRound && (
                      <label>
                        <span>Non Stop</span>
                        <p className="price-checkbox m-0">
                          <input
                            type="checkbox"
                            className="checkboxsize"
                            checked={selectedStopFilterRound.includes('0')}
                            onChange={(e) => handleStopsFilterRound(e, '0')}
                          />
                        </p>
                      </label>
                    )}
                    {oneStopPriceRound && (
                      <label>
                        <span>1 Stop</span>
                        <p className="price-checkbox m-0">
                          <input
                            type="checkbox"
                            className="checkboxsize"
                            checked={selectedStopFilterRound.includes('1')}
                            onChange={(e) => handleStopsFilterRound(e, '1')}
                          />
                        </p>
                      </label>
                    )}
                    {moreStopsPriceRound && (
                      <label>
                        <span>2+ Stops</span>
                        <p className="price-checkbox m-0">
                          <input
                            type="checkbox"
                            className="checkboxsize"
                            checked={selectedStopFilterRound.includes('2')}
                            onChange={(e) => handleStopsFilterRound(e, '2')}
                          />
                        </p>
                      </label>
                    )}
                  </div>

                  {/* Departure From Destination City */}
                  <div style={{ marginBottom: '20px' }}>
                    <h6 className='smallfilterheading' style={{ fontSize: '14px', marginBottom: '10px' }}>Departure From {listingPage1?.[0]?.OutboundInboundlist?.[1]?.flightlist?.[0]?.Departure?.city}</h6>
                    <div className="time-filters">
                      {hasFlightsForReturnTimeSlot('before6', 'departure') && (
                        <button
                          style={{ backgroundColor: selectedReturnDepartureTimeSlot === 'before6' ? '#2993B6' : '', color: selectedReturnDepartureTimeSlot === 'before6' ? 'white' : 'black' }}
                          onClick={() => handleReturnDepartureButtonClick('before6')}
                        >
                          <img src="/assets/images/BeforeSix.png" alt="Before 6AM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          Before 6AM
                        </button>
                      )}
                      {hasFlightsForReturnTimeSlot('morning', 'departure') && (
                        <button
                          style={{ backgroundColor: selectedReturnDepartureTimeSlot === 'morning' ? '#2993B6' : '', color: selectedReturnDepartureTimeSlot === 'morning' ? 'white' : 'black' }}
                          onClick={() => handleReturnDepartureButtonClick('morning')}
                        >
                          <img src="/assets/images/noon.png" alt="6AM - 12PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          6AM - 12PM
                        </button>
                      )}
                      {hasFlightsForReturnTimeSlot('afternoon', 'departure') && (
                        <button
                          style={{ backgroundColor: selectedReturnDepartureTimeSlot === 'afternoon' ? '#2993B6' : '', color: selectedReturnDepartureTimeSlot === 'afternoon' ? 'white' : 'black' }}
                          onClick={() => handleReturnDepartureButtonClick('afternoon')}
                        >
                          <img src="/assets/images/evening.png" alt="12PM - 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          12PM - 6PM
                        </button>
                      )}
                      {hasFlightsForReturnTimeSlot('evening', 'departure') && (
                        <button
                          style={{ backgroundColor: selectedReturnDepartureTimeSlot === 'evening' ? '#2993B6' : '', color: selectedReturnDepartureTimeSlot === 'evening' ? 'white' : 'black' }}
                          onClick={() => handleReturnDepartureButtonClick('evening')}
                        >
                          <img src="/assets/images/after6.png" alt="After 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          After 6PM
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Arrival at Departure City */}
                  <div style={{ marginBottom: '20px' }}>
                    <h6 className='smallfilterheading' style={{ fontSize: '14px', marginBottom: '10px' }}>Arrival at {listingPage1?.[0]?.OutboundInboundlist?.[1]?.flightlist?.[listingPage1?.[0]?.OutboundInboundlist?.[1]?.flightlist.length - 1]?.Arrival?.city}</h6>
                    <div className="time-filters">
                      {hasFlightsForReturnTimeSlot('before6', 'arrival') && (
                        <button
                          style={{ backgroundColor: selectedReturnArrivalTimeSlot === 'before6' ? '#2993B6' : '', color: selectedReturnArrivalTimeSlot === 'before6' ? 'white' : 'black' }}
                          onClick={() => handleReturnArrivalButtonClick('before6')}
                        >
                          <img src="/assets/images/beforeSix.png" alt="Before 6AM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          Before 6AM
                        </button>
                      )}
                      {hasFlightsForReturnTimeSlot('morning', 'arrival') && (
                        <button
                          style={{ backgroundColor: selectedReturnArrivalTimeSlot === 'morning' ? '#2993B6' : '', color: selectedReturnArrivalTimeSlot === 'morning' ? 'white' : 'black' }}
                          onClick={() => handleReturnArrivalButtonClick('morning')}
                        >
                          <img src="/assets/images/noon.png" alt="6AM - 12PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          6AM - 12PM
                        </button>
                      )}
                      {hasFlightsForReturnTimeSlot('afternoon', 'arrival') && (
                        <button
                          style={{ backgroundColor: selectedReturnArrivalTimeSlot === 'afternoon' ? '#2993B6' : '', color: selectedReturnArrivalTimeSlot === 'afternoon' ? 'white' : 'black' }}
                          onClick={() => handleReturnArrivalButtonClick('afternoon')}
                        >
                          <img src="/assets/images/evening.png" alt="12PM - 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          12PM - 6PM
                        </button>
                      )}
                      {hasFlightsForReturnTimeSlot('evening', 'arrival') && (
                        <button
                          style={{ backgroundColor: selectedReturnArrivalTimeSlot === 'evening' ? '#2993B6' : '', color: selectedReturnArrivalTimeSlot === 'evening' ? 'white' : 'black' }}
                          onClick={() => handleReturnArrivalButtonClick('evening')}
                        >
                          <img src="/assets/images/after6.png" alt="After 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                          After 6PM
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* One-way trip filters (keep existing structure for one-way) */}
            {tripType === "1" && (
              <>
                <div className="filter-section">
                  <h6 className='smallfilterheading my-3'>Departure From {listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.city}</h6>
                  <div className="time-filters">
                    {hasFlightsForTimeSlot('before6', 'departure') && (
                      <button
                        style={{ backgroundColor: selectedDepartureTimeSlot === 'before6' ? '#2993B6' : '' }}
                        onClick={() => handleDepartureButtonClick('before6')}
                      >
                        <img src="/assets/images/beforeSix.png" alt="Before 6AM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                        Before 6AM
                      </button>
                    )}
                    {hasFlightsForTimeSlot('morning', 'departure') && (
                      <button
                        style={{ backgroundColor: selectedDepartureTimeSlot === 'morning' ? '#2993B6' : '' }}
                        onClick={() => handleDepartureButtonClick('morning')}
                      >
                        <img src="/assets/images/noon.png" alt="6AM - 12PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                        6AM - 12PM
                      </button>
                    )}
                    {hasFlightsForTimeSlot('afternoon', 'departure') && (
                      <button
                        style={{ backgroundColor: selectedDepartureTimeSlot === 'afternoon' ? '#2993B6' : '' }}
                        onClick={() => handleDepartureButtonClick('afternoon')}
                      >
                        <img src="/assets/images/evening.png" alt="12PM - 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                        12PM - 6PM
                      </button>
                    )}
                    {hasFlightsForTimeSlot('evening', 'departure') && (
                      <button
                        style={{ backgroundColor: selectedDepartureTimeSlot === 'evening' ? '#2993B6' : '' }}
                        onClick={() => handleDepartureButtonClick('evening')}
                      >
                        <img src="/assets/images/after6.png" alt="After 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                        After 6PM
                      </button>
                    )}
                  </div>
                </div>
                <div className="filter-section">
                  <h6 className='smallfilterheading'>Arrival at {listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist?.[listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist.length - 1]?.Arrival?.city}</h6>
                  <div className="time-filters mt-3">
                    {hasFlightsForTimeSlot('before6', 'arrival') && (
                      <button
                        style={{ backgroundColor: selectedArrivalTimeSlot === 'before6' ? '#2993B6' : '' }}
                        onClick={() => handleArrivalButtonClick('before6')}
                      >
                        <img src="/assets/images/beforeSix.png" alt="Before 6AM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                        Before 6AM
                      </button>
                    )}
                    {hasFlightsForTimeSlot('morning', 'arrival') && (
                      <button
                        style={{ backgroundColor: selectedArrivalTimeSlot === 'morning' ? '#2993B6' : '' }}
                        onClick={() => handleArrivalButtonClick('morning')}
                      >
                        <img src="/assets/images/noon.png" alt="6AM - 12PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                        6AM - 12PM
                      </button>
                    )}
                    {hasFlightsForTimeSlot('afternoon', 'arrival') && (
                      <button
                        style={{ backgroundColor: selectedArrivalTimeSlot === 'afternoon' ? '#2993B6' : '' }}
                        onClick={() => handleArrivalButtonClick('afternoon')}
                      >
                        <img src="/assets/images/evening.png" alt="12PM - 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                        12PM - 6PM
                      </button>
                    )}
                    {hasFlightsForTimeSlot('evening', 'arrival') && (
                      <button
                        style={{ backgroundColor: selectedArrivalTimeSlot === 'evening' ? '#2993B6' : '' }}
                        onClick={() => handleArrivalButtonClick('evening')}
                      >
                        <img src="/assets/images/after6.png" alt="After 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                        After 6PM
                      </button>
                    )}
                  </div>
                </div>
              </>
            )}
            <div className="filter-section">
              <h6 className='smallfilterheading my-3'>Airlines</h6>
              <div className='mobileHeight'>
                {Object.keys(airlinesDetails).map(airline => {
                  // Compose logo URL safely
                  const aircode = airlinesDetails?.[airline]?.aircode
                    ? airlinesDetails[airline].aircode.replace(/\s/g, '')
                    : 'XX';
                  const logoUrl = `https://r-xx.bstatic.com/data/airlines_logo/${aircode}.png`;
                  return (
                    <label key={airline} className="mt-4">
                      <span style={{ display: "flex", flexDirection: "row" }}>
                        <img
                          src={logoUrl}
                          alt={airline}
                          style={{
                            marginTop: "2px",
                            marginLeft: "9px",
                            marginRight: "5px"
                          }}
                        />

                        <p className='p-1 m-0'>
                          {airline} ({airlinesDetails?.[airline]?.count || 0} flights)
                        </p>
                      </span>
                      <p className="price-checkbox m-0">
                        <input
                          type="checkbox"
                          className="checkboxsize"
                          checked={selectedAirlines.includes(airline)}
                          onChange={() => handleAirlineCheckboxChange(airline)}
                        />
                      </p>
                    </label>
                  );
                })}

              </div>
            </div>
          </div>
          <div className="container mt-5 mobileFilter">
            {/* Button to open modal */}
            <button type="button" className="btn" onClick={openModal}>
              Add Filters
            </button>

            {/* Modal structure */}
            {showModal && (
              <div className="modal fade show d-block" tabIndex="-1">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Filter Options</h5>
                      <button type="button" className="btn-close" onClick={closeModal}></button>
                    </div>
                    <div className="modal-body">
                      <div className=" text-start mt-4">
                        {isAnyFilterApplied && (
                          <>
                            <div className="header">
                              <h5>Applied Filters</h5>
                              <button className="clear-all" onClick={clearAllFilters}>
                                Clear all
                              </button>
                            </div>
                            <div className="applied-filters">
                              {appliedFilters.stops && (
                                <div className='applyedfilter'>
                                  Outbound Stops <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("stops")} />
                                </div>
                              )}


                              {appliedFilters.stopsRound && (
                                <div>
                                  Inbound Stops <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("stopsRound")} />
                                </div>
                              )}


                              {appliedFilters.airline && (
                                <div>
                                  Airline <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("airline")} />
                                </div>
                              )}


                              {appliedFilters.timeSlot && (
                                <div>
                                  Time Slot <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("timeSlot")} />
                                </div>
                              )}


                              {appliedFilters.arrivalslot && (
                                <div>
                                  Arrival Time Slot <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("arrivalslot")} />
                                </div>
                              )}


                              {isPriceChanged && (
                                <div>
                                  Price <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("price")} />
                                </div>
                              )}


                              {/* {isDurationChanged && tripType === "1" && (
                    <div>
                      Duration <img src="./assets/images/close-filter.png" alt="close-icon" onClick={() => removeFilter("duration")} />
                    </div>
                  )} */}

                            </div>
                          </>
                        )}
                        {hasPopularFilters && (
                          <div className="filter-section">
                            <h6 className='smallfilterheading'>
                              Popular Filters

                            </h6>
                            {listingPage1.some(flight => {
                              const stops = flight.OutboundInboundlist?.[0]?.flightlist?.length > 1
                                ? String(flight.OutboundInboundlist[0].flightlist.length - 1)
                                : "0";
                              return stops === '0';
                            }) && getMinPriceForNoOfStops('0', "1") > 0 && (
                                <label>
                                  <span>Non Stop</span>
                                  <p className="price-checkbox m-0">
                                    {/* <span>{getCurrencySymbol(currency)}{new Intl.NumberFormat('en-IN').format(getMinPriceForNoOfStops('0', "1"))}</span> */}
                                    <input
                                      type="checkbox"
                                      className="checkboxsize"
                                      checked={selectedStopFilter.includes('0')}
                                      onChange={(e) => handlePopularStopsFilter(e, '0')}
                                    />
                                  </p>
                                </label>
                              )}
                            {/* {listingPage1.some(flight => flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name === 'Air India' && (restrictedAirlines !== null && !restrictedAirlines.includes(flight.OutboundInboundlist[0].flightlist[0].MarketingAirline.name))) && (
                  <label>
                    <span>Air India</span>
                    <p className="price-checkbox m-0">
                      <span>{getCurrencySymbol(currency)}{new Intl.NumberFormat('en-IN').format(getMinPriceForAirline('Air India'))}</span> 
                      <input
                        type="checkbox"
                        className="checkboxsize"
                        checked={selectedAirlines.includes('Air India')}
                        onChange={() => toggleAirlineFilter('Air India')}
                      />
                    </p>
                  </label>
                )} */}
                            {oneStopPrice && (
                              <label>
                                <span>1 Stop</span>
                                <p className="price-checkbox m-0">

                                  <input
                                    type="checkbox"
                                    className="checkboxsize"
                                    checked={selectedStopFilter.includes('1')}
                                    onChange={(e) => handlePopularStopsFilter(e, '1')}
                                  />
                                </p>
                              </label>
                            )}
                            {moreStopsPrice && (
                              <label>
                                <span>2+ Stops</span>
                                <p className="price-checkbox m-0">

                                  <input
                                    type="checkbox"
                                    className="checkboxsize"
                                    checked={selectedStopFilter.includes('2')}
                                    onChange={(e) => handlePopularStopsFilter(e, '2')}
                                  />
                                </p>
                              </label>
                            )}
                            {/* {listingPage1.some(flight => {
                  const depTime = flight.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.time;
                  return depTime && getDepartureTimeSlot(depTime) === 'morning';
                }) && getMinPriceForTimeSlot('morning') > 0 && (
                    <label>
                      <span>Morning Departures</span>
                      <p className="price-checkbox m-0">
                        <span>{getCurrencySymbol(currency)}{new Intl.NumberFormat('en-IN').format(getMinPriceForTimeSlot('morning'))}</span>
                        <input
                          type="checkbox"
                          className="checkboxsize"
                          checked={selectedTimeSlotFilter === 'morning'}
                          onChange={() => toggleTimeSlotFilter('morning')}
                        />
                      </p>
                    </label>
                  )} */}
                          </div>)}

                        {/* {tripType === "2" && (
              <div className="filter-section">
                <h6 className='smallfilterheading'>Stops from {selectedDestination?.split(',')[2]}</h6>
                {nonStopPriceRound && (
                  <label>
                    <span>Non Stop</span>
                    <p className="price-checkbox m-0">
                      <span>{getCurrencySymbol(currency)}{new Intl.NumberFormat('en-IN').format(nonStopPriceRound)}</span>
                      <input
                        type="checkbox"
                        className="checkboxsize"
                        checked={selectedStopFilterRound.includes('0')}
                        onChange={(e) => handleStopsFilterRound(e, '0')}
                      />
                    </p>
                  </label>
                )}
                {oneStopPriceRound && (
                  <label>
                    <span>1 Stop</span>
                    <p className="price-checkbox m-0">

                      <input
                        type="checkbox"
                        className="checkboxsize"
                        checked={selectedStopFilterRound.includes('1')}
                        onChange={(e) => handleStopsFilterRound(e, '1')}
                      />
                    </p>
                  </label>
                )}
                {moreStopsPriceRound && (
                  <label>
                    <span>1+ Stops</span>
                    <p className="price-checkbox m-0">

                      <input
                        type="checkbox"
                        className="checkboxsize"
                        checked={selectedStopFilterRound.includes('2')}
                        onChange={(e) => handleStopsFilterRound(e, '2')}
                      />
                    </p>
                  </label>
                )}
              </div>
            )} */}
                        <div className="filter-section">
                          {tripType === "1" ? "Flight Price" : tripType === "2" ? "Round-Trip Price" : ""}
                          <div className="range_container testhover" style={{ position: "relative" }}>
                            <div className="sliders_control">
                              <input
                                id="toSlider"
                                type="range"
                                value={toPrice}
                                min={minPrice}
                                max={maxPrice}
                                onChange={handleSliderChange}
                                style={{
                                  width: "100%",
                                  background: `linear-gradient(90deg, #2993B6 ${(toPrice - minPrice) / (maxPrice - minPrice) * 100}%, #ddd ${(toPrice - minPrice) / (maxPrice - minPrice) * 100}%)`,
                                }}
                              />
                            </div>

                            {/* Tooltip for the slider */}
                            <div className="form_control_container">
                              <input
                                className="form_control_container__time__input form_control_container__time__input1 tooltip1"
                                type="text"
                                id="toInput"
                                value={`${getCurrencySymbol(currency)}${new Intl.NumberFormat('en-IN').format(toPrice)}`}
                                min={minPrice}
                                max={maxPrice}
                                onChange={(e) => handleInputChange(e, "toInput")}
                                disabled
                                style={{
                                  position: "absolute",
                                  top: "-31px",
                                  left: `calc(${((toPrice - minPrice) / (maxPrice - minPrice)) * 100}% - 20px)`, // Prevents overflow
                                  transform: `${toPrice - minPrice < (maxPrice - minPrice) * 0.1 ? "translateX(0%)" : toPrice - minPrice > (maxPrice - minPrice) * 0.9 ? "translateX(-74%)" : "translateX(-50%)"}`,
                                }}
                              />
                            </div>

                            {/* Min and Max Price Display */}
                            <div className="price-range-labels mt-2" style={{ display: "flex", justifyContent: "space-between" }}>
                              <span className='smallfilterheading'>{`${getCurrencySymbol(currency)}${new Intl.NumberFormat('en-IN').format(minPrice)}`}</span>
                              <span className='smallfilterheading'>{`${getCurrencySymbol(currency)}${new Intl.NumberFormat('en-IN').format(maxPrice)}`}</span>
                            </div>
                          </div>
                        </div>
                        {/* Onward Journey Section - Only for Round Trip */}
                        {tripType === "2" && (
                          <>
                            <div className="filter-section">
                              <h6 className='smallfilterheading' style={{ color: '#2993B6', marginBottom: '15px' }}>Onward Journey</h6>

                              {/* Stops from Departure City */}
                              <div style={{ marginBottom: '20px' }}>
                                <h6 className='smallfilterheading' style={{ fontSize: '14px', marginBottom: '10px' }}>
                                  Stops from {listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.city}
                                </h6>
                                {listingPage1.some(flight => {
                                  const stops = flight.OutboundInboundlist?.[0]?.flightlist?.length > 1
                                    ? String(flight.OutboundInboundlist[0].flightlist.length - 1)
                                    : "0";
                                  return stops === '0';
                                }) && getMinPriceForNoOfStops('0', "1") > 0 && (
                                    <label>
                                      <span>Non Stop</span>
                                      <p className="price-checkbox m-0">
                                        <input
                                          type="checkbox"
                                          className="checkboxsize"
                                          checked={selectedStopFilter.includes('0')}
                                          onChange={() => toggleStopFilter('0')}
                                        />
                                      </p>
                                    </label>
                                  )}
                                {oneStopPrice && (
                                  <label>
                                    <span>1 Stop</span>
                                    <p className="price-checkbox m-0">
                                      <input
                                        type="checkbox"
                                        className="checkboxsize"
                                        checked={selectedStopFilter.includes('1')}
                                        onChange={(e) => handleStopsFilter(e, '1')}
                                      />
                                    </p>
                                  </label>
                                )}
                                {moreStopsPrice && (
                                  <label>
                                    <span>2+ Stops</span>
                                    <p className="price-checkbox m-0">
                                      <input
                                        type="checkbox"
                                        className="checkboxsize"
                                        checked={selectedStopFilter.includes('2')}
                                        onChange={(e) => handleStopsFilter(e, '2')}
                                      />
                                    </p>
                                  </label>
                                )}
                              </div>

                              {/* Departure From Departure City */}
                              <div style={{ marginBottom: '20px' }}>
                                <h6 className='smallfilterheading' style={{ fontSize: '14px', marginBottom: '10px' }}>Departure From {listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.city}</h6>
                                <div className="time-filters">
                                  {hasFlightsForTimeSlot('before6', 'departure') && (
                                    <button
                                      style={{ backgroundColor: selectedDepartureTimeSlot === 'before6' ? '#2993B6' : '', color: selectedDepartureTimeSlot === 'before6' ? 'white' : 'black' }}
                                      onClick={() => handleDepartureButtonClick('before6')}
                                    >
                                      <img src="/assets/images/beforeSix.png" alt="Before 6AM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      Before 6AM
                                    </button>
                                  )}
                                  {hasFlightsForTimeSlot('morning', 'departure') && (
                                    <button
                                      style={{ backgroundColor: selectedDepartureTimeSlot === 'morning' ? '#2993B6' : '', color: selectedDepartureTimeSlot === 'morning' ? 'white' : 'black' }}
                                      onClick={() => handleDepartureButtonClick('morning')}
                                    >
                                      <img src="/assets/images/noon.png" alt="6AM - 12PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      6AM - 12PM
                                    </button>
                                  )}
                                  {hasFlightsForTimeSlot('afternoon', 'departure') && (
                                    <button
                                      style={{ backgroundColor: selectedDepartureTimeSlot === 'afternoon' ? '#2993B6' : '', color: selectedDepartureTimeSlot === 'afternoon' ? 'white' : 'black' }}
                                      onClick={() => handleDepartureButtonClick('afternoon')}
                                    >
                                      <img src="/assets/images/evening.png" alt="12PM - 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      12PM - 6PM
                                    </button>
                                  )}
                                  {hasFlightsForTimeSlot('evening', 'departure') && (
                                    <button
                                      style={{ backgroundColor: selectedDepartureTimeSlot === 'evening' ? '#2993B6' : '', color: selectedDepartureTimeSlot === 'evening' ? 'white' : 'black' }}
                                      onClick={() => handleDepartureButtonClick('evening')}
                                    >
                                      <img src="/assets/images/after6.png" alt="After 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      After 6PM
                                    </button>
                                  )}
                                </div>
                              </div>

                              {/* Arrival at Destination City */}
                              <div style={{ marginBottom: '20px' }}>
                                <h6 className='smallfilterheading' style={{ fontSize: '14px', marginBottom: '10px' }}>Arrival at {listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist?.[listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist.length - 1]?.Arrival?.city}</h6>
                                <div className="time-filters">
                                  {hasFlightsForTimeSlot('before6', 'arrival') && (
                                    <button
                                      style={{ backgroundColor: selectedArrivalTimeSlot === 'before6' ? '#2993B6' : '', color: selectedArrivalTimeSlot === 'before6' ? 'white' : 'black' }}
                                      onClick={() => handleArrivalButtonClick('before6')}
                                    >
                                      <img src="/assets/images/beforeSix.png" alt="Before 6AM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      Before 6AM
                                    </button>
                                  )}
                                  {hasFlightsForTimeSlot('morning', 'arrival') && (
                                    <button
                                      style={{ backgroundColor: selectedArrivalTimeSlot === 'morning' ? '#2993B6' : '', color: selectedArrivalTimeSlot === 'morning' ? 'white' : 'black' }}
                                      onClick={() => handleArrivalButtonClick('morning')}
                                    >
                                      <img src="/assets/images/noon.png" alt="6AM - 12PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      6AM - 12PM
                                    </button>
                                  )}
                                  {hasFlightsForTimeSlot('afternoon', 'arrival') && (
                                    <button
                                      style={{ backgroundColor: selectedArrivalTimeSlot === 'afternoon' ? '#2993B6' : '', color: selectedArrivalTimeSlot === 'afternoon' ? 'white' : 'black' }}
                                      onClick={() => handleArrivalButtonClick('afternoon')}
                                    >
                                      <img src="/assets/images/evening.png" alt="12PM - 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      12PM - 6PM
                                    </button>
                                  )}
                                  {hasFlightsForTimeSlot('evening', 'arrival') && (
                                    <button
                                      style={{ backgroundColor: selectedArrivalTimeSlot === 'evening' ? '#2993B6' : '', color: selectedArrivalTimeSlot === 'evening' ? 'white' : 'black' }}
                                      onClick={() => handleArrivalButtonClick('evening')}
                                    >
                                      <img src="/assets/images/after6.png" alt="After 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      After 6PM
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Return Journey Section */}
                            <div className="filter-section">
                              <h6 className='smallfilterheading' style={{ color: '#2993B6', marginBottom: '15px' }}>Return Journey</h6>

                              {/* Stops from Destination City */}
                              <div style={{ marginBottom: '20px' }}>
                                <h6 className='smallfilterheading' style={{ fontSize: '14px', marginBottom: '10px' }}>Stops from {listingPage1?.[0]?.OutboundInboundlist?.[1]?.flightlist?.[0]?.Departure?.city}</h6>
                                {nonStopPriceRound && (
                                  <label>
                                    <span>Non Stop</span>
                                    <p className="price-checkbox m-0">
                                      <input
                                        type="checkbox"
                                        className="checkboxsize"
                                        checked={selectedStopFilterRound.includes('0')}
                                        onChange={(e) => handleStopsFilterRound(e, '0')}
                                      />
                                    </p>
                                  </label>
                                )}
                                {oneStopPriceRound && (
                                  <label>
                                    <span>1 Stop</span>
                                    <p className="price-checkbox m-0">
                                      <input
                                        type="checkbox"
                                        className="checkboxsize"
                                        checked={selectedStopFilterRound.includes('1')}
                                        onChange={(e) => handleStopsFilterRound(e, '1')}
                                      />
                                    </p>
                                  </label>
                                )}
                                {moreStopsPriceRound && (
                                  <label>
                                    <span>2+ Stops</span>
                                    <p className="price-checkbox m-0">
                                      <input
                                        type="checkbox"
                                        className="checkboxsize"
                                        checked={selectedStopFilterRound.includes('2')}
                                        onChange={(e) => handleStopsFilterRound(e, '2')}
                                      />
                                    </p>
                                  </label>
                                )}
                              </div>

                              {/* Departure From Destination City */}
                              <div style={{ marginBottom: '20px' }}>
                                <h6 className='smallfilterheading' style={{ fontSize: '14px', marginBottom: '10px' }}>Departure From {listingPage1?.[0]?.OutboundInboundlist?.[1]?.flightlist?.[0]?.Departure?.city}</h6>
                                <div className="time-filters">
                                  {hasFlightsForReturnTimeSlot('before6', 'departure') && (
                                    <button
                                      style={{ backgroundColor: selectedReturnDepartureTimeSlot === 'before6' ? '#2993B6' : '', color: selectedReturnDepartureTimeSlot === 'before6' ? 'white' : 'black' }}
                                      onClick={() => handleReturnDepartureButtonClick('before6')}
                                    >
                                      <img src="/assets/images/beforeSix.png" alt="Before 6AM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      Before 6AM
                                    </button>
                                  )}
                                  {hasFlightsForReturnTimeSlot('morning', 'departure') && (
                                    <button
                                      style={{ backgroundColor: selectedReturnDepartureTimeSlot === 'morning' ? '#2993B6' : '', color: selectedReturnDepartureTimeSlot === 'morning' ? 'white' : 'black' }}
                                      onClick={() => handleReturnDepartureButtonClick('morning')}
                                    >
                                      <img src="/assets/images/noon.png" alt="6AM - 12PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      6AM - 12PM
                                    </button>
                                  )}
                                  {hasFlightsForReturnTimeSlot('afternoon', 'departure') && (
                                    <button
                                      style={{ backgroundColor: selectedReturnDepartureTimeSlot === 'afternoon' ? '#2993B6' : '', color: selectedReturnDepartureTimeSlot === 'afternoon' ? 'white' : 'black' }}
                                      onClick={() => handleReturnDepartureButtonClick('afternoon')}
                                    >
                                      <img src="/assets/images/evening.png" alt="12PM - 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      12PM - 6PM
                                    </button>
                                  )}
                                  {hasFlightsForReturnTimeSlot('evening', 'departure') && (
                                    <button
                                      style={{ backgroundColor: selectedReturnDepartureTimeSlot === 'evening' ? '#2993B6' : '', color: selectedReturnDepartureTimeSlot === 'evening' ? 'white' : 'black' }}
                                      onClick={() => handleReturnDepartureButtonClick('evening')}
                                    >
                                      <img src="/assets/images/after6.png" alt="After 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      After 6PM
                                    </button>
                                  )}
                                </div>
                              </div>

                              {/* Arrival at Departure City */}
                              <div style={{ marginBottom: '20px' }}>
                                <h6 className='smallfilterheading' style={{ fontSize: '14px', marginBottom: '10px' }}>Arrival at {listingPage1?.[0]?.OutboundInboundlist?.[1]?.flightlist?.[listingPage1?.[0]?.OutboundInboundlist?.[1]?.flightlist.length - 1]?.Arrival?.city}</h6>
                                <div className="time-filters">
                                  {hasFlightsForReturnTimeSlot('before6', 'arrival') && (
                                    <button
                                      style={{ backgroundColor: selectedReturnArrivalTimeSlot === 'before6' ? '#2993B6' : '', color: selectedReturnArrivalTimeSlot === 'before6' ? 'white' : 'black' }}
                                      onClick={() => handleReturnArrivalButtonClick('before6')}
                                    >
                                      <img src="/assets/images/beforeSix.png" alt="Before 6AM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      Before 6AM
                                    </button>
                                  )}
                                  {hasFlightsForReturnTimeSlot('morning', 'arrival') && (
                                    <button
                                      style={{ backgroundColor: selectedReturnArrivalTimeSlot === 'morning' ? '#2993B6' : '', color: selectedReturnArrivalTimeSlot === 'morning' ? 'white' : 'black' }}
                                      onClick={() => handleReturnArrivalButtonClick('morning')}
                                    >
                                      <img src="/assets/images/noon.png" alt="6AM - 12PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      6AM - 12PM
                                    </button>
                                  )}
                                  {hasFlightsForReturnTimeSlot('afternoon', 'arrival') && (
                                    <button
                                      style={{ backgroundColor: selectedReturnArrivalTimeSlot === 'afternoon' ? '#2993B6' : '', color: selectedReturnArrivalTimeSlot === 'afternoon' ? 'white' : 'black' }}
                                      onClick={() => handleReturnArrivalButtonClick('afternoon')}
                                    >
                                      <img src="/assets/images/evening.png" alt="12PM - 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      12PM - 6PM
                                    </button>
                                  )}
                                  {hasFlightsForReturnTimeSlot('evening', 'arrival') && (
                                    <button
                                      style={{ backgroundColor: selectedReturnArrivalTimeSlot === 'evening' ? '#2993B6' : '', color: selectedReturnArrivalTimeSlot === 'evening' ? 'white' : 'black' }}
                                      onClick={() => handleReturnArrivalButtonClick('evening')}
                                    >
                                      <img src="/assets/images/after6.png" alt="After 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                      After 6PM
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {/* One-way trip filters (keep existing structure for one-way) */}
                        {tripType === "1" && (
                          <>
                            <div className="filter-section">
                              <h6 className='smallfilterheading my-3'>Departure From {listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.city}</h6>
                              <div className="time-filters">
                                {hasFlightsForTimeSlot('before6', 'departure') && (
                                  <button
                                    style={{ backgroundColor: selectedDepartureTimeSlot === 'before6' ? '#2993B6' : '' }}
                                    onClick={() => handleDepartureButtonClick('before6')}
                                  >
                                    <img src="/assets/images/beforeSix.png" alt="Before 6AM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                    Before 6AM
                                  </button>
                                )}
                                {hasFlightsForTimeSlot('morning', 'departure') && (
                                  <button
                                    style={{ backgroundColor: selectedDepartureTimeSlot === 'morning' ? '#2993B6' : '' }}
                                    onClick={() => handleDepartureButtonClick('morning')}
                                  >
                                    <img src="/assets/images/noon.png" alt="6AM - 12PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                    6AM - 12PM
                                  </button>
                                )}
                                {hasFlightsForTimeSlot('afternoon', 'departure') && (
                                  <button
                                    style={{ backgroundColor: selectedDepartureTimeSlot === 'afternoon' ? '#2993B6' : '' }}
                                    onClick={() => handleDepartureButtonClick('afternoon')}
                                  >
                                    <img src="/assets/images/evening.png" alt="12PM - 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                    12PM - 6PM
                                  </button>
                                )}
                                {hasFlightsForTimeSlot('evening', 'departure') && (
                                  <button
                                    style={{ backgroundColor: selectedDepartureTimeSlot === 'evening' ? '#2993B6' : '' }}
                                    onClick={() => handleDepartureButtonClick('evening')}
                                  >
                                    <img src="/assets/images/after6.png" alt="After 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                    After 6PM
                                  </button>
                                )}
                              </div>
                            </div>
                            <div className="filter-section">
                              <h6 className='smallfilterheading'>Arrival at {listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist?.[listingPage1?.[0]?.OutboundInboundlist?.[0]?.flightlist.length - 1]?.Arrival?.city}</h6>
                              <div className="time-filters mt-3">
                                {hasFlightsForTimeSlot('before6', 'arrival') && (
                                  <button
                                    style={{ backgroundColor: selectedArrivalTimeSlot === 'before6' ? '#2993B6' : '' }}
                                    onClick={() => handleArrivalButtonClick('before6')}
                                  >
                                    <img src="/assets/images/beforeSix.png" alt="Before 6AM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                    Before 6AM
                                  </button>
                                )}
                                {hasFlightsForTimeSlot('morning', 'arrival') && (
                                  <button
                                    style={{ backgroundColor: selectedArrivalTimeSlot === 'morning' ? '#2993B6' : '' }}
                                    onClick={() => handleArrivalButtonClick('morning')}
                                  >
                                    <img src="/assets/images/noon.png" alt="6AM - 12PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                    6AM - 12PM
                                  </button>
                                )}
                                {hasFlightsForTimeSlot('afternoon', 'arrival') && (
                                  <button
                                    style={{ backgroundColor: selectedArrivalTimeSlot === 'afternoon' ? '#2993B6' : '' }}
                                    onClick={() => handleArrivalButtonClick('afternoon')}
                                  >
                                    <img src="/assets/images/evening.png" alt="12PM - 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                    12PM - 6PM
                                  </button>
                                )}
                                {hasFlightsForTimeSlot('evening', 'arrival') && (
                                  <button
                                    style={{ backgroundColor: selectedArrivalTimeSlot === 'evening' ? '#2993B6' : '' }}
                                    onClick={() => handleArrivalButtonClick('evening')}
                                  >
                                    <img src="/assets/images/after6.png" alt="After 6PM" style={{ width: "19px", height: "19px", borderRadius: "0" }} />
                                    After 6PM
                                  </button>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                        <div className="filter-section">
                          <h6 className='smallfilterheading my-3'>Airlines</h6>
                          <div className='mobileHeight'>
                            {Object.keys(airlinesDetails).map(airline => {
                              // Compose logo URL safely
                              const aircode = airlinesDetails?.[airline]?.aircode
                                ? airlinesDetails[airline].aircode.replace(/\s/g, '')
                                : 'XX';
                              const logoUrl = `https://r-xx.bstatic.com/data/airlines_logo/${aircode}.png`;
                              return (
                                <label key={airline} className="mt-4">
                                  <span style={{ display: "flex", flexDirection: "row" }}>
                                    <img
                                      src={logoUrl}
                                      alt={airline}
                                      style={{
                                        marginTop: "2px",
                                        marginLeft: "9px",
                                        marginRight: "5px"
                                      }}
                                    />

                                    <p className='p-1 m-0'>
                                      {airline} ({airlinesDetails?.[airline]?.count || 0} flights)
                                    </p>
                                  </span>
                                  <p className="price-checkbox m-0">
                                    <input
                                      type="checkbox"
                                      className="checkboxsize"
                                      checked={selectedAirlines.includes(airline)}
                                      onChange={() => handleAirlineCheckboxChange(airline)}
                                    />
                                  </p>
                                </label>
                              );
                            })}

                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="close-filter-button" onClick={closeModal}>
                        Apply filters
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Backdrop to close modal on clicking outside */}
            {/* {showModal && <div className="modal-backdrop fade show" onClick={closeModal}></div>} */}
          </div>

          {/* ----------------------------Div for one way --------------------------------------------- */}

          {tripType === "1" && (
            <div className="col-xl-9 col-lg-8 col-md-8 px-1 listingFlightDetails mt-4">
              {/* <div className="slider-containerLS mx-auto">
                <button className="slider-button" id="prev-button" ref={prevButtonRef}>
                  <img src='/assets/images/sliderLeftBtn.png' />
                </button>
                <div className="slider" id="slider" ref={sliderRef}>
                  {calendarData.length > 0 ? (
                    calendarData
                      .sort((a, b) => new Date(a.dt) - new Date(b.dt))
                      .map((cd, index) => (
                        <div className="slide" key={index} onClick={() => goToDate(new Date(cd.dt))} style={{ cursor: 'pointer' }}>
                          <p className="m-0 text-muted smallfont">
                            {new Date(cd.dt).toLocaleDateString('en-US', {
                              weekday: 'short',
                              day: 'numeric',
                              month: 'short'
                            })}
                          </p>
                          <h5 className="bluefontcolor" style={{
                            color: cd.ismin ? '#2D92B2' : cd.ismax ? 'red' : '#2D92B2'
                            , color: new Date(cd.dt?.split('T')[0]).getTime() === new Date(startDate).getTime() ? '#2D92B2' : '#5C5C5C'
                          }}>{getCurrencySymbol(currency)}{new Intl.NumberFormat('en-IN').format(Math.round(cd?.amount))}</h5>
                        </div>
                      ))
                  ) : (
                    <div className="loaderlisting" style={{ background: "white" }}>
                      <p>Fetching flights calender data for you.....</p>
                    </div>
                  )}
                </div>
                <button className="slider-button" id="next-button" ref={nextButtonRef}>
                  <img src='/assets/images/sliderRightBtn.png' />
                </button>
              </div> */}
              {filteredFlights.length > 0 ? (
                <div>
                  {
                    filteredFlights.map((flight, index) => (
                      <div key={index} className='mb-3'>
                        <div className='flight-cardMultiCity'>
                          <div className=''>
                            <div className="airline-info mb-2">
                              <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.MarketingAirline?.code}.png`} alt={flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.MarketingAirline?.name} className="airline-logo-one-way" />
                              <div className="airline-details mx-2">
                                <span className="airline-name">{flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.MarketingAirline?.name}</span>
                                <span className="flight-number">{flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.MarketingAirline?.code}{flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.MarketingAirline?.number}</span>
                              </div>
                            </div>
                            <div className="flight-times">
                              <div className="time">
                                <span className="time-value-one-way">{flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.time}</span>
                                <span className="location text-start">{flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.Iata}</span>
                              </div>
                              <div className="duration-container">
                                {/* {flight?.noOfStops === "0" && (
                                  <div className="duration-time">{flight?.duration?.split(':')[0]}h {flight?.duration?.split(':')[1]}m</div>
                                )}
                                {flight?.noOfStops === "1" && (
                                  <div className="duration-time">{flight?.inbwLOTime?.split(':')[0]}h {flight?.inbwLOTime?.split(':')[1]}m</div>
                                )}
                                {flight?.noOfStops === "2" && (
                                  <div className="duration-time">{flight?.inbwLOTime1?.split(':')[0]}h {flight?.inbwLOTime1?.split(':')[1]}m</div>
                                )}
                                {flight?.noOfStops === "3" && (
                                  <div className="duration-time">{flight?.inbwLOTime2?.split(':')[0]}h {flight?.inbwLOTime2?.split(':')[1]}m</div>
                                )} */}

                                <div className="duration-time">
                                  {Math.floor(flight?.OutboundInboundlist[0]?.totaltime / 60)}h:{flight?.OutboundInboundlist[0]?.totaltime % 60}m
                                </div>


                                <div className="duration-graphic">
                                  <img src="/assets/images/planeImage.png" alt="" />
                                </div>
                                <div className="duration-type">
                                  {flight?.OutboundInboundlist?.[0]?.flightlist?.length > 0 && (
                                    flight.OutboundInboundlist[0].flightlist.length - 1 === 0
                                      ? "Non-stop"
                                      : `${flight.OutboundInboundlist[0].flightlist.length - 1} Stop${flight.OutboundInboundlist[0].flightlist.length - 1 > 1 ? "s" : ""}`
                                  )}</div>
                              </div>

                              <div className="time pr-5" style={{ borderRight: "1px solid #e6e6e6" }}>
                                <span className="time-value-one-way">{flight?.OutboundInboundlist?.[0]?.flightlist?.[
                                  flight?.OutboundInboundlist?.[0]?.flightlist.length - 1
                                ]?.Arrival?.time}</span>
                                <span className="location text-start">{flight?.OutboundInboundlist?.[0]?.flightlist?.[
                                  flight?.OutboundInboundlist?.[0]?.flightlist.length - 1
                                ]?.Arrival?.Iata}</span>
                              </div>


                              {/* {flight?.noOfStops === "0" && (
                                <div className="time pr-5" style={{ borderRight: "1px solid #e6e6e6" }}>
                                  <span className="time-value-one-way">{flight?.OutboundInboundlist.length-1?.[0]}</span>
                                  <span className="location text-start">{flight?.arrCode?.split(',')[0]}</span>
                                </div>
                              )}
                              {flight?.noOfStops === "1" && (
                                <div className="time pr-5" style={{ borderRight: "1px solid #e6e6e6" }}>
                                  <span className="time-value">{flight?.lOendtime}</span>
                                  <span className="location text-start">{flight?.lOlocationArr?.split(',')[0]}</span>
                                </div>
                              )}
                              {flight?.noOfStops === "2" && (
                                <div className="time pr-5" style={{ borderRight: "1px solid #e6e6e6" }}>
                                  <span className="time-value">{flight?.lOendtime1}</span>
                                  <span className="location text-start">{flight?.lOlocationArr1?.split(',')[0]}</span>
                                </div>
                              )}
                              {flight?.noOfStops === "3" && (
                                <div className="time pr-5" style={{ borderRight: "1px solid #e6e6e6" }}>
                                  <span className="time-value">{flight?.lOendtime2}</span>
                                  <span className="location text-start">{flight?.lOlocationArr2?.split(',')[0]}</span>
                                </div>
                              )} */}
                              <div className="time text-start">
                                <div className="current-price">{getCurrencySymbol(flight?.price?.currency_sign)} {new Intl.NumberFormat('en-IN').format(Math.round(flight?.price?.tarriffinfo?.[0]?.per_pax_total_price))}</div>
                                <span className='adultonewaytext text-start'>Per Adult</span>

                              </div>
                            </div>
                            <div className="price-info">
                              <button className="view-prices-btn" onClick={() => handleUpsellPricing(flight)}>
                                View Prices
                              </button>
                              {/* Modal */}
                              <div className="viewMultiDetails p-0">
                                <div className='view-flight-details ' style={{ fontSize: "13px" }}>
                                  {flight?.freeText?.split('|')[0]}
                                </div>
                                <a href="#" className="view-flight-details " onClick={(e) => {
                                  e.preventDefault();
                                  viewFlightDetails(index);
                                }} >
                                  View Flight Details <img src="/assets/images/viewFlightDetailsArrow.png" alt="" />
                                </a>
                              </div>
                            </div>
                          </div>

                          {/* <div className="viewMultiDetails p-2 pl-4">
                            <div style={{ fontSize: "11px", textAlign: "justify" }}>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: flight?.freeText?.split('|')[1],
                                }}
                                className='px-3'
                              />
                            </div>
                          </div> */}
                        </div>
                        {detailsVisible && selectedIndex === index && (
                          <div className="" id={`tabs-container${index}`} style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px", marginTop: "2%" }}>
                            <div className="tabs my-2">
                              <button className={`tab-button ${activeTabs[index] === `flight-details${index}` ? 'active' : ''}`} onClick={() => openTab(index, `flight-details${index}`)}>
                                Flight Details
                              </button>
                              {/* <button className={`tab-button ${activeTabs[index] === `price${index}` ? 'active' : ''}`} onClick={() => openTab(index, `price${index}`)}>
                                Prices
                              </button> */}
                              <button className={`tab-button ${activeTabs[index] === `fare-summary${index}` ? 'active' : ''}`} onClick={() => openTab(index, `fare-summary${index}`)}>
                                Fare Summary
                              </button>
                              {/* <button className={`tab-button ${activeTabs[index] === `cancellation${index}` ? 'active' : ''}`} onClick={() => openTab(index, `cancellation${index}`)}>
                                Cancellation
                              </button> */}
                              {/* <button className={`tab-button ${activeTabs[index] === `date-change${index}` ? 'active' : ''}`} onClick={() => openTab(index, `date-change${index}`)}>
                                Date Change
                              </button> */}
                            </div>
                            <div id={`flight-detail${index}`} className={`tab-content ${activeTabs[index] === `flight-details${index}` ? 'active' : ''}`}>
                              <div className="flight-info">
                                <div className="FDHeaderListing">
                                  {/* <div className='ListingDetailsDeparture'>
                                    <h5 className='metropolis-semibold'>{flight?.depCode?.split(',')[2]}</h5>
                                    <img src="/assets/images/planeImage.png" alt="" />
                                    {flight?.noOfStops === "0" && (<h5 className='metropolis-semibold'>{flight?.arrCode?.split(',')[2]}</h5>)}
                                    {flight?.noOfStops === "1" && (<h5 className='metropolis-semibold'>{flight?.lOlocationArr?.split(',')[2]}</h5>)}
                                    {flight?.noOfStops === "2" && (<h5 className='metropolis-semibold'>{flight?.lOlocationArr1?.split(',')[2]}</h5>)}
                                    {flight?.noOfStops === "3" && (<h5 className='metropolis-semibold'>{flight?.lOlocationArr2?.split(',')[2]}</h5>)}
                                  </div> */}
                                  <div className="flight-details m-0">
                                    <span>
                                      {new Date(flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.Date?.split('-').reverse().join('-'))
                                        .toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })}
                                      &nbsp; {' | '} &nbsp;
                                      {flight?.OutboundInboundlist?.[0]?.flightlist?.length > 0 && (
                                        flight.OutboundInboundlist[0].flightlist.length - 1 === 0
                                          ? "Non-stop"
                                          : `${flight.OutboundInboundlist[0].flightlist.length - 1} Stop${flight.OutboundInboundlist[0].flightlist.length - 1 > 1 ? "s" : ""}`
                                      )}
                                      &nbsp; {' | '} &nbsp;
                                      {Math.floor(flight?.OutboundInboundlist?.[0]?.totaltime / 60)}h :
                                      {flight?.OutboundInboundlist?.[0]?.totaltime % 60}m
                                      &nbsp; {' | '} &nbsp;
                                      {flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.CabinClassText}

                                      {/* {flight?.noOfStops === "0" && `${flight?.duration?.split(':')[0]}h ${flight?.duration?.split(':')[1]}m`}
                                      {flight?.noOfStops === "1" && `${flight?.inbwLOTime?.split(':')[0]}h ${flight?.inbwLOTime?.split(':')[1]}m`}
                                      {flight?.noOfStops === "2" && `${flight?.inbwLOTime1?.split(':')[0]}h ${flight?.inbwLOTime1?.split(':')[1]}m`}
                                      {flight?.noOfStops === "3" && `${flight?.inbwLOTime2?.split(':')[0]}h ${flight?.inbwLOTime2?.split(':')[1]}m`} */}
                                    </span>
                                  </div>
                                </div>
                                {flight?.OutboundInboundlist?.[0]?.flightlist?.map((flightlist, index, arr) => {
                                  return <div className='listingdataContainer'>
                                    <div className="main-info">
                                      <div className='flightdetailLeftContainer'>
                                        <div className="airline">
                                          <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flightlist?.OperatingAirline.code}.png`} alt={flightlist?.OperatingAirline.name} className="airlineIconimg" />
                                          <span className='d-flex text-muted'> <h5 className='text-dark metropolis-semibold'> {flightlist?.OperatingAirline.name} </h5> &nbsp; | &nbsp;  {flightlist?.OperatingAirline?.code} • {flightlist?.OperatingAirline?.number} </span>
                                        </div>

                                        <div className="flight px-2 py-3 w-100">
                                          <div className="departure departure-width">
                                            <h4 className="time metropolis-bold">{flightlist?.Departure?.time}</h4>
                                            <span className="date text-dark metropolis-semibold">{new Date(flightlist?.Departure?.Date.split('-').reverse().join('-')).toLocaleDateString('en-US', {
                                              weekday: 'short',
                                              day: 'numeric',
                                              month: 'short',
                                              year: 'numeric'
                                            })}</span>
                                            <span className="location">{flightlist?.Departure?.city} - {flightlist?.Departure?.Iata}</span>
                                            <span className="airport">{flightlist?.Departure?.name}</span>

                                            {flightlist?.Departure?.Terminal && (
                                              <h6 className="terminal text-dark metropolis-semibold">
                                                Terminal {flightlist.Departure.Terminal}
                                              </h6>
                                            )}
                                          </div>
                                          <div className="duration-container duration-container-width">
                                            <div className="duration-time my-2">{Math.floor(flightlist?.FlightMinutes / 60)}h&nbsp;
                                              {flightlist?.FlightMinutes % 60}m</div>
                                            <div className="duration-graphic">
                                              <img src="/assets/images/flightIconListing.png" alt="" className='duration-graphic-img' />
                                            </div>
                                            <div className="duration-type my-2">
                                              {arr.length > 0 && (
                                                arr.length === 1
                                                  ? "Non-stop"
                                                  : `${arr.length - 1} Stop${arr.length - 1 > 1 ? "s" : ""}`
                                              )}
                                            </div>
                                          </div>
                                          <div className="arrival arrival-width">
                                            <h4 className="time metropolis-bold">{flightlist?.Arrival?.time}</h4>
                                            <span className="date text-dark metropolis-semibold">{new Date(flightlist?.Arrival?.Date.split('-').reverse().join('-')).toLocaleDateString('en-US', {
                                              weekday: 'short',
                                              day: 'numeric',
                                              month: 'short',
                                              year: 'numeric'
                                            })}</span>
                                            <span className="location">{flightlist?.Arrival?.city} - {flightlist?.Arrival?.Iata}</span>
                                            <span className="airport">{flightlist?.Arrival?.name}</span>

                                            {flightlist?.Arrival?.Terminal && (
                                              <h6 className="terminal text-dark metropolis-semibold">
                                                Terminal {flightlist.Arrival.Terminal}
                                              </h6>
                                            )}

                                          </div>
                                        </div>

                                      </div>
                                      <div className="baggage-info">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <th>Baggage</th>
                                              <th>Check-in</th>
                                              <th>Cabin</th>
                                            </tr>
                                            <tr>
                                              <td>Adult</td>
                                              <td>{flightlist?.CheckinBaggage?.[0]?.Value === "0Kg" ? "Not include" : flightlist?.CheckinBaggage?.[0]?.Value}</td>
                                              <td>{flightlist?.CheckinBaggage?.[1]?.Value === "0Kg" ? "Not include" : flightlist?.CheckinBaggage?.[1]?.Value}</td>
                                            </tr>

                                          </tbody>
                                        </table>
                                      </div>
                                    </div>

                                    {index < arr.length - 1 && (
                                      <div className="flightLayoverOuter my-2 py-1">
                                        <div className="flightLayover mmtConnectLayover">
                                          <div className="makeFlex">
                                            <b style={{ color: "#1FD78A" }}>Change of planes</b>・
                                            <b>
                                              {(() => {
                                                const firstArrival = flightlist?.Arrival?.time;
                                                const nextDeparture = arr[index + 1]?.Departure?.time;
                                                if (!firstArrival || !nextDeparture) return "";

                                                const [arrH, arrM] = firstArrival.split(":").map(Number);
                                                const [depH, depM] = nextDeparture.split(":").map(Number);

                                                let diff =
                                                  depH * 60 + depM - (arrH * 60 + arrM);
                                                if (diff < 0) diff += 24 * 60; // overnight layover

                                                const hours = Math.floor(diff / 60);
                                                const minutes = diff % 60;

                                                return `${hours}h ${minutes}m`;
                                              })()}
                                            </b>
                                            &nbsp;Layover in {flightlist?.Arrival?.city}
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {/* {flight?.OutboundInboundlist?.[0]?.flightlist?.map((flightlist, index, arr) => {
                                      if (index < arr.length - 1) {
                                        // {console.log("index",index,"flightlist",flightlist,"arr",arr)}
                                        return <div>
                                          <div className="flightLayoverOuter my-2 py-1 my-1">
                                            <div className="flightLayover mmtConnectLayover">
                                              <div className="makeFlex">
                                                <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>  {(() => {
                                                  const firstArrival = flightlist?.Arrival?.time; // current flight arrival
                                                  const nextDeparture = arr?.[index + 1]?.Departure?.time; // next flight departure

                                                  if (!firstArrival || !nextDeparture) return "";

                                                  const [arrH, arrM] = firstArrival.split(":").map(Number);
                                                  const [depH, depM] = nextDeparture.split(":").map(Number);

                                                  const arrTotal = arrH * 60 + arrM;
                                                  const depTotal = depH * 60 + depM;

                                                  let diff = depTotal - arrTotal;
                                                  if (diff < 0) diff += 24 * 60; // handle overnight layover

                                                  const hours = Math.floor(diff / 60);
                                                  const minutes = diff % 60;

                                                  return `${hours}h ${minutes}m`;
                                                })()}</b> m Layover in {flightlist?.Arrival?.city}
                                              </div>
                                            </div>
                                          </div>
                                          <div className=''>
                                            <div className="main-info">
                                              <div className='flightdetailLeftContainer'>
                                                <div className="airline">
                                                  <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flightlist?.Departure?.Iata}.png`} alt={flight?.lOmarkCo?.split('|')[1]} className="airlineIconimg" />
                                                  <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'> {flight?.lOmarkCo?.split('|')[1]}</h5> &nbsp; | &nbsp;  {flight?.lOmarkCo?.split('|')[0]} • {flight?.loFlightNumber} • {flight?.lOairType}</span>
                                                </div>

                                                <div className="flight px-2 py-3 w-100">
                                                  <div className="departure departure-width">
                                                    <h4 className="time metropolis-bold">{flight?.lOstarttime}</h4>
                                                    <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate).toLocaleDateString('en-US', {
                                                      weekday: 'short',
                                                      day: 'numeric',
                                                      month: 'short',
                                                      year: 'numeric'
                                                    })}</span>
                                                    <span className="location">{flightlist.Departure.name} - {flight?.lOlocationDep?.split(',')[0]}</span>
                                                    <span className="airport">{flight?.lOlocationDep?.split(',')[1]}</span>
                                                    {flight?.loDepTerminal && (
                                                      <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal}</h6>
                                                    )}
                                                  </div>
                                                  <div className="duration-container duration-container-width">
                                                    <div className="duration-time py-2">{flight?.loDuration?.split(':')[0]}h {flight?.loDuration?.split(':')[1]}m</div>
                                                    <div className="duration-graphic">
                                                      <img src="/assets/images/flightIconListing.png" alt="" className='duration-graphic-img' />
                                                    </div>
                                                    <div className="duration-type py-2">Non-stop</div>
                                                  </div>
                                                  <div className="arrival arrival-width">
                                                    <h4 className="time metropolis-bold">{flight?.lOendtime}</h4>
                                                    <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate).toLocaleDateString('en-US', {
                                                      weekday: 'short',
                                                      day: 'numeric',
                                                      month: 'short',
                                                      year: 'numeric'
                                                    })}</span>
                                                    <span className="location">{flight?.lOlocationArr?.split(',')[2]} - {flight?.lOlocationArr?.split(',')[0]}</span>
                                                    <span className="airport">{flight?.lOlocationArr?.split(',')[1]}</span>
                                                    {flight?.loArrTerminal && (
                                                      <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal}</h6>
                                                    )}
                                                  </div>
                                                </div>

                                              </div>
                                              <div className="baggage-info">
                                                <table>
                                                  <tbody>
                                                    <tr>
                                                      <th>Baggage</th>
                                                      <th>Check-in</th>
                                                      <th>Cabin</th>
                                                    </tr>
                                                    <tr>
                                                      <td>Adult</td>
                                                      <td>{flight?.lObaggage1 === "0Kg" ? "Not include" : flight?.lObaggage1}</td>
                                                      <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                    </tr>
                                                    {flight?.child > 0 && (
                                                      <tr>
                                                        <td>Child</td>
                                                        <td>{flight?.lObaggage1 === "0Kg" ? "Not include" : flight?.lObaggage1}</td>
                                                        <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                      </tr>
                                                    )}
                                                    {flight?.infant > 0 && (
                                                      <tr>
                                                        <td>Infant</td>
                                                        <td>{flight?.lObaggage1 === "0Kg" ? "Not include" : flight?.lObaggage1}</td>
                                                        <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                      </tr>
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                      return null;
                                    })} */}

                                    {/* {flight?.isLO2 && (
                                    <div>
                                      <div className="flightLayoverOuter my-2">
                                        <div className="flightLayover mmtConnectLayover">
                                          <div className="makeFlex">
                                            <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime1?.split(':')[0]}</b> h <b>{flight?.loTime1?.split(':')[1]}</b> m Layover in {flight?.lOlocationArr?.split(',')[2]}
                                          </div>
                                        </div>
                                      </div>
                                      <div className=''>
                                        <div className="main-info">
                                          <div className='flightdetailLeftContainer'>
                                            <div className="airline">
                                              <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo1?.split('|')[0]}.png`} alt={flight?.lOmarkCo1?.split('|')[1]} className="airlineIconimg" />
                                              <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'>{flight?.lOmarkCo1?.split('|')[1]} </h5> &nbsp; | &nbsp;  {flight?.lOmarkCo1?.split('|')[0]} • {flight?.loFlightNumber1} • {flight?.lOairType1}</span>
                                            </div>

                                            <div className="flight px-2 py-3 w-100">
                                              <div className="departure departure-width">
                                                <h4 className="time text-dark metropolis-bold">{flight?.lOstarttime1}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate1).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationDep1?.split(',')[2]} - {flight?.lOlocationDep1?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationDep1?.split(',')[1]}</span>
                                                {flight?.loDepTerminal1 && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal1}</h6>
                                                )}
                                              </div>
                                              <div className="duration-container duration-container-width">
                                                <div className="duration-time py-2">{flight?.loDuration1?.split(':')[0]}h {flight?.loDuration1?.split(':')[1]}m</div>
                                                <div className="duration-graphic">
                                                  <img src="/assets/images/flightIconListing.png" alt="" className='duration-graphic-img' />
                                                </div>
                                                <div className="duration-type py-2">Non-stop</div>
                                              </div>
                                              <div className="arrival arrival-width">
                                                <h4 className="time text-dark metropolis-semibold">{flight?.lOendtime1}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate1).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationArr1?.split(',')[2]} - {flight?.lOlocationArr1?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationArr1?.split(',')[1]}</span>
                                                {flight?.loArrTerminal1 && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal1}</h6>
                                                )}
                                              </div>
                                            </div>

                                          </div>
                                          <div className="baggage-info">
                                            <table>
                                              <tbody>
                                                <tr>
                                                  <th>Baggage</th>
                                                  <th>Check-in</th>
                                                  <th>Cabin</th>
                                                </tr>
                                                <tr>
                                                  <td>Adult</td>
                                                  <td>{flight?.lObaggage2 === "0Kg" ? "Not include" : flight?.lObaggage2}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                                {flight?.child > 0 && (
                                                  <tr>
                                                    <td>Child</td>
                                                    <td>{flight?.lObaggage2 === "0Kg" ? "Not include" : flight?.lObaggage2}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                                {flight?.infant > 0 && (
                                                  <tr>
                                                    <td>Infant</td>
                                                    <td>{flight?.lObaggage2 === "0Kg" ? "Not include" : flight?.lObaggage2}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )} */}
                                    {/* {flight?.isLO3 && (
                                    <div>
                                      <div className="flightLayoverOuter my-2">
                                        <div className="flightLayover mmtConnectLayover">
                                          <div className="makeFlex">
                                            <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime2?.split(':')[0]}</b> h <b>{flight?.loTime2?.split(':')[1]}</b> m Layover in {flight?.lOlocationArr1?.split(',')[2]}
                                          </div>
                                        </div>
                                      </div>
                                      <div className='listingdataContainer'>
                                        <div className="main-info">
                                          <div className='flightdetailLeftContainer'>
                                            <div className="airline">
                                              <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo2?.split('|')[0]}.png`} alt={flight?.lOmarkCo2?.split('|')[1]} className="airlineIconimg" />
                                              <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'> {flight?.lOmarkCo2?.split('|')[1]} </h5> &nbsp; | &nbsp;   {flight?.lOmarkCo2?.split('|')[0]} • {flight?.loFlightNumber2} • {flight?.lOairType2}</span>
                                            </div>

                                            <div className="flight px-2 py-3 w-100">
                                              <div className="departure departure-width">
                                                <h4 className="time metropolis-bold">{flight?.lOstarttime2}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate2).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationDep2?.split(',')[2]} - {flight?.lOlocationDep2?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationDep2?.split(',')[1]}</span>
                                                {flight?.loDepTerminal2 && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal2}</h6>
                                                )}
                                              </div>
                                              <div className="duration-container duration-container-width">
                                                <div className="duration-time py-2">{flight?.loDuration2?.split(':')[0]}h {flight?.loDuration2?.split(':')[1]}m</div>
                                                <div className="duration-graphic">
                                                  <img src="/assets/images/flightIconListing.png" alt="" className='duration-graphic-img' />
                                                </div>
                                                <div className="duration-type  py-2">Non-stop</div>
                                              </div>
                                              <div className="arrival arrival-width">
                                                <h4 className="time text-dark metropolis-bold">{flight?.lOendtime2}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate2).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationArr2?.split(',')[2]} - {flight?.lOlocationArr2?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationArr2?.split(',')[1]}</span>
                                                {flight?.loArrTerminal2 && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal2}</h6>
                                                )}
                                              </div>
                                            </div>

                                          </div>
                                          <div className="baggage-info">
                                            <table>
                                              <tbody>
                                                <tr>
                                                  <th>Baggage</th>
                                                  <th>Check-in</th>
                                                  <th>Cabin</th>
                                                </tr>
                                                <tr>
                                                  <td>Adult</td>
                                                  <td>{flight?.lObaggage3 === "0Kg" ? "Not include" : flight?.lObaggage3}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                                {flight?.child > 0 && (
                                                  <tr>
                                                    <td>Child</td>
                                                    <td>{flight?.lObaggage3 === "0Kg" ? "Not include" : flight?.lObaggage3}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                                {flight?.infant > 0 && (
                                                  <tr>
                                                    <td>Infant</td>
                                                    <td>{flight?.lObaggage3 === "0Kg" ? "Not include" : flight?.lObaggage3}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )} */}
                                  </div>
                                })}
                              </div>
                              {/* <div id={`fare-summary${index}`} className={`tab-content ${activeTabs[index] === `fare-summary${index}` ? 'active' : ''}`}>
                                <div className="farecontainer">
                                  <div className="fareheader">
                                    <h5 className='fw-bold'>Fare Breakup</h5>
                                  </div>
                                  <div className="farerow">
                                    <div>Base Fare</div>
                                    <div className="time text-start">
                                      <span className='adultonewaytext text-start'>Starts from</span>
                                      <div className="current-price">{getCurrencySymbol(flight?.price?.currency_sign)} {new Intl.NumberFormat('en-IN').format(Math.round(flight?.price?.base_price))}</div>

                                    </div>
                                  </div>
                                  <div className="farerow">
                                    <div>Surcharges</div>
                                    <div>{getCurrencySymbol(flight?.price?.currency_sign)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.price?.tax_price))}</div>
                                  </div>
                                  <div className="farerow total-row">
                                    <div>Total Fare </div>
                                    <div>{getCurrencySymbol(flight?.price?.currency_sign)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.price?.total_price))}</div>
                                  </div>
                                </div>
                              </div>
                              <div id={`cancellation${index}`} className={`tab-content ${activeTabs[index] === `cancellation${index}` ? 'active' : ''}`}>
                                <div className="farecontainer">
                                  <div className="fareheader">Cancellation Charges</div>
                                  <div className="farerow">
                                    <div>O Hours - 4 Hours</div>
                                    <div>Adult : Non Refundable</div>
                                  </div>
                                  <div className="farerow">
                                    <div>4 Hours - 4 Days</div>
                                    <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649</div>
                                  </div>
                                  <div className="farerow">
                                    <div>4 Hours - 365 Days</div>
                                    <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649</div>
                                  </div>
                                </div>
                                <p className="cancellationText1 mt-2 text-danger border p-2 rounded border-danger ">
                                  *From the Time of Departure
                                </p>
                              </div>
                              <div id={`date-change${index}`} className={`tab-content ${activeTabs[index] === `date-change${index}` ? 'active' : ''}`}>
                                <div className="farecontainer2">
                                  <div className="fareheader">Date Change Charges</div>
                                  <div className="farerow">
                                    <div>O Hours - 4 Hours</div>
                                    <div>Adult : Non Changeable</div>
                                  </div>
                                  <div className="farerow">
                                    <div>4 Hours - 4 Days</div>
                                    <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649 + Fare Difference</div>
                                  </div>
                                  <div className="farerow">
                                    <div>4 Hours - 365 Days</div>
                                    <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649 + Fare Difference</div>
                                  </div>
                                </div>
                                <p className="cancellationText mt-2 text-danger border p-2 rounded border-danger ">
                                  *From the Time of Departure
                                </p>
                              </div> */}
                            </div>


                            {/* <div id={`price${index}`} className={`tab-content ${activeTabs[index] === `price${index}` ? 'active' : ''}`}>
                              </div> */}

                            {/* Fare Summary  */}

                            <div id={`fare-summary${index}`} className={`tab-content ${activeTabs[index] === `fare-summary${index}` ? 'active' : ''}`}>
                              <div className="farecontainer">
                                <div className="fareheader">
                                  <h5 className="fw-bold">Fare Breakup</h5>
                                </div>
                                <div className="farerow">
                                  <div>Base Fare</div>
                                  <div>{getCurrencySymbol(flight?.price?.currency_sign)}&nbsp;
                                    {new Intl.NumberFormat('en-IN').format(Math.round(flight?.price?.base_price))}</div>
                                </div>
                                <div className="farerow">
                                  <div>Surcharges</div>
                                  <div>{getCurrencySymbol(flight?.price?.currency_sign)}&nbsp;{new Intl.NumberFormat('en-IN').format(Math.round(flight?.price?.tax_price))}</div>
                                </div>
                                <div className="farerow total-row">
                                  <div>Total Fare </div>
                                  <div>{getCurrencySymbol(flight?.price?.currency_sign)}&nbsp;{new Intl.NumberFormat('en-IN').format(Math.round(flight?.price?.total_price))}</div>
                                </div>
                              </div>
                            </div>

                            {/* <-------- Cancellation --------- */}

                            <div id={`cancellation${index}`} className={`tab-content ${activeTabs[index] === `cancellation${index}` ? 'active' : ''}`}>
                              <div className="farecontainer">
                                <div className="fareheader">Cancellation Charges</div>
                                <div className="farerow">
                                  <div>O Hours - 4 Hours</div>
                                  <div>Adult : Non Refundable</div>
                                </div>
                                <div className="farerow">
                                  <div>4 Hours - 4 Days</div>
                                  <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649</div>
                                </div>
                                <div className="farerow">
                                  <div>4 Hours - 365 Days</div>
                                  <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649</div>
                                </div>
                              </div>
                              <p className="cancellationText1 mt-2 text-danger border p-2 rounded border-danger ">
                                *From the Time of Departure
                              </p>
                            </div>

                            {/* Date Change Charges  */}

                            {/* <div id={`date-change${index}`} className={`tab-content ${activeTabs[index] === `date-change${index}` ? 'active' : ''}`}>
                              <div className="farecontainer2">
                                <div className="fareheader">Date Change Charges</div>
                                <div className="farerow">
                                  <div>O Hours - 4 Hours</div>
                                  <div>Adult : Non Changeable</div>
                                </div>
                                <div className="farerow">
                                  <div>4 Hours - 4 Days</div>
                                  <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649 + Fare Difference</div>
                                </div>
                                <div className="farerow">
                                  <div>4 Hours - 365 Days</div>
                                  <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649 + Fare Difference</div>
                                </div>
                              </div>
                              <p className="cancellationText mt-2 text-danger border p-2 rounded border-danger ">
                                *From the Time of Departure
                              </p>
                            </div> */}
                          </div>
                        )}
                      </div>
                    ))
                  }
                </div>
              ) : (!loading &&
                <div className="not-found-container">
                  <div className="airplane">
                    <img src="./assets/images/notfound.png" alt="" />
                  </div>
                  <h1>Flight Not Found</h1>
                  <p>We couldn't find the flight you were looking for. Please try again.</p>
                </div>
              )}
            </div>
          )}
          {/* ----------------------------Div for one way --------------------------------------------- */}

          {/* ----------------------------Div for round trip ---------------------------------------------*/}
          {tripType === "2" && (

            <div className="px-1 listingFlightDetails">

              {!loading2 && filteredFlights.length > 0 ? (
                <div>
                  {
                    filteredFlights.map((flight, index) => (
                      <div key={index} className='mt-4'>
                        <div className='flight-cardMultiCity'>
                          <div>
                            <div className='roundWayDepart pl-2'>
                              <p className='text-start m-0 fw-bold my-2'>Depart: <img className='ml-2' src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.MarketingAirline?.code}.png`} alt="" /> {flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.MarketingAirline.name} </p>
                              <div className="departDataContainer">
                                <div className="time">
                                  <span className="time-value">{flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure.time}</span>
                                  <span className="location text-start">{flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure.Iata}</span>
                                </div>
                                <div className="duration-container" style={{ fontSize: "13px", marginTop: "1.5%" }}>

                                  <div className="duration-time">{Math.floor(flight?.OutboundInboundlist?.[0]?.totaltime / 60)}h {flight?.OutboundInboundlist?.[0]?.totaltime % 60}m</div>

                                  {/* {flight?.noOfStops === "0" && (
                                    <div className="duration-time">{Math.floor(flight?.OutboundInboundlist?.[0]?.totaltime / 60)}h {flight?.OutboundInboundlist?.[0]?.totaltime % 60}m</div>
                                  )}
                                  {flight?.noOfStops === "1" && (
                                    <div className="duration-time">{flight?.inbwLOTime?.split(':')[0]}h {flight?.inbwLOTime?.split(':')[1]}m</div>
                                  )}
                                  {flight?.noOfStops === "2" && (
                                    <div className="duration-time">{flight?.inbwLOTime1?.split(':')[0]}h {flight?.inbwLOTime1?.split(':')[1]}m</div>
                                  )}
                                  {flight?.noOfStops === "3" && (
                                    <div className="duration-time">{flight?.inbwLOTime2?.split(':')[0]}h {flight?.inbwLOTime2?.split(':')[1]}m</div>
                                  )} */}
                                  <div className="duration-graphic">
                                    <img src="/assets/images/planeImage.png" alt="" />
                                  </div>
                                  <div className="duration-type" style={{ fontSize: "13px" }}>
                                    {flight?.OutboundInboundlist?.[0]?.flightlist?.length > 0 && (
                                      flight.OutboundInboundlist[0].flightlist.length - 1 === 0
                                        ? "Non-stop"
                                        : `${flight.OutboundInboundlist[0].flightlist.length - 1} Stop${flight.OutboundInboundlist[0].flightlist.length - 1 > 1 ? "s" : ""}`
                                    )}</div>
                                </div>

                                <div className="time">
                                  <span className="time-value">{flight?.OutboundInboundlist?.[0]?.flightlist?.[flight?.OutboundInboundlist?.[0]?.flightlist?.length - 1]?.Arrival.time}</span>
                                  <span className="location text-end">{flight?.OutboundInboundlist?.[0]?.flightlist?.[flight?.OutboundInboundlist?.[0]?.flightlist?.length - 1]?.Arrival.Iata}</span>
                                </div>

                                {/* {flight?.noOfStops === "0" && (
                                  <div className="time">
                                    <span className="time-value">{flight?.arrivalTime}</span>
                                    <span className="location text-end">{flight?.arrCode?.split(',')[0]}</span>
                                  </div>
                                )}
                                {flight?.noOfStops === "1" && (
                                  <div className="time">
                                    <span className="time-value">{flight?.lOendtime}</span>
                                    <span className="location text-end">{flight?.lOlocationArr??.split(',')[0]}</span>
                                  </div>
                                )}
                                {flight?.noOfStops === "2" && (
                                  <div className="time">
                                    <span className="time-value">{flight?.lOendtime1}</span>
                                    <span className="location text-end">{flight?.lOlocationArr1??.split(',')[0]}</span>
                                  </div>
                                )}
                                {flight?.noOfStops === "3" && (
                                  <div className="time">
                                    <span className="time-value">{flight?.lOendtime2}</span>
                                    <span className="location text-end">{flight?.lOlocationArr2??.split(',')[0]}</span>
                                  </div>
                                )} */}
                              </div>
                            </div>
                            <div className='roundWayDepart'>
                              <p className='text-start m-0 fw-bold my-2'>Return: <img className='ml-2' src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.OutboundInboundlist?.[1]?.flightlist?.[0]?.MarketingAirline?.code}.png`} alt="" /> {flight?.OutboundInboundlist?.[1]?.flightlist?.[0]?.MarketingAirline?.name} </p>
                              <div className="departDataContainer">
                                <div className="time">
                                  <span className="time-value">{flight?.OutboundInboundlist?.[1]?.flightlist?.[0]?.Departure.time}</span>
                                  <span className="location text-start">{flight?.OutboundInboundlist?.[1]?.flightlist?.[0]?.Departure.Iata}</span>
                                </div>
                                <div className="duration-container" style={{ fontSize: "13px", marginTop: "1.5%" }}>

                                  <div className="duration-time">{Math.floor(flight?.OutboundInboundlist?.[1]?.totaltime / 60)}h {flight?.totaltime % 60}m</div>

                                  {/* {flight?.retnoOfStops === "0" && (
                                    <div className="duration-time">{flight?.retduration?.split(':')[0]}h {flight?.retduration?.split(':')[1]}m</div>
                                  )}
                                  {flight?.retnoOfStops === "1" && (
                                    <div className="duration-time">{flight?.retinbwLOTime?.split(':')[0]}h {flight?.retinbwLOTime?.split(':')[1]}m</div>
                                  )}
                                  {flight?.retnoOfStops === "2" && (
                                    <div className="duration-time">{flight?.retinbwLOTime1?.split(':')[0]}h {flight?.retinbwLOTime1?.split(':')[1]}m</div>
                                  )}
                                  {flight?.retnoOfStops === "3" && (
                                    <div className="duration-time">{flight?.retinbwLOTime2?.split(':')[0]}h {flight?.retinbwLOTime2?.split(':')[1]}m</div>
                                  )} */}
                                  <div className="duration-graphic">
                                    <img src="/assets/images/planeImage.png" alt="" />
                                  </div>
                                  <div className="duration-type" style={{ fontSize: "13px", marginTop: "1.5%" }}>
                                    {flight?.OutboundInboundlist?.[1]?.flightlist?.length > 0 && (
                                      flight.OutboundInboundlist[1].flightlist.length - 1 === 0
                                        ? "Non-stop"
                                        : `${flight.OutboundInboundlist[1].flightlist.length - 1} Stop${flight.OutboundInboundlist[1].flightlist.length - 1 > 1 ? "s" : ""}`
                                    )}</div>
                                </div>


                                <div className="time">
                                  <span className="time-value">{flight?.OutboundInboundlist?.[1]?.flightlist?.[flight?.OutboundInboundlist?.[1]?.flightlist?.length - 1]?.Arrival.time}</span>
                                  <span className="location text-end">{flight?.OutboundInboundlist?.[1]?.flightlist?.[flight?.OutboundInboundlist?.[1]?.flightlist?.length - 1]?.Arrival.Iata}</span>
                                </div>

                                {/* {flight?.retnoOfStops === "0" && (
                                  <div className="time">
                                    <span className="time-value">{flight?.retarrivalTime}</span>
                                    <span className="location text-end">{flight?.retarrCode?.split(',')[0]}</span>
                                  </div>
                                )}
                                {flight?.retnoOfStops === "1" && (
                                  <div className="time">
                                    <span className="time-value">{flight?.retLOendtime}</span>
                                    <span className="location text-end">{flight?.retLOlocationArr??.split(',')[0]}</span>
                                  </div>
                                )}
                                {flight?.retnoOfStops === "2" && (
                                  <div className="time">
                                    <span className="time-value">{flight?.retLOendtime1}</span>
                                    <span className="location text-end">{flight?.retLOlocationArr1??.split(',')[0]}</span>
                                  </div>
                                )}
                                {flight?.retnoOfStops === "3" && (
                                  <div className="time">
                                    <span className="time-value">{flight?.retLOendtime2}</span>
                                    <span className="location text-end">{flight?.retLOlocationArr2??.split(',')[0]}</span>
                                  </div>
                                )} */}
                              </div>
                            </div>
                            <div className="price-infoContainer">
                              <div className="time">
                                <div className="current-price-multi">{getCurrencySymbol(flight?.price?.currency_sign)}&nbsp;{new Intl.NumberFormat('en-IN').format(Math.round(flight?.price?.tarriffinfo?.[0]?.per_pax_total_price))}</div>
                                <span className='adultonewaytext text-start'>Per Adult</span>

                              </div>
                              <div className="price-info-round-trip text-start">
                                <button className="view-prices-btn" onClick={() => handleUpsellPricing(flight)}>
                                  View Prices
                                </button>
                                <div className="viewMultiDetails p-0">
                                  <div className='view-flight-details' style={{ fontSize: "12px" }}>
                                    {flight?.freeText?.split('|')[0]}
                                  </div>
                                  <a href="#" className="view-flight-details" onClick={(e) => {
                                    e.preventDefault();
                                    viewFlightDetails(index);
                                  }} >
                                    View Flight Details <img src="/assets/images/viewFlightDetailsArrow.png" alt="" />
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="viewMultiDetails p-0 ">
                            <div style={{ fontSize: "12px", textAlign: "justify" }} className='px-2'>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: flight?.freeText?.split('|')[1],
                                }}

                              />

                            </div>
                          </div>
                        </div>
                        {detailsVisible && selectedIndex === index && (


                          <div className="" id={`tabs-container${index}`} style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px", marginTop: "2%" }}>
                            <div className="tabs">
                              <button className={`tab-button ${activeTabs1[index] === `flight-details${index}` ? 'active' : ''}`} onClick={() => openTab1(index, `flight-details${index}`)}>
                                Flight Details
                              </button>
                              <button className={`tab-button ${activeTabs1[index] === `fare-summary${index}` ? 'active' : ''}`} onClick={() => openTab1(index, `fare-summary${index}`)}>
                                Fare Summary
                              </button>
                              {/* <button className={`tab-button ${activeTabs1[index] === `cancellation${index}` ? 'active' : ''}`} onClick={() => openTab1(index, `cancellation${index}`)}>
                        Cancellation
                      </button>
                      <button className={`tab-button ${activeTabs1[index] === `date-change${index}` ? 'active' : ''}`} onClick={() => openTab1(index, `date-change${index}`)}>
                        Date Change
                      </button> */}
                            </div>

                            <div id={`flight-details${index}`} className={`tab-content ${activeTabs1[index] === `flight-details${index}` ? 'active' : ''}`}>
                              <div className="flight-info">
                                <div className="FDHeaderListing">
                                  <div className='ListingDetailsDeparture'>
                                    <h6 className='metropolis-semibold m-0'>{flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure.city}</h6>
                                    <img src="/assets/images/planeImage.png" alt="" />
                                    <h6 className='metropolis-semibold m-0'>{flight?.OutboundInboundlist?.[0]?.flightlist?.[flight?.OutboundInboundlist?.[0]?.flightlist?.length - 1]?.Arrival.city}</h6>
                                    {/* {flight?.noOfStops === "0" && (<h5 className='metropolis-semibold'>{flight?.arrCode?.split(',')[2]}</h5>)}
                                    {flight?.noOfStops === "1" && (<h5 className='metropolis-semibold'>{flight?.lOlocationArr?.split(',')[2]}</h5>)}
                                    {flight?.noOfStops === "2" && (<h5 className='metropolis-semibold'>{flight?.lOlocationArr1?.split(',')[2]}</h5>)}
                                    {flight?.noOfStops === "3" && (<h5 className='metropolis-semibold'>{flight?.lOlocationArr2?.split(',')[2]}</h5>)} */}
                                  </div>
                                  <div className="flight-details">
                                    <span>{new Date(flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure.Date?.split('-').reverse().join('-')).toLocaleDateString('en-US', {
                                      weekday: 'short',
                                      day: 'numeric',
                                      month: 'short',
                                      year: 'numeric'
                                    })} {' | '} {flight?.OutboundInboundlist?.[0]?.flightlist?.length > 0 && (
                                      flight.OutboundInboundlist[0].flightlist.length - 1 === 0
                                        ? "Non-stop"
                                        : `${flight.OutboundInboundlist[0].flightlist.length - 1} Stop${flight.OutboundInboundlist[0].flightlist.length - 1 > 1 ? "s" : ""}`
                                    )}
                                      {' | '}
                                      {/* {flight?.noOfStops === "0" && `${flight?.duration?.split(':')[0]}h ${flight?.duration?.split(':')[1]}m`}
                                      {flight?.noOfStops === "1" && `${flight?.inbwLOTime?.split(':')[0]}h ${flight?.inbwLOTime?.split(':')[1]}m`}
                                      {flight?.noOfStops === "2" && `${flight?.inbwLOTime1?.split(':')[0]}h ${flight?.inbwLOTime1?.split(':')[1]}m`}
                                      {flight?.noOfStops === "3" && `${flight?.inbwLOTime2?.split(':')[0]}h ${flight?.inbwLOTime2?.split(':')[1]}m`} */}
                                      {flight?.OutboundInboundlist?.[0]?.totaltime && `${Math.floor(flight?.OutboundInboundlist?.[0]?.totaltime / 60)}h ${flight?.OutboundInboundlist?.[0]?.totaltime % 60}m`}
                                      {' | '}
                                      {flight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.CabinClassText}
                                    </span>
                                  </div>
                                </div>
                                {flight?.OutboundInboundlist?.[0]?.flightlist?.map((flightlist, index, arr) => {
                                  return <div className='listingdataContainer'>
                                    <div className="main-info">
                                      <div className='flightdetailLeftContainer'>
                                        <div className="airline">
                                          <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flightlist?.OperatingAirline.code}.png`} alt={flightlist?.OperatingAirline.name} className="airlineIconimg" />
                                          <span className='d-flex text-muted'> <h5 className='text-dark metropolis-semibold'> {flightlist?.OperatingAirline.name} </h5> &nbsp; | &nbsp;  {flightlist?.OperatingAirline?.code} • {flightlist?.OperatingAirline?.number} </span>
                                        </div>

                                        <div className="flight px-2 py-3 w-100">
                                          <div className="departure departure-width">
                                            <h4 className="time metropolis-bold">{flightlist?.Departure?.time}</h4>
                                            <span className="date text-dark metropolis-semibold">{new Date(flightlist?.Departure?.Date.split('-').reverse().join('-')).toLocaleDateString('en-US', {
                                              weekday: 'short',
                                              day: 'numeric',
                                              month: 'short',
                                              year: 'numeric'
                                            })}</span>
                                            <span className="location">{flightlist?.Departure?.city} - {flightlist?.Departure?.Iata}</span>
                                            <span className="airport">{flightlist?.Departure?.name}</span>

                                            {flightlist?.Departure?.Terminal && (
                                              <h6 className="terminal text-dark metropolis-semibold">
                                                Terminal {flightlist.Departure.Terminal}
                                              </h6>
                                            )}
                                          </div>
                                          <div className="duration-container duration-container-width">
                                            <div className="duration-time my-2">{Math.floor(flightlist?.FlightMinutes / 60)}h&nbsp;
                                              {flightlist?.FlightMinutes % 60}m</div>
                                            <div className="duration-graphic">
                                              <img src="/assets/images/flightIconListing.png" alt="" className='duration-graphic-img' />
                                            </div>
                                            <div className="duration-type my-2">
                                              {arr.length > 0 && (
                                                arr.length === 1
                                                  ? "Non-stop"
                                                  : `${arr.length - 1} Stop${arr.length - 1 > 1 ? "s" : ""}`
                                              )}
                                            </div>
                                          </div>
                                          <div className="arrival arrival-width">
                                            <h4 className="time metropolis-bold">{flightlist?.Arrival?.time}</h4>
                                            <span className="date text-dark metropolis-semibold">{new Date(flightlist?.Arrival?.Date.split('-').reverse().join('-')).toLocaleDateString('en-US', {
                                              weekday: 'short',
                                              day: 'numeric',
                                              month: 'short',
                                              year: 'numeric'
                                            })}</span>
                                            <span className="location">{flightlist?.Arrival?.city} - {flightlist?.Arrival?.Iata}</span>
                                            <span className="airport">{flightlist?.Arrival?.name}</span>

                                            {flightlist?.Arrival?.Terminal && (
                                              <h6 className="terminal text-dark metropolis-semibold">
                                                Terminal {flightlist.Arrival.Terminal}
                                              </h6>
                                            )}

                                          </div>
                                        </div>

                                      </div>
                                      <div className="baggage-info">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <th>Baggage</th>
                                              <th>Check-in</th>
                                              <th>Cabin</th>
                                            </tr>
                                            <tr>
                                              <td>Adult</td>
                                              <td>{flightlist?.CheckinBaggage?.[0]?.Value === "0Kg" ? "Not include" : flightlist?.CheckinBaggage?.[0]?.Value}g</td>
                                              {/* <td>{flightlist?.CheckinBaggage?.[1]?.Value === "0Kg" ? "Not include" : flightlist?.CheckinBaggage?.[1]?.Value}</td> */}
                                            </tr>
                                            {flight?.child > 0 && (
                                              <tr>
                                                <td>Child</td>
                                                <td>{flightlist?.CheckinBaggage?.[1]?.Value === "0Kg" ? "Not include" : flightlist?.CheckinBaggage?.[1]?.Value}</td>
                                                <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                              </tr>
                                            )}
                                            {flight?.infant > 0 && (
                                              <tr>
                                                <td>Infant</td>
                                                <td>{flight?.baggage === "0Kg" ? "Not include" : flight?.baggage}</td>
                                                <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>

                                    {index < arr.length - 1 && (
                                      <div className="flightLayoverOuter my-2 py-1">
                                        <div className="flightLayover mmtConnectLayover">
                                          <div className="makeFlex">
                                            <b style={{ color: "#1FD78A" }}>Change of planes</b>・
                                            <b>
                                              {(() => {
                                                const firstArrival = flightlist?.Arrival?.time;
                                                const nextDeparture = arr[index + 1]?.Departure?.time;
                                                if (!firstArrival || !nextDeparture) return "";

                                                const [arrH, arrM] = firstArrival.split(":").map(Number);
                                                const [depH, depM] = nextDeparture.split(":").map(Number);

                                                let diff =
                                                  depH * 60 + depM - (arrH * 60 + arrM);
                                                if (diff < 0) diff += 24 * 60; // overnight layover

                                                const hours = Math.floor(diff / 60);
                                                const minutes = diff % 60;

                                                return `${hours}h ${minutes}m`;
                                              })()}
                                            </b>
                                            &nbsp;Layover in {flightlist?.Arrival?.city}
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {/* {flight?.OutboundInboundlist?.[0]?.flightlist?.map((flightlist, index, arr) => {
                                      if (index < arr.length - 1) {
                                        // {console.log("index",index,"flightlist",flightlist,"arr",arr)}
                                        return <div>
                                          <div className="flightLayoverOuter my-2 py-1 my-1">
                                            <div className="flightLayover mmtConnectLayover">
                                              <div className="makeFlex">
                                                <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>  {(() => {
                                                  const firstArrival = flightlist?.Arrival?.time; // current flight arrival
                                                  const nextDeparture = arr?.[index + 1]?.Departure?.time; // next flight departure

                                                  if (!firstArrival || !nextDeparture) return "";

                                                  const [arrH, arrM] = firstArrival.split(":").map(Number);
                                                  const [depH, depM] = nextDeparture.split(":").map(Number);

                                                  const arrTotal = arrH * 60 + arrM;
                                                  const depTotal = depH * 60 + depM;

                                                  let diff = depTotal - arrTotal;
                                                  if (diff < 0) diff += 24 * 60; // handle overnight layover

                                                  const hours = Math.floor(diff / 60);
                                                  const minutes = diff % 60;

                                                  return `${hours}h ${minutes}m`;
                                                })()}</b> m Layover in {flightlist?.Arrival?.city}
                                              </div>
                                            </div>
                                          </div>
                                          <div className=''>
                                            <div className="main-info">
                                              <div className='flightdetailLeftContainer'>
                                                <div className="airline">
                                                  <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flightlist?.Departure?.Iata}.png`} alt={flight?.lOmarkCo?.split('|')[1]} className="airlineIconimg" />
                                                  <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'> {flight?.lOmarkCo?.split('|')[1]}</h5> &nbsp; | &nbsp;  {flight?.lOmarkCo?.split('|')[0]} • {flight?.loFlightNumber} • {flight?.lOairType}</span>
                                                </div>

                                                <div className="flight px-2 py-3 w-100">
                                                  <div className="departure departure-width">
                                                    <h4 className="time metropolis-bold">{flight?.lOstarttime}</h4>
                                                    <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate).toLocaleDateString('en-US', {
                                                      weekday: 'short',
                                                      day: 'numeric',
                                                      month: 'short',
                                                      year: 'numeric'
                                                    })}</span>
                                                    <span className="location">{flightlist.Departure.name} - {flight?.lOlocationDep?.split(',')[0]}</span>
                                                    <span className="airport">{flight?.lOlocationDep?.split(',')[1]}</span>
                                                    {flight?.loDepTerminal && (
                                                      <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal}</h6>
                                                    )}
                                                  </div>
                                                  <div className="duration-container duration-container-width">
                                                    <div className="duration-time py-2">{flight?.loDuration?.split(':')[0]}h {flight?.loDuration?.split(':')[1]}m</div>
                                                    <div className="duration-graphic">
                                                      <img src="/assets/images/flightIconListing.png" alt="" className='duration-graphic-img' />
                                                    </div>
                                                    <div className="duration-type py-2">Non-stop</div>
                                                  </div>
                                                  <div className="arrival arrival-width">
                                                    <h4 className="time metropolis-bold">{flight?.lOendtime}</h4>
                                                    <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate).toLocaleDateString('en-US', {
                                                      weekday: 'short',
                                                      day: 'numeric',
                                                      month: 'short',
                                                      year: 'numeric'
                                                    })}</span>
                                                    <span className="location">{flight?.lOlocationArr?.split(',')[2]} - {flight?.lOlocationArr?.split(',')[0]}</span>
                                                    <span className="airport">{flight?.lOlocationArr?.split(',')[1]}</span>
                                                    {flight?.loArrTerminal && (
                                                      <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal}</h6>
                                                    )}
                                                  </div>
                                                </div>

                                              </div>
                                              <div className="baggage-info">
                                                <table>
                                                  <tbody>
                                                    <tr>
                                                      <th>Baggage</th>
                                                      <th>Check-in</th>
                                                      <th>Cabin</th>
                                                    </tr>
                                                    <tr>
                                                      <td>Adult</td>
                                                      <td>{flight?.lObaggage1 === "0Kg" ? "Not include" : flight?.lObaggage1}</td>
                                                      <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                    </tr>
                                                    {flight?.child > 0 && (
                                                      <tr>
                                                        <td>Child</td>
                                                        <td>{flight?.lObaggage1 === "0Kg" ? "Not include" : flight?.lObaggage1}</td>
                                                        <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                      </tr>
                                                    )}
                                                    {flight?.infant > 0 && (
                                                      <tr>
                                                        <td>Infant</td>
                                                        <td>{flight?.lObaggage1 === "0Kg" ? "Not include" : flight?.lObaggage1}</td>
                                                        <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                      </tr>
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                      return null;
                                    })} */}

                                    {/* {flight?.isLO2 && (
                                    <div>
                                      <div className="flightLayoverOuter my-2">
                                        <div className="flightLayover mmtConnectLayover">
                                          <div className="makeFlex">
                                            <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime1?.split(':')[0]}</b> h <b>{flight?.loTime1?.split(':')[1]}</b> m Layover in {flight?.lOlocationArr?.split(',')[2]}
                                          </div>
                                        </div>
                                      </div>
                                      <div className=''>
                                        <div className="main-info">
                                          <div className='flightdetailLeftContainer'>
                                            <div className="airline">
                                              <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo1?.split('|')[0]}.png`} alt={flight?.lOmarkCo1?.split('|')[1]} className="airlineIconimg" />
                                              <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'>{flight?.lOmarkCo1?.split('|')[1]} </h5> &nbsp; | &nbsp;  {flight?.lOmarkCo1?.split('|')[0]} • {flight?.loFlightNumber1} • {flight?.lOairType1}</span>
                                            </div>

                                            <div className="flight px-2 py-3 w-100">
                                              <div className="departure departure-width">
                                                <h4 className="time text-dark metropolis-bold">{flight?.lOstarttime1}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate1).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationDep1?.split(',')[2]} - {flight?.lOlocationDep1?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationDep1?.split(',')[1]}</span>
                                                {flight?.loDepTerminal1 && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal1}</h6>
                                                )}
                                              </div>
                                              <div className="duration-container duration-container-width">
                                                <div className="duration-time py-2">{flight?.loDuration1?.split(':')[0]}h {flight?.loDuration1?.split(':')[1]}m</div>
                                                <div className="duration-graphic">
                                                  <img src="/assets/images/flightIconListing.png" alt="" className='duration-graphic-img' />
                                                </div>
                                                <div className="duration-type py-2">Non-stop</div>
                                              </div>
                                              <div className="arrival arrival-width">
                                                <h4 className="time text-dark metropolis-semibold">{flight?.lOendtime1}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate1).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationArr1?.split(',')[2]} - {flight?.lOlocationArr1?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationArr1?.split(',')[1]}</span>
                                                {flight?.loArrTerminal1 && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal1}</h6>
                                                )}
                                              </div>
                                            </div>

                                          </div>
                                          <div className="baggage-info">
                                            <table>
                                              <tbody>
                                                <tr>
                                                  <th>Baggage</th>
                                                  <th>Check-in</th>
                                                  <th>Cabin</th>
                                                </tr>
                                                <tr>
                                                  <td>Adult</td>
                                                  <td>{flight?.lObaggage2 === "0Kg" ? "Not include" : flight?.lObaggage2}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                                {flight?.child > 0 && (
                                                  <tr>
                                                    <td>Child</td>
                                                    <td>{flight?.lObaggage2 === "0Kg" ? "Not include" : flight?.lObaggage2}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                                {flight?.infant > 0 && (
                                                  <tr>
                                                    <td>Infant</td>
                                                    <td>{flight?.lObaggage2 === "0Kg" ? "Not include" : flight?.lObaggage2}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )} */}
                                    {/* {flight?.isLO3 && (
                                    <div>
                                      <div className="flightLayoverOuter my-2">
                                        <div className="flightLayover mmtConnectLayover">
                                          <div className="makeFlex">
                                            <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime2?.split(':')[0]}</b> h <b>{flight?.loTime2?.split(':')[1]}</b> m Layover in {flight?.lOlocationArr1?.split(',')[2]}
                                          </div>
                                        </div>
                                      </div>
                                      <div className='listingdataContainer'>
                                        <div className="main-info">
                                          <div className='flightdetailLeftContainer'>
                                            <div className="airline">
                                              <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo2?.split('|')[0]}.png`} alt={flight?.lOmarkCo2?.split('|')[1]} className="airlineIconimg" />
                                              <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'> {flight?.lOmarkCo2?.split('|')[1]} </h5> &nbsp; | &nbsp;   {flight?.lOmarkCo2?.split('|')[0]} • {flight?.loFlightNumber2} • {flight?.lOairType2}</span>
                                            </div>

                                            <div className="flight px-2 py-3 w-100">
                                              <div className="departure departure-width">
                                                <h4 className="time metropolis-bold">{flight?.lOstarttime2}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate2).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationDep2?.split(',')[2]} - {flight?.lOlocationDep2?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationDep2?.split(',')[1]}</span>
                                                {flight?.loDepTerminal2 && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal2}</h6>
                                                )}
                                              </div>
                                              <div className="duration-container duration-container-width">
                                                <div className="duration-time py-2">{flight?.loDuration2?.split(':')[0]}h {flight?.loDuration2?.split(':')[1]}m</div>
                                                <div className="duration-graphic">
                                                  <img src="/assets/images/flightIconListing.png" alt="" className='duration-graphic-img' />
                                                </div>
                                                <div className="duration-type  py-2">Non-stop</div>
                                              </div>
                                              <div className="arrival arrival-width">
                                                <h4 className="time text-dark metropolis-bold">{flight?.lOendtime2}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate2).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationArr2?.split(',')[2]} - {flight?.lOlocationArr2?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationArr2?.split(',')[1]}</span>
                                                {flight?.loArrTerminal2 && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal2}</h6>
                                                )}
                                              </div>
                                            </div>

                                          </div>
                                          <div className="baggage-info">
                                            <table>
                                              <tbody>
                                                <tr>
                                                  <th>Baggage</th>
                                                  <th>Check-in</th>
                                                  <th>Cabin</th>
                                                </tr>
                                                <tr>
                                                  <td>Adult</td>
                                                  <td>{flight?.lObaggage3 === "0Kg" ? "Not include" : flight?.lObaggage3}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                                {flight?.child > 0 && (
                                                  <tr>
                                                    <td>Child</td>
                                                    <td>{flight?.lObaggage3 === "0Kg" ? "Not include" : flight?.lObaggage3}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                                {flight?.infant > 0 && (
                                                  <tr>
                                                    <td>Infant</td>
                                                    <td>{flight?.lObaggage3 === "0Kg" ? "Not include" : flight?.lObaggage3}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )} */}
                                  </div>
                                })}
                              </div>
                              {/* {flight?.noOfStops !== "0" && (
                                  <div>
                                    <div className="flightLayoverOuter my-2">
                                      <div className="flightLayover mmtConnectLayover">
                                        <div className="makeFlex">
                                          <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime?.split(':')[0]}</b> h <b>{flight?.loTime?.split(':')[1]}</b> m Layover in {flight?.arrCode?.split(',')[2]}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='flight-info'>
                                      <div className='listingdataContainer'>
                                        <div className="main-info">
                                          <div className='flightdetailLeftContainer'>
                                            <div className="airline">
                                              <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo?.split('|')[0]}.png`} alt={flight?.lOmarkCo?.split('|')[1]} className="airlineIconimg" />
                                              <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'> {flight?.lOmarkCo?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.lOmarkCo?.split('|')[0]} • {flight?.loFlightNumber} • {flight?.lOairType}</span>
                                            </div>
                                            <div className="flight px-2 py-3 w-100">
                                              <div className="departure departure-width">
                                                <h4 className="time text-dark metropolis-bold">{flight?.lOstarttime}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationDep?.split(',')[2]} - {flight?.lOlocationDep?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationDep?.split(',')[1]}</span>
                                                {flight?.loDepTerminal && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal}</h6>
                                                )}
                                              </div>
                                              <div className="duration-container duration-container-width">
                                                <div className="duration-time py-2">{flight?.loDuration?.split(':')[0]}h {flight?.loDuration?.split(':')[1]}m</div>
                                                <div className="duration-graphic">
                                                  <img src="/assets/images/planeImage.png" alt="" />
                                                </div>
                                                <div className="duration-type py-2">Non-stop</div>
                                              </div>
                                              <div className="arrival arrival-width">
                                                <h4 className="time text-dark metropolis-bold">{flight?.lOendtime}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationArr?.split(',')[2]} - {flight?.lOlocationArr?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationArr?.split(',')[1]}</span>
                                                {flight?.loArrTerminal && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal}</h6>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="baggage-info">
                                            <table>
                                              <tbody>
                                                <tr>
                                                  <th>Baggage</th>
                                                  <th>Check-in</th>
                                                  <th>Cabin</th>
                                                </tr>
                                                <tr>
                                                  <td>Adult</td>
                                                  <td>{flight?.lObaggage === "0Kg" ? "Not include" : flight?.lObaggage}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                                {flight?.child > 0 && (
                                                  <tr>
                                                    <td>Child</td>
                                                    <td>{flight?.lObaggage === "0Kg" ? "Not include" : flight?.lObaggage}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                                {flight?.infant > 0 && (
                                                  <tr>
                                                    <td>Infant</td>
                                                    <td>{flight?.lObaggage === "0Kg" ? "Not include" : flight?.lObaggage}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {flight?.isLO2 && (
                                  <div>
                                    <div className="flightLayoverOuter my-2">
                                      <div className="flightLayover mmtConnectLayover">
                                        <div className="makeFlex">
                                          <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime1?.split(':')[0]}</b> h <b>{flight?.loTime1?.split(':')[1]}</b> m Layover in {flight?.lOlocationArr?.split(',')[2]}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='flight-info'>
                                      <div className='listingdataContainer'>
                                        <div className="main-info">
                                          <div className='flightdetailLeftContainer'>
                                            <div className="airline">
                                              <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo1?.split('|')[0]}.png`} alt={flight?.lOmarkCo1?.split('|')[1]} className="airlineIconimg" />
                                              <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'> {flight?.lOmarkCo1?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.lOmarkCo1?.split('|')[0]} • {flight?.loFlightNumber1} • {flight?.lOairType1}</span>
                                            </div>

                                            <div className="flight px-2 py-3 w-100">
                                              <div className="departure departure-width">
                                                <h4 className="time metropolis-semibold">{flight?.lOstarttime1}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate1).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}
                                                </span>
                                                <span className="location">{flight?.lOlocationDep1?.split(',')[2]} - {flight?.lOlocationDep1?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationDep1?.split(',')[1]}</span>
                                                {flight?.loDepTerminal1 && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal1}</h6>
                                                )}
                                              </div>
                                              <div className="duration-container duration-container-width">
                                                <div className="duration-time py-2">{flight?.loDuration1?.split(':')[0]}h {flight?.loDuration1?.split(':')[1]}m</div>
                                                <div className="duration-graphic">
                                                  <img src="/assets/images/planeImage.png" alt="" />
                                                </div>
                                                <div className="duration-type py-2">Non-stop</div>
                                              </div>
                                              <div className="arrival arrival-width">
                                                <h4 className="time text-dark metropolis-bold">{flight?.lOendtime1}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate1).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationArr1?.split(',')[2]} - {flight?.lOlocationArr1?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationArr1?.split(',')[1]}</span>
                                                {flight?.loArrTerminal1 && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal1}</h6>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="baggage-info">
                                            <table>
                                              <tbody>
                                                <tr>
                                                  <th>Baggage</th>
                                                  <th>Check-in</th>
                                                  <th>Cabin</th>
                                                </tr>
                                                <tr>
                                                  <td>Adult</td>
                                                  <td>{flight?.lObaggage1 === "0Kg" ? "Not include" : flight?.lObaggage1}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                                {flight?.child > 0 && (
                                                  <tr>
                                                    <td>Child</td>
                                                    <td>{flight?.lObaggage1 === "0Kg" ? "Not include" : flight?.lObaggage1}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                                {flight?.infant > 0 && (
                                                  <tr>
                                                    <td>Infant</td>
                                                    <td>{flight?.lObaggage1 === "0Kg" ? "Not include" : flight?.lObaggage1}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {flight?.isLO3 && (
                                  <div>
                                    <div className="flightLayoverOuter my-2">
                                      <div className="flightLayover mmtConnectLayover">
                                        <div className="makeFlex">
                                          <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime2?.split(':')[0]}</b> h <b>{flight?.loTime2?.split(':')[1]}</b> m Layover in {flight?.lOlocationArr1?.split(',')[2]}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='flight-info'>
                                      <div className='listingdataContainer'>
                                        <div className="main-info">
                                          <div className='flightdetailLeftContainer'>
                                            <div className="airline">
                                              <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo2?.split('|')[0]}.png`} alt={flight?.lOmarkCo2?.split('|')[1]} className="airlineIconimg" />
                                              <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'>{flight?.lOmarkCo2?.split('|')[1]} </h5> &nbsp; | &nbsp;  {flight?.lOmarkCo2?.split('|')[0]} • {flight?.loFlightNumber2} • {flight?.lOairType2}</span>
                                            </div>
                                            <div className="flight px-2 py-3 w-100">
                                              <div className="departure departure-width">
                                                <h4 className="time text-dark metropolis-bold">{flight?.lOstarttime2}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate2).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationDep2?.split(',')[2]} - {flight?.lOlocationDep2?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationDep2?.split(',')[1]}</span>
                                                {flight?.loDepTerminal2 && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal2}</h6>
                                                )}
                                              </div>
                                              <div className="duration-container duration-container-width">
                                                <div className="duration-time py-2">{flight?.loDuration2?.split(':')[0]}h {flight?.loDuration2?.split(':')[1]}m</div>
                                                <div className="duration-graphic">
                                                  <img src="/assets/images/planeImage.png" alt="" />
                                                </div>
                                                <div className="duration-type py-2">Non-stop</div>
                                              </div>
                                              <div className="arrival arrival-width">
                                                <h4 className="time text-dark metropolis-bold">{flight?.lOendtime2}</h4>
                                                <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate2).toLocaleDateString('en-US', {
                                                  weekday: 'short',
                                                  day: 'numeric',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })}</span>
                                                <span className="location">{flight?.lOlocationArr2?.split(',')[2]} - {flight?.lOlocationArr2?.split(',')[0]}</span>
                                                <span className="airport">{flight?.lOlocationArr2?.split(',')[1]}</span>
                                                {flight?.loArrTerminal2 && (
                                                  <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal2}</h6>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="baggage-info">
                                            <table>
                                              <tbody>
                                                <tr>
                                                  <th>Baggage</th>
                                                  <th>Check-in</th>
                                                  <th>Cabin</th>
                                                </tr>
                                                <tr>
                                                  <td>Adult</td>
                                                  <td>{flight?.lObaggage2 === "0Kg" ? "Not include" : flight?.lObaggage2}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                                {flight?.child > 0 && (
                                                  <tr>
                                                    <td>Child</td>
                                                    <td>{flight?.lObaggage2 === "0Kg" ? "Not include" : flight?.lObaggage2}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                                {flight?.infant > 0 && (
                                                  <tr>
                                                    <td>Infant</td>
                                                    <td>{flight?.lObaggage2 === "0Kg" ? "Not include" : flight?.lObaggage2}</td>
                                                    <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )} */}
                              <div className="flight-info mt-2">
                                <div className="FDHeaderListing">
                                  <div className='ListingDetailsDeparture'>
                                    <h6 className='text-dark metropolis-semibold'>{flight?.OutboundInboundlist?.[1]?.flightlist?.[0]?.Departure?.city}</h6>
                                    <img src="/assets/images/planeImage.png" alt="" />
                                    <h6 className='text-dark metropolis-semibold'>{flight?.OutboundInboundlist?.[1]?.flightlist?.[flight.OutboundInboundlist?.[1]?.flightlist.length - 1]?.Arrival?.city}</h6>
                                    {/* {flight?.retnoOfStops === "0" && (<h5 className='text-dark metropolis-semibold'>{flight?.retarrCode?.split(',')[2]}</h5>)}
                                      {flight?.retnoOfStops === "1" && (<h5 className='text-dark metropolis-semibold'>{flight?.retLOlocationArr?.split(',')[2]}</h5>)}
                                      {flight?.retnoOfStops === "2" && (<h5 className='text-dark metropolis-semibold'>{flight?.retLOlocationArr1?.split(',')[2]}</h5>)}
                                      {flight?.retnoOfStops === "3" && (<h5 className='text-dark metropolis-semibold'>{flight?.retLOlocationArr2?.split(',')[2]}</h5>)} */}
                                  </div>
                                  <div className="flight-details">
                                    <span>{new Date(flight?.OutboundInboundlist?.[1]?.flightlist?.[0]?.Departure?.Date.split('-').reverse().join('-')).toLocaleDateString('en-US', {
                                      weekday: 'short',
                                      day: 'numeric',
                                      month: 'short',
                                      year: 'numeric'
                                    })}
                                      {' | '}
                                      {flight?.OutboundInboundlist?.[1]?.flightlist?.length > 0 && (
                                        flight.OutboundInboundlist[1].flightlist.length - 1 === 0
                                          ? "Non-stop"
                                          : `${flight.OutboundInboundlist[1].flightlist.length - 1} Stop${flight.OutboundInboundlist[1].flightlist.length - 1 > 1 ? "s" : ""}`
                                      )}
                                      {/* {flight?.retnoOfStops === "0" ? "Non-stop" :
                                        flight?.retnoOfStops === "1" ? "1 stop" :
                                          flight?.retnoOfStops === "2" ? "2 stops" :
                                            `${flight?.retnoOfStops} stops`} */}

                                      {' | '}
                                      {flight?.OutboundInboundlist?.[1]?.totaltime && `${Math.floor(flight?.OutboundInboundlist?.[1]?.totaltime / 60)}h ${flight?.OutboundInboundlist?.[1]?.totaltime % 60}m`}
                                      {' | '}
                                      {flight?.OutboundInboundlist?.[1]?.flightlist?.[0]?.CabinClassText}
                                    </span>
                                  </div>
                                </div>
                                {flight?.OutboundInboundlist?.[1]?.flightlist?.map((flightlist, index, arr) => {
                                  return <div className='listingdataContainer'>
                                    <div className="main-info">
                                      <div className='flightdetailLeftContainer'>
                                        <div className="airline">
                                          <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flightlist?.OperatingAirline.code}.png`} alt={flightlist?.OperatingAirline.name} className="airlineIconimg" />
                                          <span className='d-flex text-muted'> <h5 className='text-dark metropolis-semibold'> {flightlist?.OperatingAirline.name} </h5> &nbsp; | &nbsp;  {flightlist?.OperatingAirline?.code} • {flightlist?.OperatingAirline?.number} </span>
                                        </div>

                                        <div className="flight px-2 py-3 w-100">
                                          <div className="departure departure-width">
                                            <h4 className="time metropolis-bold">{flightlist?.Departure?.time}</h4>
                                            <span className="date text-dark metropolis-semibold">{new Date(flightlist?.Departure?.Date.split('-').reverse().join('-')).toLocaleDateString('en-US', {
                                              weekday: 'short',
                                              day: 'numeric',
                                              month: 'short',
                                              year: 'numeric'
                                            })}</span>
                                            <span className="location">{flightlist?.Departure?.city} - {flightlist?.Departure?.Iata}</span>
                                            <span className="airport">{flightlist?.Departure?.name}</span>

                                            {flightlist?.Departure?.Terminal && (
                                              <h6 className="terminal text-dark metropolis-semibold">
                                                Terminal {flightlist.Departure.Terminal}
                                              </h6>
                                            )}
                                          </div>
                                          <div className="duration-container duration-container-width">
                                            <div className="duration-time my-2">{Math.floor(flightlist?.FlightMinutes / 60)}h&nbsp;
                                              {flightlist?.FlightMinutes % 60}m</div>
                                            <div className="duration-graphic">
                                              <img src="/assets/images/flightIconListing.png" alt="" className='duration-graphic-img' />
                                            </div>
                                            <div className="duration-type my-2">
                                              {arr.length > 0 && (
                                                arr.length === 1
                                                  ? "Non-stop"
                                                  : `${arr.length - 1} Stop${arr.length - 1 > 1 ? "s" : ""}`
                                              )}
                                            </div>
                                          </div>
                                          <div className="arrival arrival-width">
                                            <h4 className="time metropolis-bold">{flightlist?.Arrival?.time}</h4>
                                            <span className="date text-dark metropolis-semibold">{new Date(flightlist?.Arrival?.Date.split('-').reverse().join('-')).toLocaleDateString('en-US', {
                                              weekday: 'short',
                                              day: 'numeric',
                                              month: 'short',
                                              year: 'numeric'
                                            })}</span>
                                            <span className="location">{flightlist?.Arrival?.city} - {flightlist?.Arrival?.Iata}</span>
                                            <span className="airport">{flightlist?.Arrival?.name}</span>

                                            {flightlist?.Arrival?.Terminal && (
                                              <h6 className="terminal text-dark metropolis-semibold">
                                                Terminal {flightlist.Arrival.Terminal}
                                              </h6>
                                            )}

                                          </div>
                                        </div>

                                      </div>
                                      <div className="baggage-info">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <th>Baggage</th>
                                              <th>Check-in</th>
                                              <th>Cabin</th>
                                            </tr>
                                            <tr>
                                              <td>Adult</td>
                                              <td>{flightlist?.CheckinBaggage?.[0]?.Value === "0Kg" ? "Not include" : flightlist?.CheckinBaggage?.[0]?.Value} </td>
                                              <td>{flightlist?.CheckinBaggage?.[1]?.Value === "0Kg" ? "Not include" : flightlist?.CheckinBaggage?.[1]?.Value}</td>
                                            </tr>
                                            {/* {flight?.child > 0 && (
                                            <tr>
                                              <td>Child</td>
                                              <td>{flight?.baggage === "0Kg" ? "Not include" : flight?.baggage}</td>
                                              <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                            </tr>
                                          )}
                                          {flight?.infant > 0 && (
                                            <tr>
                                              <td>Infant</td>
                                              <td>{flight?.baggage === "0Kg" ? "Not include" : flight?.baggage}</td>
                                              <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                            </tr>
                                          )} */}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>

                                    {index < arr.length - 1 && (
                                      <div className="flightLayoverOuter my-2 py-1">
                                        <div className="flightLayover mmtConnectLayover">
                                          <div className="makeFlex">
                                            <b style={{ color: "#1FD78A" }}>Change of planes</b>・
                                            <b>
                                              {(() => {
                                                const firstArrival = flightlist?.Arrival?.time;
                                                const nextDeparture = arr[index + 1]?.Departure?.time;
                                                if (!firstArrival || !nextDeparture) return "";

                                                const [arrH, arrM] = firstArrival.split(":").map(Number);
                                                const [depH, depM] = nextDeparture.split(":").map(Number);

                                                let diff =
                                                  depH * 60 + depM - (arrH * 60 + arrM);
                                                if (diff < 0) diff += 24 * 60; // overnight layover

                                                const hours = Math.floor(diff / 60);
                                                const minutes = diff % 60;

                                                return `${hours}h ${minutes}m`;
                                              })()}
                                            </b>
                                            &nbsp;Layover in {flightlist?.Arrival?.city}
                                          </div>
                                        </div>
                                      </div>
                                    )}


                                  </div>
                                })}
                              </div>
                              {/* {flight?.retnoOfStops !== "0" && (
                                <div>
                                  <div className="flightLayoverOuter my-2">
                                    <div className="flightLayover mmtConnectLayover">
                                      <div className="makeFlex">
                                        <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.retLOTime?.split(':')[0]}</b> h <b>{flight?.retLOTime?.split(':')[1]}</b> m Layover in {flight?.retarrCode?.split(',')[2]}
                                      </div>
                                    </div>
                                  </div>
                                  <div className='flight-info'>
                                    <div className='listingdataContainer'>
                                      <div className="main-info">
                                        <div className='flightdetailLeftContainer'>
                                          <div className="airline">
                                            <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.retLOmarkCo?.split('|')[0]}.png`} alt={flight?.retLOmarkCo?.split('|')[1]} className="airlineIconimg" />
                                            <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'> {flight?.retLOmarkCo?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.retLOmarkCo?.split('|')[0]} • {flight?.retLOFlightNumber} • {flight?.retLOairType}</span>
                                          </div>
                                          <div className="flight px-2 py-3 w-100">
                                            <div className="departure departure-width">
                                              <h4 className="time metropolis-semibold">{flight?.retLOstarttime}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.retLOstartDate).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.retLOlocationDep?.split(',')[2]} - {flight?.retLOlocationDep?.split(',')[0]}</span>
                                              <span className="airport">{flight?.retLOlocationDep?.split(',')[1]}</span>
                                              {flight?.retLODepTerminal && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retLODepTerminal}</h6>
                                              )}
                                            </div>
                                            <div className="duration-container duration-container-width">
                                              <div className="duration-time py-2">{flight?.retLODuration?.split(':')[0]}h {flight?.retLODuration?.split(':')[1]}m</div>
                                              <div className="duration-graphic">
                                                <img src="/assets/images/planeImage.png" alt="" />
                                              </div>
                                              <div className="duration-type py-2">Non-stop</div>
                                            </div>
                                            <div className="arrival arrival-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.retLOendtime}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.retLOendDate).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.retLOlocationArr?.split(',')[2]} - {flight?.retLOlocationArr?.split(',')[0]}</span>
                                              <span className="airport">{flight?.retLOlocationArr?.split(',')[1]}</span>
                                              {flight?.retLOArrTerminal && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retLOArrTerminal}</h6>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="baggage-info">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <th>Baggage</th>
                                                <th>Check-in</th>
                                                <th>Cabin</th>
                                              </tr>
                                              <tr>
                                                <td>Adult</td>
                                                <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                              </tr>
                                              {flight?.child > 0 && (
                                                <tr>
                                                  <td>Child</td>
                                                  <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                  <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                                </tr>
                                              )}
                                              {flight?.infant > 0 && (
                                                <tr>
                                                  <td>Infant</td>
                                                  <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                  <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {flight?.retisLO2 && (
                                <div>
                                  <div className="flightLayoverOuter my-2">
                                    <div className="flightLayover mmtConnectLayover">
                                      <div className="makeFlex">
                                        <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.retLOTime1?.split(':')[0]}</b> h <b>{flight?.retLOTime1?.split(':')[1]}</b> m Layover in {flight?.retLOlocationArr?.split(',')[2]}
                                      </div>
                                    </div>
                                  </div>
                                  <div className='flight-info'>
                                    <div className='listingdataContainer'>
                                      <div className="main-info">
                                        <div className='flightdetailLeftContainer'>
                                          <div className="airline">
                                            <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.retLOmarkCo1?.split('|')[0]}.png`} alt={flight?.retLOmarkCo1?.split('|')[1]} className="airlineIconimg" />
                                            <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'> {flight?.retLOmarkCo1?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.retLOmarkCo1?.split('|')[0]} • {flight?.retLOFlightNumber1} • {flight?.retLOairType1}</span>
                                          </div>
                                          <div className="flight px-2 py-3 w-100">
                                            <div className="departure departure-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.retLOstarttime1}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.retLOstartDate1).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.retLOlocationDep1?.split(',')[2]} - {flight?.retLOlocationDep1?.split(',')[0]}</span>
                                              <span className="airport">{flight?.retLOlocationDep1?.split(',')[1]}</span>
                                              {flight?.retLODepTerminal1 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retLODepTerminal1}</h6>
                                              )}
                                            </div>
                                            <div className="duration-container duration-container-width">
                                              <div className="duration-time py-2">{flight?.retLODuration1?.split(':')[0]}h {flight?.retLODuration1?.split(':')[1]}m</div>
                                              <div className="duration-graphic">
                                                <img src="/assets/images/planeImage.png" alt="" />
                                              </div>
                                              <div className="duration-type py-2">Non-stop</div>
                                            </div>
                                            <div className="arrival arrival-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.retLOendtime1}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.retLOendDate1).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.retLOlocationArr1?.split(',')[2]} - {flight?.retLOlocationArr1?.split(',')[0]}</span>
                                              <span className="airport">{flight?.retLOlocationArr1?.split(',')[1]}</span>
                                              {flight?.retLOArrTerminal1 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retLOArrTerminal1}</h6>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="baggage-info">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <th>Baggage</th>
                                                <th>Check-in</th>
                                                <th>Cabin</th>
                                              </tr>
                                              <tr>
                                                <td>Adult</td>
                                                <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                              </tr>
                                              {flight?.child > 0 && (
                                                <tr>
                                                  <td>Child</td>
                                                  <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                  <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                                </tr>
                                              )}
                                              {flight?.infant > 0 && (
                                                <tr>
                                                  <td>Infant</td>
                                                  <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                  <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {flight?.retisLO3 && (
                                <div>
                                  <div className="flightLayoverOuter my-2">
                                    <div className="flightLayover mmtConnectLayover">
                                      <div className="makeFlex">
                                        <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.retLOTime2?.split(':')[0]}</b> h <b>{flight?.retLOTime2?.split(':')[1]}</b> m Layover in {flight?.retLOlocationArr1?.split(',')[2]}
                                      </div>
                                    </div>
                                  </div>
                                  <div className='flight-info'>
                                    <div className='listingdataContainer'>
                                      <div className="main-info">
                                        <div className='flightdetailLeftContainer'>
                                          <div className="airline">
                                            <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.retLOmarkCo2?.split('|')[0]}.png`} alt={flight?.retLOmarkCo2?.split('|')[1]} className="airlineIconimg" />
                                            <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'> {flight?.retLOmarkCo2?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.retLOmarkCo2?.split('|')[0]} • {flight?.retLOFlightNumber2} • {flight?.retLOairType2}</span>
                                          </div>

                                          <div className="flight px-2 py-3 w-100">
                                            <div className="departure departure-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.retLOstarttime2}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.retLOstartDate2).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.retLOlocationDep2?.split(',')[2]} - {flight?.retLOlocationDep2?.split(',')[0]}</span>
                                              <span className="airport">{flight?.retLOlocationDep2?.split(',')[1]}</span>
                                              {flight?.retLODepTerminal2 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retLODepTerminal2}</h6>)}
                                            </div>
                                            <div className="duration-container duration-container-width">
                                              <div className="duration-time py-2">{flight?.retLODuration2?.split(':')[0]}h {flight?.retLODuration2?.split(':')[1]}m</div>
                                              <div className="duration-graphic">
                                                <img src="/assets/images/planeImage.png" alt="" />
                                              </div>
                                              <div className="duration-type py-2">Non-stop</div>
                                            </div>
                                            <div className="arrival arrival-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.retLOendtime2}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.retLOendDate2).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.retLOlocationArr2?.split(',')[2]} - {flight?.retLOlocationArr2?.split(',')[0]}</span>
                                              <span className="airport">{flight?.retLOlocationArr2?.split(',')[1]}</span>
                                              {flight?.retLOArrTerminal2 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retLOArrTerminal2}</h6>)}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="baggage-info">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <th>Baggage</th>
                                                <th>Check-in</th>
                                                <th>Cabin</th>
                                              </tr>
                                              <tr>
                                                <td>Adult</td>
                                                <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                              </tr>
                                              {flight?.child > 0 && (
                                                <tr>
                                                  <td>Child</td>
                                                  <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                  <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                                </tr>
                                              )}
                                              {flight?.infant > 0 && (
                                                <tr>
                                                  <td>Infant</td>
                                                  <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                  <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )} */}
                              {/* </div> */}
                            </div>

                            <div id={`fare-summary${index}`} className={`tab-content ${activeTabs1[index] === `fare-summary${index}` ? 'active' : ''}`}>
                              <div className="farecontainer">
                                <div className="fareheader">
                                  <h5 className="fw-bold">Fare Breakup</h5>
                                </div>
                                <div className="farerow">
                                  <div>Base Fare</div>
                                  <div>{getCurrencySymbol(flight?.price?.currency_sign)}&nbsp;
                                    {new Intl.NumberFormat('en-IN').format(Math.round(flight?.price?.base_price))}</div>
                                </div>
                                <div className="farerow">
                                  <div>Surcharges</div>
                                  <div>{getCurrencySymbol(flight?.price?.currency_sign)}&nbsp;{new Intl.NumberFormat('en-IN').format(Math.round(flight?.price?.tax_price))}</div>
                                  </div>
                                <div className="farerow total-row">
                                  <div>Total Fare </div>
                                  <div>{getCurrencySymbol(flight?.price?.currency_sign)}&nbsp;{new Intl.NumberFormat('en-IN').format(Math.round(flight?.price?.total_price))}</div>
                                </div>
                              </div>
                            </div>
                            <div id={`cancellation${index}`} className={`tab-content ${activeTabs1[index] === `cancellation${index}` ? 'active' : ''}`}>
                              <div className="farecontainer">
                                <div className="fareheader">Cancellation Charges</div>
                                <div className="farerow">
                                  <div>O Hours - 4 Hours</div>
                                  <div>Adult : Non Refundable</div>
                                </div>
                                <div className="farerow">
                                  <div>4 Hours - 4 Days</div>
                                  <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649</div>
                                </div>
                                <div className="farerow">
                                  <div>4 Hours - 365 Days</div>
                                  <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649</div>
                                </div>
                              </div>
                              <p className="cancellationText1 mt-2 text-danger border p-2 rounded border-danger ">
                                *From the Time of Departure
                              </p>
                            </div>
                            <div id={`date-change${index}`} className={`tab-content ${activeTabs1[index] === `date-change${index}` ? 'active' : ''}`}>
                              <div className="farecontainer2">
                                <div className="fareheader">Date Change Charges</div>
                                <div className="farerow">
                                  <div>O Hours - 4 Hours</div>
                                  <div>Adult : Non Changeable</div>
                                </div>
                                <div className="farerow">
                                  <div>4 Hours - 4 Days</div>
                                  <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649 + Fare Difference</div>
                                </div>
                                <div className="farerow">
                                  <div>4 Hours - 365 Days</div>
                                  <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649 + Fare Difference</div>
                                </div>
                              </div>
                              <p className="cancellationText mt-2 text-danger border p-2 rounded border-danger ">
                                *From the Time of Departure
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    ))
                  }
                </div>
              ) : (!loading &&
                <div className="not-found-container">
                  {/* <h1>testing1</h1> */}
                  {/* <h1>Round trip</h1> */}
                  <div className="airplane">
                    <img src="./assets/images/notfound.png" alt="" />
                  </div>
                  <h1>Flight Not Found</h1>
                  <p>We couldn't find the flight you were looking for. Please try again.</p>
                </div>
              )}
            </div>
          )}

          {/*----------------------------Div for round trip --------------------------------------------- */}
          {/* ----------------------------Div for multi trip --------------------------------------------- */}

          {tripType === "3" && isSearchClicked && (
            <div className="px-1 listingFlightDetails">
              {filteredFlights.length > 0 ? (
                <div>
                  {
                    filteredFlights.map((flight, index) => (
                      <div key={index} className='mt-4'>
                        <div className="flight-cardMultiCity multiCityCardResponsive">
                          <div style={{ padding: "25px" }}>
                            <div className='multiFlightDetailsContainer'>
                              <div className='multiFlightDetails'>
                                <div className='multiFlightIcon text-start'>
                                  <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.marketingCompany?.split('|')[0]}.png`} alt={flight?.marketingCompany?.split('|')[1]} />
                                  <div>
                                    <h5 className='metropolis-bold m-0'>
                                      {flight?.marketingCompany?.split('|')[1]}
                                    </h5>
                                    <p className='text-muted m-0' style={{ fontSize: "12px" }}>
                                      {flight?.marketingCompany?.split('|')[0]}-{flight?.flightNumber}
                                    </p>
                                  </div>
                                </div>
                                <div className='multiFlightData'>
                                  <div className="departDataContainer">
                                    <div className="time">
                                      <span className="location text-start text-dark time-font-multi">{new Date(flight?.depDt).toLocaleDateString('en-US', {
                                        weekday: 'short',
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric',
                                      })}</span>
                                      <span className="time-value text-start text-muted m-0 time-value-font-multi"> {flight?.depCode?.split(',')[0]} &nbsp; <p className='text-dark m-0'> {flight?.departureTime} </p> </span>
                                    </div>
                                    <div className="duration-container">
                                      {flight?.noOfStops === "0" && (
                                        <div className="duration-time" style={{ fontSize: "13px" }}>{flight?.duration?.split(':')[0]}h {flight?.duration?.split(':')[1]}m</div>
                                      )}
                                      {flight?.noOfStops === "1" && (
                                        <div className="duration-time" style={{ fontSize: "13px" }}>{flight?.inbwLOTime?.split(':')[0]}h {flight?.inbwLOTime?.split(':')[1]}m</div>
                                      )}
                                      {flight?.noOfStops === "2" && (
                                        <div className="duration-time" style={{ fontSize: "13px" }}>{flight?.inbwLOTime1?.split(':')[0]}h {flight?.inbwLOTime1?.split(':')[1]}m</div>
                                      )}
                                      {flight?.noOfStops === "3" && (
                                        <div className="duration-time" style={{ fontSize: "13px" }}>{flight?.inbwLOTime2?.split(':')[0]}h {flight?.inbwLOTime2?.split(':')[1]}m</div>
                                      )}
                                      <div className="duration-graphic">
                                        <img src="/assets/images/planeImage.png" alt="" />
                                      </div>
                                      <div className="duration-type" style={{ fontSize: "13px" }}>
                                        {flight?.noOfStops === "0" && "Non-stop"}
                                        {flight?.noOfStops === "1" && "1 stop"}
                                        {flight?.noOfStops === "2" && "2 stops"}{flight?.noOfStops === "3" && "3 stops"}</div>
                                    </div>
                                    <div className="time align-items-end">
                                      {flight?.noOfStops === "0" && (
                                        <span className="location text-dark time-font-multi">{new Date(flight?.arrDt).toLocaleDateString('en-US', {
                                          weekday: 'short',
                                          day: 'numeric',
                                          month: 'short',
                                          year: 'numeric'
                                        })}</span>)}
                                      {flight?.noOfStops === "1" && (<span className="location text-start text-dark time-font-multi">{new Date(flight?.lOendDate).toLocaleDateString('en-US', {
                                        weekday: 'short',
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric'
                                      })}</span>)}
                                      {flight?.noOfStops === "2" && (<span className="location text-start text-dark time-font-multi">{new Date(flight?.lOendDate1).toLocaleDateString('en-US', {
                                        weekday: 'short',
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric'
                                      })}</span>)}
                                      {flight?.noOfStops === "3" && (<span className="location text-start text-dark time-font-multi">{new Date(flight?.lOendDate2).toLocaleDateString('en-US', {
                                        weekday: 'short',
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric'
                                      })}</span>)}
                                      {flight?.noOfStops === "0" && (
                                        <span className="time-value text-end time-value-font-multi"> <p className='text-muted m-0'> {flight?.arrCode?.split(',')[0]}</p> &nbsp; {flight?.arrivalTime}</span>
                                      )}
                                      {flight?.noOfStops === "1" && (
                                        <span className="time-value text-end time-value-font-multi"> <p className='text-muted m-0'> {flight?.lOlocationArr?.split(',')[0]}</p> &nbsp;{flight?.lOendtime}</span>
                                      )}
                                      {flight?.noOfStops === "2" && (
                                        <span className="time-value text-end time-value-font-multi"> <p className='text-muted m-0'> {flight?.lOlocationArr1?.split(',')[0]}</p> &nbsp;{flight?.lOendtime1}</span>
                                      )}
                                      {flight?.noOfStops === "3" && (
                                        <span className="time-value text-end time-value-font-multi"> <p className='text-muted m-0'> {flight?.lOlocationArr2?.split(',')[0]}</p>&nbsp; {flight?.lOendtime2}</span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className='multiFlightDetails mt-3'>
                                <div className='multiFlightIcon'>
                                  <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.retmarketingCompany?.split('|')[0]}.png`} alt={flight?.retmarketingCompany?.split('|')[1]} />
                                  <div>
                                    <h5 className="metropolis-bold m-0 text-start">
                                      {flight?.retmarketingCompany?.split('|')[1]}
                                    </h5>
                                    <p className='text-muted text-start m-0' style={{ fontSize: "12px" }}>
                                      {flight?.retmarketingCompany?.split('|')[0]}-{flight?.retflightNumber}
                                    </p>
                                  </div>
                                </div>
                                <div className='multiFlightData'>
                                  <div className="departDataContainer">
                                    <div className="time">
                                      <span className="location text-start text-dark time-font-multi">{new Date(flight?.retdepDt).toLocaleDateString('en-US', {
                                        weekday: 'short',
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric'
                                      })}</span>
                                      <span className="time-value text-start text-muted m-0 time-value-font-multi"> {flight?.retdepCode?.split(',')[0]} &nbsp; <p className='text-dark m-0'> {flight?.retdepartureTime} </p> </span>
                                    </div>
                                    <div className="duration-container">
                                      {flight?.retnoOfStops === "0" && (
                                        <div className="duration-time" style={{ fontSize: "13px" }}>{flight?.retduration?.split(':')[0]}h {flight?.retduration?.split(':')[1]}m</div>
                                      )}
                                      {flight?.retnoOfStops === "1" && (
                                        <div className="duration-time" style={{ fontSize: "13px" }}>{flight?.retinbwLOTime?.split(':')[0]}h {flight?.retinbwLOTime?.split(':')[1]}m</div>
                                      )}
                                      {flight?.retnoOfStops === "2" && (
                                        <div className="duration-time" style={{ fontSize: "13px" }}>{flight?.retinbwLOTime1?.split(':')[0]}h {flight?.retinbwLOTime1?.split(':')[1]}m</div>
                                      )}
                                      {flight?.retnoOfStops === "3" && (
                                        <div className="duration-time" style={{ fontSize: "13px" }}>{flight?.retinbwLOTime2?.split(':')[0]}h {flight?.retinbwLOTime2?.split(':')[1]}m</div>
                                      )}
                                      <div className="duration-graphic">
                                        <img src="/assets/images/planeImage.png" alt="" />
                                      </div>
                                      <div className="duration-type" style={{ fontSize: "13px" }}>
                                        {flight?.retnoOfStops === "0" && "Non-stop"}
                                        {flight?.retnoOfStops === "1" && "1 stop"}
                                        {flight?.retnoOfStops === "2" && "2 stops"}{flight?.retnoOfStops === "3" && "3 stops"}</div>
                                    </div>
                                    <div className="time align-items-end">
                                      {flight?.retnoOfStops === "0" && (
                                        <span className="location text-start text-dark time-font-multi">{new Date(flight?.retarrDt).toLocaleDateString('en-US', {
                                          weekday: 'short',
                                          day: 'numeric',
                                          month: 'short',
                                          year: 'numeric'
                                        })}</span>)}
                                      {flight?.retnoOfStops === "1" && (<span className="location text-start text-dark time-font-multi">{new Date(flight?.retLOendDate).toLocaleDateString('en-US', {
                                        weekday: 'short',
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric'
                                      })}</span>)}
                                      {flight?.retnoOfStops === "2" && (<span className="location text-start text-dark time-font-multi">{new Date(flight?.retLOendDate1).toLocaleDateString('en-US', {
                                        weekday: 'short',
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric'
                                      })}</span>)}
                                      {flight?.retnoOfStops === "3" && (<span className="location text-start text-dark time-font-multi">{new Date(flight?.retLOendDate2).toLocaleDateString('en-US', {
                                        weekday: 'short',
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric'
                                      })}</span>)}
                                      {flight?.retnoOfStops === "0" && (
                                        <span className="time-value text-end time-value-font-multi"> <p className='text-muted m-0'> {flight?.retarrCode?.split(',')[0]}</p> &nbsp; {flight?.retarrivalTime}</span>
                                      )}
                                      {flight?.retnoOfStops === "1" && (
                                        <span className="time-value text-end time-value-font-multi"> <p className='text-muted m-0'> {flight?.retLOlocationArr?.split(',')[0]}</p> &nbsp; {flight?.retLOendtime}</span>
                                      )}
                                      {flight?.retnoOfStops === "2" && (
                                        <span className="time-value text-end time-value-font-multi"> <p className='text-muted m-0'> {flight?.retLOlocationArr1?.split(',')[0]}</p> &nbsp; {flight?.retLOendtime1}</span>
                                      )}
                                      {flight?.retnoOfStops === "3" && (
                                        <span className="time-value text-end time-value-font-multi"> <p className='text-muted m-0'> {flight?.retLOlocationArr2?.split(',')[0]}</p> &nbsp; {flight?.retLOendtime2}</span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {isSecondCityVisible && (
                                <div className='multiFlightDetails mt-3'>
                                  <div className='multiFlightIcon'>
                                    <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.marketingCompany3?.split('|')[0]}.png`} alt={flight?.marketingCompany3?.split('|')[1]} />
                                    <div>
                                      <h5 className="metropolis-bold m-0 text-start">
                                        {flight?.marketingCompany3?.split('|')[1]}
                                      </h5>
                                      <p className='text-muted text-start m-0' style={{ fontSize: "12px" }}>
                                        {flight?.marketingCompany3?.split('|')[0]}-{flight?.flightNumber3}
                                      </p>
                                    </div>
                                  </div>
                                  <div className='multiFlightData'>
                                    <div className="departDataContainer">
                                      <div className="time">
                                        <span className="location text-start text-dark time-font-multi">{new Date(flight?.depDt3).toLocaleDateString('en-US', {
                                          weekday: 'short',
                                          day: 'numeric',
                                          month: 'short',
                                          year: 'numeric'
                                        })}</span>
                                        <span className="time-value text-start text-muted m-0 time-value-font-multi"> {flight?.depCode3?.split(',')[0]} &nbsp; <p className='text-dark m-0'>  {flight?.departureTime3} </p></span>
                                      </div>
                                      <div className="duration-container">
                                        {flight?.noOfStops3 === "0" && (
                                          <div className="duration-time" style={{ fontSize: "13px" }}>{flight?.duration3?.split(':')[0]}h {flight?.duration3?.split(':')[1]}m</div>
                                        )}
                                        {flight?.noOfStops3 === "1" && (
                                          <div className="duration-time" style={{ fontSize: "13px" }}>{flight?.inbwLOTime3?.split(':')[0]}h {flight?.inbwLOTime3?.split(':')[1]}m</div>
                                        )}
                                        {flight?.noOfStops3 === "2" && (
                                          <div className="duration-time" style={{ fontSize: "13px" }}>{flight?.inbwLOTime31?.split(':')[0]}h {flight?.inbwLOTime31?.split(':')[1]}m</div>
                                        )}
                                        {flight?.noOfStops3 === "3" && isSecondCityVisible && (
                                          <div className="duration-time" style={{ fontSize: "13px" }}>{flight?.inbwLOTime32?.split(':')[0]}h {flight?.inbwLOTime32?.split(':')[1]}m</div>
                                        )}
                                        <div className="duration-graphic">
                                          <img src="/assets/images/planeImage.png" alt="" />
                                        </div>
                                        <div className="duration-type" style={{ fontSize: "13px" }}>
                                          {flight?.noOfStops3 === "0" && "Non-stop"}
                                          {flight?.noOfStops3 === "1" && "1 stop"}
                                          {flight?.noOfStops3 === "2" && "2 stops"}{flight?.noOfStops3 === "3" && "3 stops"}</div>
                                      </div>
                                      {flight?.noOfStops3 === "0" && (
                                        <div className="time align-items-end">
                                          <span className="location text-start text-dark time-font-multi">{new Date(flight?.arrDt3).toLocaleDateString('en-US', {
                                            weekday: 'short',
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric'
                                          })}</span>
                                          <span className="time-value text-end time-value-font-multi"> <p className='text-muted m-0'> {flight?.arrCode3?.split(',')[0]}</p> &nbsp; {flight?.arrivalTime3}</span>
                                        </div>
                                      )}
                                      {flight?.noOfStops3 === "1" && (
                                        <div className="time">
                                          <span className="location text-start text-dark time-font-multi">{new Date(flight?.lOendDate3).toLocaleDateString('en-US', {
                                            weekday: 'short',
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric'
                                          })}</span>
                                          <span className="time-value text-end time-value-font-multi"> <p className='text-muted m-0'> {flight?.lOlocationArr3?.split(',')[0]} </p> &nbsp; {flight?.lOendtime3}</span>
                                        </div>
                                      )}
                                      {flight?.noOfStops3 === "2" && (
                                        <div className="time">
                                          <span className="location text-start text-dark time-font-multi">{new Date(flight?.lOendDate31).toLocaleDateString('en-US', {
                                            weekday: 'short',
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric'
                                          })}</span>
                                          <span className="time-value text-end time-value-font-multi"> <p className='text-muted m-0'> {flight?.lOlocationArr31?.split(',')[0]}</p> &nbsp; {flight?.lOendtime31}</span>
                                        </div>
                                      )}
                                      {flight?.noOfStops3 === "3" && isSecondCityVisible && (
                                        <div className="time">
                                          <span className="location text-start text-dark">{new Date(flight?.lOendDate32).toLocaleDateString('en-US', {
                                            weekday: 'short',
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric'
                                          })}</span>
                                          <span className="time-value text-end time-value-font-multi"> <p className='text-muted m-0'> {flight?.lOlocationArr32?.split(',')[0]}</p> {flight?.lOendtime32} </span>
                                        </div>
                                      )}

                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="price-infoContainerMulti">
                              <div className="time">
                                <span className='adultonewaytext'>Starts from</span>
                                <div className="current-price-multi mb-2">{getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))}</div>

                              </div>
                              <div className="price-infoMulti">
                                <button className="view-prices-btn" onClick={() => handlePricing(flight)}>
                                  View Prices
                                </button>

                              </div>
                            </div>
                          </div>
                          <div className='viewMultiDetails p-0'>
                            <div className='view-flight-details ' style={{ fontSize: "13px" }}>
                              {flight?.freeText?.split('|')[0]}
                            </div>
                            <a href="#" className="view-flight-details pr-3" onClick={(e) => {
                              e.preventDefault();
                              viewFlightDetails(index);
                            }} >
                              View Flight Details <img src="/assets/images/viewFlightDetailsArrow.png" alt="" />
                            </a>
                          </div>
                          <div className="viewMultiDetails p-0">
                            <div style={{ fontSize: "13px", textAlign: "justify" }}>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: flight?.freeText?.split('|')[1],
                                }}
                                className='px-2'
                              />
                            </div>
                          </div>
                        </div>
                        {detailsVisible && selectedIndex === index && (
                          <div className="" id={`tabs-container${index}`} style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px", marginTop: "2%" }}>
                            <div className="tabs my-2">
                              <button className={`tab-button ${activeTabs2[index] === `flight-details${index}` ? 'active' : ''}`} onClick={() => openTab2(index, `flight-details${index}`)}>
                                Flight Details
                              </button>
                              <button className={`tab-button ${activeTabs2[index] === `fare-summary${index}` ? 'active' : ''}`} onClick={() => openTab2(index, `fare-summary${index}`)}>
                                Fare Summary
                              </button>
                              {/* <button className={`tab-button ${activeTabs2[index] === `cancellation${index}` ? 'active' : ''}`} onClick={() => openTab2(index, `cancellation${index}`)}>
                        Cancellation
                      </button>
                      <button className={`tab-button ${activeTabs2[index] === `date-change${index}` ? 'active' : ''}`} onClick={() => openTab2(index, `date-change${index}`)}>
                        Date Change
                      </button> */}
                            </div>
                            <div id={`flight-details${index}`} className={`tab-content ${activeTabs2[index] === `flight-details${index}` ? 'active' : ''}`}>
                              <div className="flight-info">
                                <div className="FDHeaderListing">
                                  <div className='ListingDetailsDeparture'>
                                    <h5 className='text-dark metropolis-semibold'>{flight?.depCode?.split(',')[2]}</h5>
                                    <img src="/assets/images/planeImage.png" alt="" />
                                    {flight?.noOfStops === "0" && (<h5 className='metropolis-semibold'>{flight?.arrCode?.split(',')[2]}</h5>)}
                                    {flight?.noOfStops === "1" && (<h5 className='metropolis-semibold'>{flight?.lOlocationArr?.split(',')[2]}</h5>)}
                                    {flight?.noOfStops === "2" && (<h5 className='metropolis-semibold'>{flight?.lOlocationArr1?.split(',')[2]}</h5>)}
                                    {flight?.noOfStops === "3" && (<h5 className='metropolis-semibold'>{flight?.lOlocationArr2?.split(',')[2]}</h5>)}
                                  </div>
                                  <div className="flight-details">
                                    <span>{new Date(flight?.depDt).toLocaleDateString('en-US', {
                                      weekday: 'short',
                                      day: 'numeric',
                                      month: 'short',
                                      year: 'numeric'
                                    })}
                                      {' | '}
                                      {flight?.noOfStops === "0" ? "Non-stop" :
                                        flight?.noOfStops === "1" ? "1 stop" :
                                          flight?.noOfStops === "2" ? "2 stops" :
                                            `${flight?.noOfStops} stops`}
                                      {' | '}
                                      {flight?.noOfStops === "0" && `${flight?.duration?.split(':')[0]}h ${flight?.duration?.split(':')[1]}m`}
                                      {flight?.noOfStops === "1" && `${flight?.inbwLOTime?.split(':')[0]}h ${flight?.inbwLOTime?.split(':')[1]}m`}
                                      {flight?.noOfStops === "2" && `${flight?.inbwLOTime1?.split(':')[0]}h ${flight?.inbwLOTime1?.split(':')[1]}m`}
                                      {flight?.noOfStops === "3" && `${flight?.inbwLOTime2?.split(':')[0]}h ${flight?.inbwLOTime2?.split(':')[1]}m`}
                                    </span>
                                  </div>
                                </div>
                                <div className='listingdataContainer'>
                                  <div className="main-info">
                                    <div className='flightdetailLeftContainer'>
                                      <div className="airline">
                                        <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.marketingCompany?.split('|')[0]}.png`} alt={flight?.marketingCompany?.split('|')[1]} className="airlineIconimg" />
                                        <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'>{flight?.marketingCompany?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.marketingCompany?.split('|')[0]} • {flight?.flightNumber} • {flight?.aircraftType}</span>
                                      </div>
                                      <div className="flight px-2 py-3 w-100">
                                        <div className="departure departure-width">
                                          <h4 className="time text-dark metropolis-bold">{flight?.departureTime}</h4>
                                          <span className="date text-dark metropolis-semibold">{new Date(flight?.depDt).toLocaleDateString('en-US', {
                                            weekday: 'short',
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric'
                                          })}</span>
                                          <span className="location">{flight?.depCode?.split(',')[2]} - {flight?.depCode?.split(',')[0]}</span>
                                          <span className="airport">{flight?.depCode?.split(',')[1]}</span>
                                          {flight?.depTerminal && (<h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.depTerminal}</h6>)}
                                        </div>
                                        <div className="duration-container duration-container-width">
                                          <div className="duration-time py-2">{flight?.duration?.split(':')[0]}h {flight?.duration?.split(':')[1]}m</div>
                                          <div className="duration-graphic">
                                            <img src="/assets/images/planeImage.png" alt="" />
                                          </div>
                                          <div className="duration-type py-2">Non-stop</div>
                                        </div>
                                        <div className="arrival arrival-width">
                                          <h4 className="time text-dark metropolis-bold">{flight?.arrivalTime}</h4>
                                          <span className="date text-dark metropolis-semibold">{new Date(flight?.arrDt).toLocaleDateString('en-US', {
                                            weekday: 'short',
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric'
                                          })}</span>
                                          <span className="location">{flight?.arrCode?.split(',')[2]} - {flight?.arrCode?.split(',')[0]}</span>
                                          <span className="airport">{flight?.arrCode?.split(',')[1]}</span>
                                          {flight?.arrTerminal && (
                                            <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.arrTerminal}</h6>)}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="baggage-info">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <th>Baggage</th>
                                            <th>Check-in</th>
                                            <th>Cabin</th>
                                          </tr>
                                          <tr>
                                            <td>Adult</td>
                                            <td>{flight?.baggage === "0Kg" ? "Not include" : flight?.baggage}</td>
                                            <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                          </tr>
                                          {flight?.child > 0 && (
                                            <tr>
                                              <td>Child</td>
                                              <td>{flight?.baggage === "0Kg" ? "Not include" : flight?.baggage}</td>
                                              <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                            </tr>
                                          )}
                                          {flight?.infant > 0 && (
                                            <tr>
                                              <td>Infant</td>
                                              <td>{flight?.baggage === "0Kg" ? "Not include" : flight?.baggage}</td>
                                              <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                                {flight?.noOfStops !== "0" && (
                                  <div>
                                    <div className="flightLayoverOuter my-2">
                                      <div className="flightLayover mmtConnectLayover">
                                        <div className="makeFlex">
                                          <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime?.split(':')[0]}</b> h <b>{flight?.loTime?.split(':')[1]}</b> m Layover in {flight?.arrCode?.split(',')[2]}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='listingdataContainer'>
                                      <div className="main-info">
                                        <div className='flightdetailLeftContainer'>
                                          <div className="airline">
                                            <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo?.split('|')[0]}.png`} alt={flight?.lOmarkCo?.split('|')[1]} className="airlineIconimg" />
                                            <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'> {flight?.lOmarkCo?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.lOmarkCo?.split('|')[0]} • {flight?.loFlightNumber} • {flight?.lOairType}</span>
                                          </div>
                                          <div className="flight px-2 py-3 w-100">
                                            <div className="departure departure-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.lOstarttime}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.lOlocationDep?.split(',')[2]} - {flight?.lOlocationDep?.split(',')[0]}</span>
                                              <span className="airport">{flight?.lOlocationDep?.split(',')[1]}</span>
                                              {flight?.loDepTerminal && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal}</h6>)}
                                            </div>
                                            <div className="duration-container duration-container-width">
                                              <div className="duration-time py-2">{flight?.loDuration?.split(':')[0]}h {flight?.loDuration?.split(':')[1]}m</div>
                                              <div className="duration-graphic">
                                                <img src="/assets/images/planeImage.png" alt="" />
                                              </div>
                                              <div className="duration-type py-2">Non-stop</div>
                                            </div>
                                            <div className="arrival arrival-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.lOendtime}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.lOlocationArr?.split(',')[2]} - {flight?.lOlocationArr?.split(',')[0]}</span>
                                              <span className="airport">{flight?.lOlocationArr?.split(',')[1]}</span>
                                              {flight?.loArrTerminal && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal}</h6>)}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="baggage-info">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <th>Baggage</th>
                                                <th>Check-in</th>
                                                <th>Cabin</th>
                                              </tr>
                                              <tr>
                                                <td>Adult</td>
                                                <td>{flight?.baggage === "0Kg" ? "Not include" : flight?.baggage}</td>
                                                <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                              </tr>
                                              {flight?.child > 0 && (
                                                <tr>
                                                  <td>Child</td>
                                                  <td>{flight?.baggage === "0Kg" ? "Not include" : flight?.baggage}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                              )}
                                              {flight?.infant > 0 && (
                                                <tr>
                                                  <td>Infant</td>
                                                  <td>{flight?.baggage === "0Kg" ? "Not include" : flight?.baggage}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {flight?.isLO2 && (
                                  <div>
                                    <div className="flightLayoverOuter my-2">
                                      <div className="flightLayover mmtConnectLayover">
                                        <div className="makeFlex">
                                          <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime1?.split(':')[0]}</b> h <b>{flight?.loTime1?.split(':')[1]}</b> m Layover in {flight?.lOlocationArr?.split(',')[2]}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='listingdataContainer'>
                                      <div className="main-info">
                                        <div className='flightdetailLeftContainer'>
                                          <div className="airline">
                                            <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo1?.split('|')[0]}.png`} alt={flight?.lOmarkCo1?.split('|')[1]} className="airlineIconimg" />
                                            <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'> {flight?.lOmarkCo1?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.lOmarkCo1?.split('|')[0]} • {flight?.loFlightNumber1} • {flight?.lOairType1}</span>
                                          </div>
                                          <div className="flight px-2 py-3 w-100">
                                            <div className="departure departure-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.lOstarttime1}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate1).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.lOlocationDep1?.split(',')[2]} - {flight?.lOlocationDep1?.split(',')[0]}</span>
                                              <span className="airport">{flight?.lOlocationDep1?.split(',')[1]}</span>
                                              {flight?.loDepTerminal1 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal1}</h6>
                                              )}
                                            </div>
                                            <div className="duration-container  duration-container-width">
                                              <div className="duration-time py-2">{flight?.loDuration1?.split(':')[0]}h {flight?.loDuration1?.split(':')[1]}m</div>
                                              <div className="duration-graphic">
                                                <img src="/assets/images/planeImage.png" alt="" />
                                              </div>
                                              <div className="duration-type py-2">Non-stop</div>
                                            </div>
                                            <div className="arrival arrival-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.lOendtime1}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate1).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.lOlocationArr1?.split(',')[2]} - {flight?.lOlocationArr1?.split(',')[0]}</span>
                                              <span className="airport">{flight?.lOlocationArr1?.split(',')[1]}</span>
                                              {flight?.loArrTerminal1 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal1}</h6>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="baggage-info">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <th>Baggage</th>
                                                <th>Check-in</th>
                                                <th>Cabin</th>
                                              </tr>
                                              <tr>
                                                <td>Adult</td>
                                                <td>{flight?.lObaggage2 === "0Kg" ? "Not include" : flight?.lObaggage2}</td>
                                                <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                              </tr>
                                              {flight?.child > 0 && (
                                                <tr>
                                                  <td>Child</td>
                                                  <td>{flight?.lObaggage2 === "0Kg" ? "Not include" : flight?.lObaggage2}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                              )}
                                              {flight?.infant > 0 && (
                                                <tr>
                                                  <td>Infant</td>
                                                  <td>{flight?.lObaggage2 === "0Kg" ? "Not include" : flight?.lObaggage2}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {flight?.isLO3 && (
                                  <div>
                                    <div className="flightLayoverOuter my-2">
                                      <div className="flightLayover mmtConnectLayover">
                                        <div className="makeFlex">
                                          <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime2?.split(':')[0]}</b> h <b>{flight?.loTime2?.split(':')[1]}</b> m Layover in {flight?.lOlocationArr1?.split(',')[2]}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='listingdataContainer'>
                                      <div className="main-info">
                                        <div className='flightdetailLeftContainer'>
                                          <div className="airline">
                                            <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo2?.split('|')[0]}.png`} alt={flight?.lOmarkCo2?.split('|')[1]} className="airlineIconimg" />
                                            <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'>{flight?.lOmarkCo2?.split('|')[1]}  </h5> &nbsp; | &nbsp;  {flight?.lOmarkCo2?.split('|')[0]} • {flight?.loFlightNumber2} • {flight?.lOairType2}</span>
                                          </div>
                                          <div className="flight px-2 py-3 w-100">
                                            <div className="departure departure-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.lOstarttime2}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate2).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.lOlocationDep2?.split(',')[2]} - {flight?.lOlocationDep2?.split(',')[0]}</span>
                                              <span className="airport">{flight?.lOlocationDep2?.split(',')[1]}</span>
                                              {flight?.loDepTerminal2 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal2}</h6>
                                              )}
                                            </div>
                                            <div className="duration-container duration-container-width">
                                              <div className="duration-time py-2">{flight?.loDuration2?.split(':')[0]}h {flight?.loDuration2?.split(':')[1]}m</div>
                                              <div className="duration-graphic">
                                                <img src="/assets/images/planeImage.png" alt="" />
                                              </div>
                                              <div className="duration-type py-2">Non-stop</div>
                                            </div>
                                            <div className="arrival arrival-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.lOendtime2}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate2).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.lOlocationArr2?.split(',')[2]} - {flight?.lOlocationArr2?.split(',')[0]}</span>
                                              <span className="airport">{flight?.lOlocationArr2?.split(',')[1]}</span>
                                              {flight?.loArrTerminal2 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal2}</h6>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="baggage-info">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <th>Baggage</th>
                                                <th>Check-in</th>
                                                <th>Cabin</th>
                                              </tr>
                                              <tr>
                                                <td>Adult</td>
                                                <td>{flight?.lObaggage3 === "0Kg" ? "Not include" : flight?.lObaggage3}</td>
                                                <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                              </tr>
                                              {flight?.child > 0 && (
                                                <tr>
                                                  <td>Child</td>
                                                  <td>{flight?.lObaggage3 === "0Kg" ? "Not include" : flight?.lObaggage3}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                              )}
                                              {flight?.infant > 0 && (
                                                <tr>
                                                  <td>Infant</td>
                                                  <td>{flight?.lObaggage3 === "0Kg" ? "Not include" : flight?.lObaggage3}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <div className="FDHeaderListing">
                                  <div className='ListingDetailsDeparture'>
                                    <h5 className='text-dark metropolis-semibold'>{flight?.retdepCode?.split(',')[2]}</h5>
                                    <img src="/assets/images/planeImage.png" alt="" />
                                    {flight?.retnoOfStops === "0" && (<h5 className='metropolis-semibold'>{flight?.retarrCode?.split(',')[2]}</h5>)}
                                    {flight?.retnoOfStops === "1" && (<h5 className='metropolis-semibold'>{flight?.retLOlocationArr?.split(',')[2]}</h5>)}
                                    {flight?.retnoOfStops === "2" && (<h5 className='metropolis-semibold'>{flight?.retLOlocationArr1?.split(',')[2]}</h5>)}
                                    {flight?.retnoOfStops === "3" && (<h5 className='metropolis-semibold'>{flight?.retLOlocationArr2?.split(',')[2]}</h5>)}
                                  </div>
                                  <div className="flight-details">
                                    <span>{new Date(flight?.retdepDt).toLocaleDateString('en-US', {
                                      weekday: 'short',
                                      day: 'numeric',
                                      month: 'short',
                                      year: 'numeric'
                                    })}
                                      {' | '}
                                      {flight?.retnoOfStops === "0" ? "Non-stop" :
                                        flight?.retnoOfStops === "1" ? "1 stop" :
                                          flight?.retnoOfStops === "2" ? "2 stops" :
                                            `${flight?.retnoOfStops} stops`}
                                      {' | '}

                                      {flight?.retnoOfStops === "0" && `${flight?.retduration?.split(':')[0]}h ${flight?.retduration?.split(':')[1]}m`}
                                      {flight?.retnoOfStops === "1" && `${flight?.retinbwLOTime?.split(':')[0]}h ${flight?.retinbwLOTime?.split(':')[1]}m`}
                                      {flight?.retnoOfStops === "2" && `${flight?.retinbwLOTime1?.split(':')[0]}h ${flight?.retinbwLOTime1?.split(':')[1]}m`}
                                      {flight?.retnoOfStops === "3" && `${flight?.retinbwLOTime2?.split(':')[0]}h ${flight?.retinbwLOTime2?.split(':')[1]}m`}</span>
                                  </div>
                                </div>
                                <div className='listingdataContainer'>
                                  <div className="main-info">
                                    <div className='flightdetailLeftContainer'>
                                      <div className="airline">
                                        <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.retmarketingCompany?.split('|')[0]}.png`} alt={flight?.retmarketingCompany?.split('|')[1]} className="airlineIconimg" />
                                        <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'>{flight?.retmarketingCompany?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.retmarketingCompany?.split('|')[0]} • {flight?.retflightNumber} • {flight?.retaircraftType}</span>
                                      </div>
                                      <div className="flight px-2 py-3 w-100">
                                        <div className="departure departure-width">
                                          <h4 className="time text-dark metropolis-bold">{flight?.retdepartureTime}</h4>
                                          <span className="date text-dark metropolis-semibold">{new Date(flight?.retdepDt).toLocaleDateString('en-US', {
                                            weekday: 'short',
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric'
                                          })}</span>
                                          <span className="location">{flight?.retdepCode?.split(',')[2]} - {flight?.retdepCode?.split(',')[0]}</span>
                                          <span className="airport">{flight?.retdepCode?.split(',')[1]}</span>
                                          {flight?.retdepTerminal && (
                                            <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retdepTerminal}</h6>)}
                                        </div>
                                        <div className="duration-container duration-container-width">
                                          <div className="duration-time py-2">{flight?.retduration?.split(':')[0]}h {flight?.retduration?.split(':')[1]}m</div>
                                          <div className="duration-graphic">
                                            <img src="/assets/images/planeImage.png" alt="" />
                                          </div>
                                          <div className="duration-type py-2">Non-stop</div>
                                        </div>
                                        <div className="arrival arrival-width">
                                          <h4 className="time text-dark metropolis-bold">{flight?.retarrivalTime}</h4>
                                          <span className="date text-dark metropolis-semibold">{new Date(flight?.retarrDt).toLocaleDateString('en-US', {
                                            weekday: 'short',
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric'
                                          })}</span>
                                          <span className="location">{flight?.retarrCode?.split(',')[2]} - {flight?.retarrCode?.split(',')[0]}</span>
                                          <span className="airport">{flight?.retarrCode?.split(',')[1]}</span>
                                          {flight?.retarrTerminal && (
                                            <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retarrTerminal}</h6>)}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="baggage-info">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <th>Baggage</th>
                                            <th>Check-in</th>
                                            <th>Cabin</th>
                                          </tr>
                                          <tr>
                                            <td>Adult</td>
                                            <td>{flight?.retbaggage === "0Kg" ? "Not include" : flight?.retbaggage}</td>
                                            <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                          </tr>
                                          {flight?.child > 0 && (
                                            <tr>
                                              <td>Child</td>
                                              <td>{flight?.retbaggage === "0Kg" ? "Not include" : flight?.retbaggage}</td>
                                              <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                            </tr>
                                          )}
                                          {flight?.infant > 0 && (
                                            <tr>
                                              <td>Infant</td>
                                              <td>{flight?.retbaggage === "0Kg" ? "Not include" : flight?.retbaggage}</td>
                                              <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                                {flight?.retnoOfStops !== "0" && (
                                  <div>
                                    <div className="flightLayoverOuter my-2">
                                      <div className="flightLayover mmtConnectLayover">
                                        <div className="makeFlex">
                                          <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.retLOTime?.split(':')[0]}</b> h <b>{flight?.retLOTime?.split(':')[1]}</b> m Layover in {flight?.retarrCode?.split(',')[2]}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='listingdataContainer'>
                                      <div className="main-info">
                                        <div className='flightdetailLeftContainer'>
                                          <div className="airline">
                                            <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.retLOmarkCo?.split('|')[0]}.png`} alt={flight?.retLOmarkCo?.split('|')[1]} className="airlineIconimg" />
                                            <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'>{flight?.retLOmarkCo?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.retLOmarkCo?.split('|')[0]} • {flight?.retLOFlightNumber} • {flight?.retLOairType}</span>
                                          </div>
                                          <div className="flight px-2 py-3 w-100">
                                            <div className="departure departure-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.retLOstarttime}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.retLOstartDate).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.retLOlocationDep?.split(',')[2]} - {flight?.retLOlocationDep?.split(',')[0]}</span>
                                              <span className="airport">{flight?.retLOlocationDep?.split(',')[1]}</span>
                                              {flight?.retLODepTerminal && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retLODepTerminal}</h6>)}
                                            </div>
                                            <div className="duration-container duration-container-width">
                                              <div className="duration-time py-2">{flight?.retLODuration?.split(':')[0]}h {flight?.retLODuration?.split(':')[1]}m</div>
                                              <div className="duration-graphic">
                                                <img src="/assets/images/planeImage.png" alt="" />
                                              </div>
                                              <div className="duration-type py-2">Non-stop</div>
                                            </div>
                                            <div className="arrival arrival-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.retLOendtime}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.retLOendDate).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.retLOlocationArr?.split(',')[2]} - {flight?.retLOlocationArr?.split(',')[0]}</span>
                                              <span className="airport">{flight?.retLOlocationArr?.split(',')[1]}</span>
                                              {flight?.retLOArrTerminal && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retLOArrTerminal}</h6>)}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="baggage-info">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <th>Baggage</th>
                                                <th>Check-in</th>
                                                <th>Cabin</th>
                                              </tr>
                                              <tr>
                                                <td>Adult</td>
                                                <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                              </tr>
                                              {flight?.child > 0 && (
                                                <tr>
                                                  <td>Child</td>
                                                  <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                  <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                                </tr>
                                              )}
                                              {flight?.infant > 0 && (
                                                <tr>
                                                  <td>Infant</td>
                                                  <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                  <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {flight?.retisLO2 && (
                                  <div>
                                    <div className="flightLayoverOuter my-2">
                                      <div className="flightLayover mmtConnectLayover">
                                        <div className="makeFlex">
                                          <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.retLOTime1?.split(':')[0]}</b> h <b>{flight?.retLOTime1?.split(':')[1]}</b> m Layover in {flight?.retLOlocationArr?.split(',')[2]}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='listingdataContainer'>
                                      <div className="main-info">
                                        <div className='flightdetailLeftContainer'>
                                          <div className="airline">
                                            <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.retLOmarkCo1?.split('|')[0]}.png`} alt={flight?.retLOmarkCo1?.split('|')[1]} className="airlineIconimg" />
                                            <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'>{flight?.retLOmarkCo1?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.retLOmarkCo1?.split('|')[0]} • {flight?.retLOFlightNumber1} • {flight?.retLOairType1}</span>
                                          </div>
                                          <div className="flight px-2 py-3 w-100">
                                            <div className="departure departure-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.retLOstarttime1}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.retLOstartDate1).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.retLOlocationDep1?.split(',')[2]} - {flight?.retLOlocationDep1?.split(',')[0]}</span>
                                              <span className="airport">{flight?.retLOlocationDep1?.split(',')[1]}</span>
                                              {flight?.retLODepTerminal1 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retLODepTerminal1}</h6>)}
                                            </div>
                                            <div className="duration-container duration-container-width">
                                              <div className="duration-time py-2">{flight?.retLODuration1?.split(':')[0]}h {flight?.retLODuration1?.split(':')[1]}m</div>
                                              <div className="duration-graphic">
                                                <img src="/assets/images/planeImage.png" alt="" />
                                              </div>
                                              <div className="duration-type py-2">Non-stop</div>
                                            </div>
                                            <div className="arrival arrival-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.retLOendtime1}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.retLOendDate1).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.retLOlocationArr1?.split(',')[2]} - {flight?.retLOlocationArr1?.split(',')[0]}</span>
                                              <span className="airport">{flight?.retLOlocationArr1?.split(',')[1]}</span>
                                              {flight?.retLOArrTerminal1 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retLOArrTerminal1}</h6>)}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="baggage-info">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <th>Baggage</th>
                                                <th>Check-in</th>
                                                <th>Cabin</th>
                                              </tr>
                                              <tr>
                                                <td>Adult</td>
                                                <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                              </tr>
                                              {flight?.child > 0 && (
                                                <tr>
                                                  <td>Child</td>
                                                  <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                  <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                                </tr>
                                              )}
                                              {flight?.infant > 0 && (
                                                <tr>
                                                  <td>Infant</td>
                                                  <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                  <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {flight?.retisLO3 && (
                                  <div>
                                    <div className="flightLayoverOuter my-2">
                                      <div className="flightLayover mmtConnectLayover">
                                        <div className="makeFlex">
                                          <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.retLOTime2?.split(':')[0]}</b> h <b>{flight?.retLOTime2?.split(':')[1]}</b> m Layover in {flight?.retLOlocationArr1?.split(',')[2]}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='listingdataContainer'>
                                      <div className="main-info">
                                        <div className='flightdetailLeftContainer'>
                                          <div className="airline">
                                            <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.retLOmarkCo2?.split('|')[0]}.png`} alt={flight?.retLOmarkCo2?.split('|')[1]} className="airlineIconimg" />
                                            <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'>{flight?.retLOmarkCo2?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.retLOmarkCo2?.split('|')[0]} • {flight?.retLOFlightNumber2} • {flight?.retLOairType2}</span>
                                          </div>
                                          <div className="flight px-2 py-3 w-100">
                                            <div className="departure departure-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.retLOstarttime2}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.retLOstartDate2).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.retLOlocationDep2?.split(',')[2]} - {flight?.retLOlocationDep2?.split(',')[0]}</span>
                                              <span className="airport">{flight?.retLOlocationDep2?.split(',')[1]}</span>
                                              {flight?.retLODepTerminal2 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retLODepTerminal2}</h6>)}
                                            </div>
                                            <div className="duration-container duration-container-width">
                                              <div className="duration-time py-2">{flight?.retLODuration2?.split(':')[0]}h {flight?.retLODuration2?.split(':')[1]}m</div>
                                              <div className="duration-graphic">
                                                <img src="/assets/images/planeImage.png" alt="" />
                                              </div>
                                              <div className="duration-type py-2">Non-stop</div>
                                            </div>
                                            <div className="arrival arrival-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.retLOendtime2}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.retLOendDate2).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.retLOlocationArr2?.split(',')[2]} - {flight?.retLOlocationArr2?.split(',')[0]}</span>
                                              <span className="airport">{flight?.retLOlocationArr2?.split(',')[1]}</span>
                                              {flight?.retLOArrTerminal2 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.retLOArrTerminal2}</h6>)}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="baggage-info">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <th>Baggage</th>
                                                <th>Check-in</th>
                                                <th>Cabin</th>
                                              </tr>
                                              <tr>
                                                <td>Adult</td>
                                                <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                              </tr>
                                              {flight?.child > 0 && (
                                                <tr>
                                                  <td>Child</td>
                                                  <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                  <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                                </tr>
                                              )}
                                              {flight?.infant > 0 && (
                                                <tr>
                                                  <td>Infant</td>
                                                  <td>{flight?.retLObaggage === "0Kg" ? "Not include" : flight?.retLObaggage}</td>
                                                  <td>{flight?.cbnBag1 === "0Kg" ? "Not include" : flight?.cbnBag1}</td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {isSecondCityVisible && (
                                  <div>
                                    <div className="FDHeaderListing">
                                      <div className='ListingDetailsDeparture'>
                                        <h5 className='text-dark metropolis-semibold'>{flight?.depCode?.split(',')[2]}</h5>
                                        <img src="/assets/images/planeImage.png" alt="" />
                                        <h5 className='text-dark metropolis-semibold'>{flight?.arrCode?.split(',')[2]}</h5>
                                      </div>
                                      <div className="flight-details">
                                        <span>{new Date(flight?.depDt3).toLocaleDateString('en-US', {
                                          weekday: 'short',
                                          day: 'numeric',
                                          month: 'short',
                                          year: 'numeric'
                                        })}
                                          {' | '}
                                          {flight?.noOfStops3 === "0" ? "Non-stop" :
                                            flight?.noOfStops3 === "1" ? "1 stop" :
                                              flight?.noOfStops3 === "2" ? "2 stops" :
                                                `${flight?.noOfStops3} stops`}
                                          {' | '}
                                          {flight?.noOfStops3 === "0" && `${flight?.duration3?.split(':')[0]}h ${flight?.duration3?.split(':')[1]}m`}
                                          {flight?.noOfStops3 === "1" && `${flight?.inbwLOTime3?.split(':')[0]}h ${flight?.inbwLOTime3?.split(':')[1]}m`}
                                          {flight?.noOfStops3 === "2" && `${flight?.inbwLOTime31?.split(':')[0]}h ${flight?.inbwLOTime31?.split(':')[1]}m`}
                                          {flight?.noOfStops3 === "3" && `${flight?.inbwLOTime32?.split(':')[0]}h ${flight?.inbwLOTime32?.split(':')[1]}m`}
                                        </span>
                                      </div>
                                    </div>
                                    <div className='listingdataContainer'>
                                      <div className="main-info">
                                        <div className='flightdetailLeftContainer'>
                                          <div className="airline">
                                            <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.marketingCompany3?.split('|')[0]}.png`} alt={flight?.marketingCompany3?.split('|')[1]} className="airlineIconimg" />
                                            <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'>{flight?.marketingCompany3?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.marketingCompany3?.split('|')[0]} • {flight?.flightNumber3} • {flight?.aircraftType3}</span>
                                          </div>
                                          <div className="flight px-2 py-3 w-100">
                                            <div className="departure departure-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.departureTime3}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.depDt3).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.depCode3?.split(',')[2]} - {flight?.depCode3?.split(',')[0]}</span>
                                              <span className="airport">{flight?.depCode3?.split(',')[1]}</span>
                                              {flight?.depTerminal3 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.depTerminal3}</h6>)}
                                            </div>
                                            <div className="duration-container duration-container-width">
                                              <div className="duration-time py-2">{flight?.duration3?.split(':')[0]}h {flight?.duration3?.split(':')[1]}m</div>
                                              <div className="duration-graphic">
                                                <img src="/assets/images/planeImage.png" alt="" />
                                              </div>
                                              <div className="duration-type py-2">Non-stop</div>
                                            </div>
                                            <div className="arrival arrival-width">
                                              <h4 className="time text-dark metropolis-bold">{flight?.arrivalTime3}</h4>
                                              <span className="date text-dark metropolis-semibold">{new Date(flight?.arrDt3).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                              })}</span>
                                              <span className="location">{flight?.arrCode3?.split(',')[2]} - {flight?.arrCode3?.split(',')[0]}</span>
                                              <span className="airport">{flight?.arrCode3?.split(',')[1]}</span>
                                              {flight?.arrTerminal3 && (
                                                <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.arrTerminal3}</h6>)}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="baggage-info">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <th>Baggage</th>
                                                <th>Check-in</th>
                                                <th>Cabin</th>
                                              </tr>
                                              <tr>
                                                <td>Adult</td>
                                                <td>{flight?.baggage3 === "0Kg" ? "Not include" : flight?.baggage3}</td>
                                                <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                              </tr>
                                              {flight?.child > 0 && (
                                                <tr>
                                                  <td>Child</td>
                                                  <td>{flight?.baggage3 === "0Kg" ? "Not include" : flight?.baggage3}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                              )}
                                              {flight?.infant > 0 && (
                                                <tr>
                                                  <td>Infant</td>
                                                  <td>{flight?.baggage3 === "0Kg" ? "Not include" : flight?.baggage3}</td>
                                                  <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                      {flight?.noOfStops3 !== "0" && (
                                        <div>
                                          <div className="flightLayoverOuter my-2">
                                            <div className="flightLayover mmtConnectLayover">
                                              <div className="makeFlex">
                                                <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime3?.split(':')[0]}</b> h <b>{flight?.loTime3?.split(':')[1]}</b> m Layover in {flight?.arrCode3?.split(',')[2]}
                                              </div>
                                            </div>
                                          </div>
                                          <div className='listingdataContainer'>
                                            <div className="main-info">
                                              <div className='flightdetailLeftContainer'>
                                                <div className="airline">
                                                  <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo3?.split('|')[0]}.png`} alt={flight?.lOmarkCo3?.split('|')[1]} className="airlineIconimg" />
                                                  <span>{flight?.lOmarkCo3?.split('|')[1]} | {flight?.lOmarkCo3?.split('|')[0]} • {flight?.loFlightNumber3} • {flight?.lOairType3}</span>
                                                </div>
                                                <div className="flight px-2 py-3 w-100">
                                                  <div className="departure departure-width">
                                                    <h4 className="time text-dark metropolis-bold">{flight?.lOstarttime3}</h4>
                                                    <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate3).toLocaleDateString('en-US', {
                                                      weekday: 'short',
                                                      day: 'numeric',
                                                      month: 'short',
                                                      year: 'numeric'
                                                    })}</span>
                                                    <span className="location">{flight?.lOlocationDep3?.split(',')[2]} - {flight?.lOlocationDep3?.split(',')[0]}</span>
                                                    <span className="airport">{flight?.lOlocationDep3?.split(',')[1]}</span>
                                                    {flight?.loDepTerminal3 && (
                                                      <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal3}</h6>)}
                                                  </div>
                                                  <div className="duration-container duration-container-width">
                                                    <div className="duration-time py-2">{flight?.loDuration3?.split(':')[0]}h {flight?.loDuration3?.split(':')[1]}m</div>
                                                    <div className="duration-graphic">
                                                      <img src="/assets/images/planeImage.png" alt="" />
                                                    </div>
                                                    <div className="duration-type py-2">Non-stop</div>
                                                  </div>
                                                  <div className="arrival arrival-width">
                                                    <h4 className="time text-dark metropolis-bold">{flight?.lOendtime3}</h4>
                                                    <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate3).toLocaleDateString('en-US', {
                                                      weekday: 'short',
                                                      day: 'numeric',
                                                      month: 'short',
                                                      year: 'numeric'
                                                    })}</span>
                                                    <span className="location">{flight?.lOlocationArr3?.split(',')[2]} - {flight?.lOlocationArr3?.split(',')[0]}</span>
                                                    <span className="airport">{flight?.lOlocationArr3?.split(',')[1]}</span>
                                                    {flight?.loArrTerminal3 && (
                                                      <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal3}</h6>)}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="baggage-info">
                                                <table>
                                                  <tbody>
                                                    <tr>
                                                      <th>Baggage</th>
                                                      <th>Check-in</th>
                                                      <th>Cabin</th>
                                                    </tr>
                                                    <tr>
                                                      <td>Adult</td>
                                                      <td>{flight?.baggage3 === "0Kg" ? "Not include" : flight?.baggage3}</td>
                                                      <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                    </tr>
                                                    {flight?.child > 0 && (
                                                      <tr>
                                                        <td>Child</td>
                                                        <td>{flight?.baggage3 === "0Kg" ? "Not include" : flight?.baggage3}</td>
                                                        <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                      </tr>
                                                    )}
                                                    {flight?.infant > 0 && (
                                                      <tr>
                                                        <td>Infant</td>
                                                        <td>{flight?.baggage3 === "0Kg" ? "Not include" : flight?.baggage3}</td>
                                                        <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                      </tr>
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>)}
                                      {flight?.isLO32 && (
                                        <div>
                                          <div className="flightLayoverOuter my-2">
                                            <div className="flightLayover mmtConnectLayover">
                                              <div className="makeFlex">
                                                <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime31?.split(':')[0]}</b> h <b>{flight?.loTime31?.split(':')[1]}</b> m Layover in {flight?.lOlocationArr?.split(',')[2]}
                                              </div>
                                            </div>
                                          </div>
                                          <div className='listingdataContainer'>
                                            <div className="main-info">
                                              <div className='flightdetailLeftContainer'>
                                                <div className="airline">
                                                  <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo31?.split('|')[0]}.png`} alt={flight?.lOmarkCo31?.split('|')[1]} className="airlineIconimg" />
                                                  <span className='d-flex text-muted'>  <h5 className='text-dark metropolis-semibold'>{flight?.lOmarkCo31?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.lOmarkCo31?.split('|')[0]} • {flight?.loFlightNumber31} • {flight?.lOairType31}</span>
                                                </div>
                                                <div className="flight px-2 py-3 w-100">
                                                  <div className="departure departure-width">
                                                    <h4 className="time text-dark metropolis-bold">{flight?.lOstarttime31}</h4>
                                                    <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate31).toLocaleDateString('en-US', {
                                                      weekday: 'short',
                                                      day: 'numeric',
                                                      month: 'short',
                                                      year: 'numeric'
                                                    })}</span>
                                                    <span className="location">{flight?.lOlocationDep31?.split(',')[2]} - {flight?.lOlocationDep31?.split(',')[0]}</span>
                                                    <span className="airport">{flight?.lOlocationDep31?.split(',')[1]}</span>
                                                    {flight?.loDepTerminal1 && (
                                                      <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal31}</h6>
                                                    )}
                                                  </div>
                                                  <div className="duration-container duration-container-width">
                                                    <div className="duration-time py-2">{flight?.loDuration31?.split(':')[0]}h {flight?.loDuration31?.split(':')[1]}m</div>
                                                    <div className="duration-graphic">
                                                      <img src="/assets/images/planeImage.png" alt="" />
                                                    </div>
                                                    <div className="duration-type py-2">Non-stop</div>
                                                  </div>
                                                  <div className="arrival arrival-width">
                                                    <h4 className="time">{flight?.lOendtime31}</h4>
                                                    <span className="date">{new Date(flight?.lOendDate31).toLocaleDateString('en-US', {
                                                      weekday: 'short',
                                                      day: 'numeric',
                                                      month: 'short',
                                                      year: 'numeric'
                                                    })}</span>
                                                    <span className="location">{flight?.lOlocationArr31?.split(',')[2]} - {flight?.lOlocationArr31?.split(',')[0]}</span>
                                                    <span className="airport">{flight?.lOlocationArr31?.split(',')[1]}</span>
                                                    {flight?.loArrTerminal31 && (
                                                      <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal31}</h6>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="baggage-info">
                                                <table>
                                                  <tbody>
                                                    <tr>
                                                      <th>Baggage</th>
                                                      <th>Check-in</th>
                                                      <th>Cabin</th>
                                                    </tr>
                                                    <tr>
                                                      <td>Adult</td>
                                                      <td>{flight?.lObaggage32 === "0Kg" ? "Not include" : flight?.lObaggage32}</td>
                                                      <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                    </tr>
                                                    {flight?.child > 0 && (
                                                      <tr>
                                                        <td>Child</td>
                                                        <td>{flight?.lObaggage32 === "0Kg" ? "Not include" : flight?.lObaggage32}</td>
                                                        <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                      </tr>
                                                    )}
                                                    {flight?.infant > 0 && (
                                                      <tr>
                                                        <td>Infant</td>
                                                        <td>{flight?.lObaggage32 === "0Kg" ? "Not include" : flight?.lObaggage32}</td>
                                                        <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                      </tr>
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {flight?.isLO33 && (
                                        <div>
                                          <div className="flightLayoverOuter my-2">
                                            <div className="flightLayover mmtConnectLayover">
                                              <div className="makeFlex">
                                                <b><font style={{ color: "#1FD78A" }}>Change of planes</font></b>・<b>{flight?.loTime32?.split(':')[0]}</b> h <b>{flight?.loTime32?.split(':')[1]}</b> m Layover in {flight?.lOlocationArr1?.split(',')[2]}
                                              </div>
                                            </div>
                                          </div>
                                          <div className='listingdataContainer'>
                                            <div className="main-info">
                                              <div className='flightdetailLeftContainer'>
                                                <div className="airline">
                                                  <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flight?.lOmarkCo32?.split('|')[0]}.png`} alt={flight?.lOmarkCo32?.split('|')[1]} className="airlineIconimg" />
                                                  <span className='d-flex text-muted'>  <h5 className='text-dark text-dark metropolis-semibold'> {flight?.lOmarkCo32?.split('|')[1]} </h5> &nbsp; | &nbsp; {flight?.lOmarkCo32?.split('|')[0]} • {flight?.loFlightNumber32} • {flight?.lOairType32}</span>
                                                </div>
                                                <div className="flight px-2 py-3 w-100">
                                                  <div className="departure departure-width">
                                                    <h4 className="time text-dark metropolis-bold">{flight?.lOstarttime32}</h4>
                                                    <span className="date text-dark metropolis-semibold">{new Date(flight?.lOstartDate32).toLocaleDateString('en-US', {
                                                      weekday: 'short',
                                                      day: 'numeric',
                                                      month: 'short',
                                                      year: 'numeric'
                                                    })}</span>
                                                    <span className="location">{flight?.lOlocationDep32?.split(',')[2]} - {flight?.lOlocationDep32?.split(',')[0]}</span>
                                                    <span className="airport">{flight?.lOlocationDep32?.split(',')[1]}</span>
                                                    {flight?.loDepTerminal32 && (
                                                      <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loDepTerminal32}</h6>
                                                    )}
                                                  </div>
                                                  <div className="duration-container duration-container-width">
                                                    <div className="duration-time py-2">{flight?.loDuration32?.split(':')[0]}h {flight?.loDuration32?.split(':')[1]}m</div>
                                                    <div className="duration-graphic">
                                                      <img src="/assets/images/planeImage.png" alt="" />
                                                    </div>
                                                    <div className="duration-type py-2">Non-stop</div>
                                                  </div>
                                                  <div className="arrival arrival-width">
                                                    <h4 className="time text-dark metropolis-bold">{flight?.lOendtime32}</h4>
                                                    <span className="date text-dark metropolis-semibold">{new Date(flight?.lOendDate32).toLocaleDateString('en-US', {
                                                      weekday: 'short',
                                                      day: 'numeric',
                                                      month: 'short',
                                                      year: 'numeric'
                                                    })}</span>
                                                    <span className="location">{flight?.lOlocationArr32?.split(',')[2]} - {flight?.lOlocationArr32?.split(',')[0]}</span>
                                                    <span className="airport">{flight?.lOlocationArr32?.split(',')[1]}</span>
                                                    {flight?.loArrTerminal32 && (
                                                      <h6 className="terminal text-dark metropolis-semibold">Terminal {flight?.loArrTerminal32}</h6>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="baggage-info">
                                                <table>
                                                  <tbody>
                                                    <tr>
                                                      <th>Baggage</th>
                                                      <th>Check-in</th>
                                                      <th>Cabin</th>
                                                    </tr>
                                                    <tr>
                                                      <td>Adult</td>
                                                      <td>{flight?.lObaggage33 === "0Kg" ? "Not include" : flight?.lObaggage33}</td>
                                                      <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                    </tr>
                                                    {flight?.child > 0 && (
                                                      <tr>
                                                        <td>Child</td>
                                                        <td>{flight?.lObaggage33 === "0Kg" ? "Not include" : flight?.lObaggage33}</td>
                                                        <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                      </tr>
                                                    )}
                                                    {flight?.infant > 0 && (
                                                      <tr>
                                                        <td>Infant</td>
                                                        <td>{flight?.lObaggage33 === "0Kg" ? "Not include" : flight?.lObaggage33}</td>
                                                        <td>{flight?.cbnBag === "0Kg" ? "Not include" : flight?.cbnBag}</td>
                                                      </tr>
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>)}
                              </div>
                            </div>
                            <div id={`fare-summary${index}`} className={`tab-content ${activeTabs2[index] === `fare-summary${index}` ? 'active' : ''}`}>
                              <div className="farecontainer">
                                <div className="fareheader">
                                  <h5 className="fw-bold">Fare Breakup</h5>
                                </div>
                                <div className="farerow">
                                  <div>Base Fare</div>
                                  <div>{getCurrencySymbol(flight?.currency)}
                                    {new Intl.NumberFormat('en-IN').format((Math.round(flight?.amount) - Math.round(flight?.taxamount))?.toFixed(2))} </div>
                                </div>
                                <div className="farerow">
                                  <div>Surcharges</div>
                                  <div>{getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.taxamount))}</div>
                                </div>
                                <div className="farerow total-row">
                                  <div>Total Fare </div>
                                  <div>{getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))}</div>
                                </div>
                              </div>
                            </div>
                            <div id={`cancellation${index}`} className={`tab-content ${activeTabs2[index] === `cancellation${index}` ? 'active' : ''}`}>
                              <div className="farecontainer">
                                <div className="fareheader">Cancellation Charges</div>
                                <div className="farerow">
                                  <div>O Hours - 4 Hours</div>
                                  <div>Adult : Non Refundable</div>
                                </div>
                                <div className="farerow">
                                  <div>4 Hours - 4 Days</div>
                                  <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649</div>
                                </div>
                                <div className="farerow">
                                  <div>4 Hours - 365 Days</div>
                                  <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649</div>
                                </div>
                              </div>
                              <p className="cancellationText1 mt-2 text-danger border p-2 rounded border-danger ">
                                *From the Time of Departure
                              </p>
                            </div>
                            <div id={`date-change${index}`} className={`tab-content ${activeTabs2[index] === `date-change${index}` ? 'active' : ''}`}>
                              <div className="farecontainer2">
                                <div className="fareheader">Date Change Charges</div>
                                <div className="farerow">
                                  <div>O Hours - 4 Hours</div>
                                  <div>Adult : Non Changeable</div>
                                </div>
                                <div className="farerow">
                                  <div>4 Hours - 4 Days</div>
                                  <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649 + Fare Difference</div>
                                </div>
                                <div className="farerow">
                                  <div>4 Hours - 365 Days</div>
                                  <div>Adult : {getCurrencySymbol(flight?.currency)}{new Intl.NumberFormat('en-IN').format(Math.round(flight?.amount))} + {getCurrencySymbol(flight?.currency)}649 + Fare Difference</div>
                                </div>
                              </div>
                              <p className="cancellationText mt-2 text-danger border p-2 rounded border-danger ">
                                *From the Time of Departure
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    ))
                  }
                </div>
              ) : (!loading &&
                <div className="not-found-container">
                  {/* <h1>testing3</h1> */}
                  <div className="airplane">
                    <img src="./assets/images/notfound.png" alt="" />
                  </div>
                  <h1>Flight Not Found</h1>
                  <p>We couldn't find the flight you were looking for. Please try again.</p>
                </div>
              )}
            </div>
          )}
          {/* ----------------------------Div for Multi trip ---------------------------------------------  */}
          <Modal
            isOpen={!!activePriceModal}
            onRequestClose={() => setActivePriceModal(null)}
            className="modalReactPrices"
            overlayClassName="modalOverlay"
            closeTimeoutMS={200}
          >
            <button
              className="close-modal"
              onClick={() => setActivePriceModal(null)}
            >
              ×
            </button>

            {pricingFlight && Object.keys(pricingFlight).length > 0 && (
              <div>
                {/* HEADER */}
                <div className="fare-header">
                  <div className="airline-info-modal">
                    <img src={`https://r-xx.bstatic.com/data/airlines_logo/${pricingFlight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.MarketingAirline.code}.png`}
                      alt={pricingFlight?.OutboundInboundlist?.[0]?.flightList?.[0]?.MarketingAirline.name} className="airline_infoImg" />
                    <span
                      className='metropolis-semibold'>{pricingFlight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.MarketingAirline?.name}
                    </span>
                    <div className='px-3 pricemodalDestination' style={{
                      borderRight: "2px solid #e6e6e6",
                      borderLeft: "2px solid #e6e6e6"
                    }}>
                      <span
                        className='metropolis-semibold'>{pricingFlight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure.city}</span>
                      <span>
                        <img src="/assets/images/planeImage.png" alt="" className='planePriceMobile' />
                      </span>
                      <span className="metropolis-semibold">
                        {
                          pricingFlight?.OutboundInboundlist?.[
                            pricingFlight?.OutboundInboundlist.length - 1
                          ]?.flightlist?.[
                            pricingFlight?.OutboundInboundlist[
                              pricingFlight?.OutboundInboundlist.length - 1
                            ]?.flightlist.length - 1
                          ]?.Arrival?.city
                        }
                      </span>
                    </div>

                  </div>
                  <div className="flight-details m-0">
                    <span>
                      {new Date(pricingFlight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure?.Date.split('-').reverse().join('-')).toLocaleDateString('en-US', {
                        weekday: 'short',
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      })} • Departure at {pricingFlight?.OutboundInboundlist?.[0]?.flightlist?.[0]?.Departure.time} -
                      Arrival at &nbsp;

                      {
                        pricingFlight?.OutboundInboundlist?.[
                          pricingFlight?.OutboundInboundlist.length - 1
                        ]?.flightlist?.[
                          pricingFlight?.OutboundInboundlist[
                            pricingFlight?.OutboundInboundlist.length - 1
                          ]?.flightlist.length - 1
                        ]?.Arrival?.time
                      }
                    </span>
                  </div>
                </div>

                {/* ===== SMOOTH SLIDER START ===== */}
                <div className="fare-options position-relative">
                  {pricingOption.length !== 0 && (
                    <>
                      {/* LEFT ARROW */}
                      {slideIndex > 0 && (
                        <button
                          className="slider-arrow left"
                          onClick={handlePrev}
                        >
                          ‹
                        </button>
                      )}

                      {/* SLIDER VIEWPORT */}
                      <div className="slider-viewport">
                        <div
                          className="slider-track"
                          style={{
                            "--slide-index": slideIndex,
                            "--visible-slides": VISIBLE_SLIDES,
                          }}
                        >
                          {pricingOption.map((fl, index) => (
                            <div
                              key={index}
                              className="fare-option slider-item"
                            >
                              <div className="farePriceDive">
                                <div className="price">
                                  <h5 className="metropolis-semibold m-0">
                                    {getCurrencySymbol(fl.currency_sign)}{' '}
                                    {new Intl.NumberFormat("en-IN").format(
                                      Math.round(fl?.amount)
                                    )}
                                  </h5  >
                                  <span
                                    style={{
                                      fontSize: "13px",
                                      color: "#6A6F70",
                                    }}
                                  >
                                    Starts from
                                  </span>
                                </div>
                                <div className="fare-type">
                                  <p> {fl?.farebasis?.split("|")?.[1]} </p>
                                </div>
                              </div>

                              <div className="details">
                                <h3 className="metropolis-semibold">
                                  Baggage
                                </h3>
                                <p>
                                  {fl?.baggageDetail === "0Kg"
                                    ? "Not include"
                                    : fl?.baggageDetail}
                                </p>

                                <div
                                  className="miniRulesFont"
                                  dangerouslySetInnerHTML={{
                                    __html: fl?.miniRule,
                                  }}
                                />
                              </div>

                              <button
                                className="pricingBookNowBTN"
                                onClick={() =>
                                  AddToCart(pricingFlight)
                                }
                              >
                                Book Now
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* RIGHT ARROW */}
                      {slideIndex + 3 < pricingOption.length && (
                        <button
                          className="slider-arrow right"
                          onClick={handleNext}
                        >
                          ›
                        </button>
                      )}
                    </>
                  )}
                </div>
                {/* ===== SMOOTH SLIDER END ===== */}
              </div>
            )}
          </Modal>

        </div>
      ) : (!loading &&
        <div className="not-found-container">
          <div className="airplane">
            <img src="./assets/images/notfound.png" alt="" />
          </div>
          <h1>Flight Not Found</h1>
          <p>We couldn't find the flight you were looking for. Please try again.</p>
        </div>
      )}
      <div>
        {isVisible && (
          <div onClick={scrollToTop} className="backToTop">
            <img src="./assets/images/up-arrow.png" alt="" />
          </div>
        )}
      </div>
      <div className="loaderbgContainer">
        {loading && (
          <>
            <div className="loader-container">
              <div className="loader-bar"></div>
            </div>
            <div className="loaderUpdated">
              <img src="./assets/images/loaderBlueBG.gif" alt="Loading" />
            </div>
          </>
        )}
        {upsellloading && (
          <>
            <div className="loaderbg"></div>

            <div className="loaderUpselling">
              <img src="./assets/images/Flight-price-loader.gif" alt="Loading" />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ListingPageComponent;
